/* eslint-disable no-loop-func */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect } from "react";
import UserActions from "../../store/user/Actions";
import { connect } from "react-redux";
import Images from "../../images";
import {
  findStrokes,
  convertToCommonFormat,
  convertToWebFormat,
  convertToCommonFormatExpand,
  convertToWebFormatExpand,
  translateStroke,
  translateStrokeToParent,
  findContainsExplicitStrokes,
  translateShapesToExpand,
} from "../../utils/SmartPaperUtils";
import "../App/App.scss";
import "./SmartPaperScreen.css";
import "../../css/bootstrap.css";
import PlayCircleRoundedIcon from "@mui/icons-material/PlayCircleRounded";
import PauseCircleFilledRoundedIcon from "@mui/icons-material/PauseCircleFilledRounded";
import SkipNextRoundedIcon from "@mui/icons-material/SkipNextRounded";
import CloseIcon from "@material-ui/icons/Close";
import {
  NOTHING_FOR_REPLAY,
  NAVIGATION_PAPER,
  LARGE_DESKTOP,
  RECORD_ONGOING,
  SMALL_DESKTOP,
  GET_ACTIVITY,
} from "../../constants";
import interact from "interactjs";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import NewComponent from "../../smartslidecomponents/NewComponent/NewComponent";
import H5PComponentTest from "../../smartslidecomponents/NewComponent/H5PComponentTest";
import { playAnimationSound } from "../../utils/AnimationSoundsUtils";
import {
  SmartPaperBaseScreen,
  AnswerExplanation,
  TeacherFeedback,
  SequenceAneme,
  KnovoHelp,
  WarningPopup,
  SuccessPopup,
  AiAssistanceBot,
} from "root-components";
import {
  getTimeSpent,
  getTimeSpentOverall,
  getSubmitDate,
} from "../../utils/TimerUtils";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";
import MicRoundedIcon from "@mui/icons-material/MicRounded";
import "../CommonItems/HamburgerMenuStyle.css";
import "../CommonItems/ComponentsStyles.css";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import StopCircleRoundedIcon from "@mui/icons-material/StopCircleRounded";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import KnovoActivityScreen from "../KnovoActivityScreen/KnovoActivityScreen";
import {
  CheckmarkFilled,
  TextUnderline,
  TextItalic,
  TextBold,
  TextAlignLeft,
  TextAlignCenter,
  TextAlignRight,
  Reset,
  TrashCan,
  TextColor,
  TextFill,
  CircleSolid,
  SquareFill,
  DirectionStraightRight,
  Maximize,
  Close,
  ArrowDown,
  ArrowUp,
} from "@carbon/icons-react";
import { Button } from "carbon-components-react";
import { SketchPicker } from "react-color";
import "../CommonItems/AiAssistance.css";

const MicRecorder = require("mic-recorder-to-mp3");
const recorder = new MicRecorder({
  bitRate: 128,
});

function SmartPaperScreen(props) {
  const canvasRef = useRef(null);
  const contextRef = useRef(null);
  const expandCanvasRef = useRef(null);
  const expandContextRef = useRef(null);
  const isDrawing = useRef(false);
  const [strokeArray, setStrokeArray] = useState([]);
  const [timer, setTimer] = useState(undefined);
  const [pointsArray, setpointsArray] = useState([]);
  const [expandPointsArray, setExpandPointsArray] = useState([]);
  const [expandStrokeArray, setExpandStrokeArray] = useState([]);
  const [currentActivity, setCurrentActivity] = useState({});
  const {
    isActive,
    tutorialStart,
    activitySaveClick,
    activitySaveType,
    isBgAudioPlayed,
    activityResetType,
    recordPopupClick,
    canvasAreaDimensions,
    displayWalkThrough,
    currentWalkThroughStep,
    isKnovoHelpOpen,
    minutes,
    seconds,
    minutesPractice,
    secondsPractice,
    confirmPopupVisible,
    muteClicked,
    muteStatus,
    activityDataFromParent,
  } = props; //values from parent activity screen
  const {
    getStudentWorkedDataFromChild,
    getStudentCurrentScore,
    getActivityResetStatus,
    getRecordAction,
    hardResetDone,
    getTutorTalking,
    knovoHelpClose,
    knovoActivityTourClick,
    onActivitySubmitClick,
    onWarningBotDialog,
    getRecordingStatus,
    getIsVideoPlaying,
    getIsContainedOpen,
    onHideHeader,
    getValidationFeedback,
    getActivityLoaded,
    getIsExpandableView,
    onGuidedCloseClick,
    handleGuidedActivity,
    saveMuteStatus,
  } = props; //values to parent activity screen
  const {
    setHeaderTitle,
    setShowHideLoader,
    saveActivityForStudent,
    setWorkJson,
    getContainedActivityForStudent,
    showOrHideToaster,
    hardResetRandomActivity,
    chatChallengeMe,
    refreshToken,
    userToken,
  } = props;
  const {
    loading,
    user,
    //  currentActivity,
    currentLessonUnitDistId,
    showToastModal,
    currentOSName,
    token,
  } = props; // from redux state
  const { isContained, setContainedWorkJson, containedWorkJson } = props; //for Contained
  const {
    ActivityJson,
    Completed,
    ContentID,
    InkJson,
    ActivityType,
    AppName,
    Feedback,
    FollowTheFlow,
    ContainedView,
    WorkJson,
    OtherActivities,
  } = currentActivity;
  const CANVAS_MODE = {
    PEN: "PEN",
    REPLAY: "REPLAY",
    RECORD: "RECORD",
    SELECT: "SELECT",
    LABEL: "LABEL",
  };
  const STROKE_WIDTH = {
    EXTRA_SMALL: 1.5,
    SMALL: 3,
    MEDIUM: 5,
    LARGE: 8,
    NONE: 0,
  };
  const REPLAY_SPEED = {
    TWOTIMES: 250,
    ONETIME: 500,
    HALFTIME: 1000,
  };
  const SHAPE_NAME = {
    PEN: "pen",
    LINE: "line",
    RECT: "rect",
    CIRCLE: "circle",
  };
  const ACTION_NAME = {
    DRAG: "drag",
    RESIZE: "resize",
    DELETE: "DELETE",
  };
  const STROKE_TYPE = {
    STROKE: "STROKE",
    SHAPE: "SHAPE",
  };
  const [currentSpeed, setcurrentSpeed] = useState(REPLAY_SPEED.ONETIME);

  const [editorStrokeData, setEditorStrokeData] = useState([]);
  const [strokeWidth, setStrokeWidth] = useState(STROKE_WIDTH.MEDIUM);
  const [strokeColor, setStrokeColor] = useState("#000000");
  const [currentMode, setCurrentMode] = useState(CANVAS_MODE.PEN);
  const [currentShape, setCurrentShape] = useState(SHAPE_NAME.PEN);
  const [currentAction, setCurrentAction] = useState(undefined);
  const [selectedStroke, setSelectedStroke] = useState(undefined);
  const [strokeActions, setStrokeActions] = useState([]);
  const [expandStrokeActions, setExpandStrokeActions] = useState([]);
  const [smartPaperData, setSmartPaperData] = useState({
    BackgroundImage: "",
    Strokes: [],
    StrokeActions: [],
    InputRows: [],
    ReplayRectangles: [],
    TotalScore: 0,
    EditorImageHeight: 0,
    EditorImageWidth: 0,
    ReplayRectanglesAudio: [],
    Opacity: "rgba(0,0,0,0)",
    TextToSpeech: [],
    Seconds: [],
    Back: false,
    Skip: false,
    Stop: false,
    ChatBotSettings: "",
  });

  const [replayRectangleData, setReplayRectangleData] = useState([]);
  const [canvasDimension, setCanvasDimension] = useState(undefined);
  const [attempts, setAttempts] = useState(0);
  const [controlsList, setControlsList] = useState([]);
  const [dimensionFactor, setDimensionFactor] = useState(undefined);
  const [rectangleCoordinatesArray, setRectangleCoordinatesArray] = useState(
    []
  );
  const [currentScore, setCurrentScore] = useState(0);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [replayRectangleObject, setReplayRectangleObject] = useState({});
  const [replayRect, setReplayRect] = useState(undefined);
  const [context, setContext] = useState(null);
  const [expandContext, setExpandContext] = useState(null);
  const [isReplayHappening, setIsReplayHappening] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [editorNonDeletable, seteditorNonDeletable] = useState(false);
  const [startTime, setstartTime] = useState("");
  const [resize, setResize] = useState(0);
  const rect = useRef();
  const expandRect = useRef();
  const imgRef = useRef();
  const IsReadonly = false;
  const isPractice = ActivityType === "practice" ? true : false;
  // TODO need to remove the below line.. this is purely for development purspose
  const [replayCount, setreplayCount] = useState(0);
  const [resetValue, setresetValue] = useState(0);
  const [attemptsPractice, setAttemptsPractice] = useState(0);
  const [totalResetPractice, setTotalResetPractice] = useState(0);

  const [currentScoreApi, setCurrentScoreApi] = useState(0);
  const [currentScoreReset, setCurrentScoreReset] = useState(0);

  const [cumulativeAverageScoreOld, setCumulativeAverageScoreOld] = useState(0);
  const [totalResetOld, setTotalResetOld] = useState(0);
  const [priorityActive, setPriorityActive] = useState(0);
  const [showHint, setShowHint] = useState(false);
  const [showNavToast, setShowNavToast] = useState(false);
  const [isResetClick, setIsResetClick] = useState(false);
  const [replayRectangleAudio, setReplayRectangleAudio] = useState(undefined);
  const [isAudioReplay, setIsAudioReplay] = useState(false);
  const [isInitialAudioPlay, setIsInitialAudioPlay] = useState(false);
  const [handleAudioTimeOut, setHandleAudioTimeOut] = useState(undefined);
  const [isPopupSlideVisible, setisPopupSlideVisible] = useState(false);
  const [isExpandableView, setIsExpandableView] = useState(false);
  const [activeExpandBox, setActiveExpandBox] = useState(undefined);
  const [activeReplayBox, setActiveReplayBox] = useState(undefined);
  const [expandImageCoordinates, setExpandImageCoordinates] =
    useState(undefined);
  const [initialExpand, setInitialExpand] = useState(false);
  const [expandReplayCount, setExpandReplayCount] = useState(0);
  const [success, setSuccess] = useState(false);
  const [validationVisible, setValidationVisible] = useState(false);
  const [isFloating, setIsFloating] = useState(false);
  const [isFloatingChild, setIsFloatingChild] = useState(false);
  const [isReset, setIsReset] = useState(false);
  const [putExpandCall, setPutExpandCall] = useState(false);
  //Introduction tts

  //Smart video and popup constants
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [videoResume, setVideoResume] = useState(false);
  const [allMarkerStatus, setAllMarkerStatus] = useState({});
  const [smartVideoStatus, setSmartVideoStatus] = useState({});
  const [externalPopupVisible, setExternalPopupVisible] = useState(false);
  const [textPopupVisible, setTextPopupVisible] = useState(false);
  const [containedDone, setContainedDone] = useState(false);
  const currentAppName = useRef();
  const currentVideoPlayer = useRef();
  const currentContainedID = useRef();
  const currentPopupValue = useRef();

  //Record audio constants
  const currentRecordedFile = useRef();
  const currentRecordedURL = useRef();
  const currentRecordedAudioPlayer = useRef();
  const [isRecording, setIsRecording] = useState(false);

  //Recording audio functionality
  const [recordseconds, setRecordSeconds] = useState(0);
  const [recordminutes, setRecordMinutes] = useState(0);
  const [isRecordSaveClick, setIsRecordSaveClick] = useState(false);
  const [isRecordDeleteClick, setIsRecordDeleteClick] = useState(false);
  const [isRecordPlaying, setIsRecordPlaying] = useState(false);
  const [currentRecordTime, setCurrentRecordTime] = useState(0);
  const [recordDuration, setRecordDuration] = useState(0);

  //Teacher audio
  const currentRecordedTeacherURL = useRef();
  const [isTeacherRecordPlaying, setIsTeacherRecordPlaying] = useState(false);
  const [audioStop, setAudioStop] = useState(false);

  // Hint
  const [hintMessage, setHintMessage] = useState("");
  const [explanationAvailable, setExplanationAvailable] = useState(false);

  const currentAudioPlayer = useRef();
  const currentAudioPlaying = useRef();

  const [initial, setInitial] = useState(true);
  const [shapesDataArray, setShapesDataArray] = useState([]);
  const [editorAllShapesData, setEditorAllShapesData] = useState([]);
  const [editorShapesReplayDataArray, setEditorShapesReplayDataArray] =
    useState([]);
  const [allShapesExpandDataArray, setAllShapesExpandDataArray] = useState([]);
  const currentScaleFactor = useRef();

  //Sequence text to speech values
  //Success and failure tts values
  const [failureCount, setFailureCount] = useState(0);
  const [successCount, setSuccessCount] = useState(0);
  const [failurePopupVisible, setFailurePopupVisible] = useState(false);
  const [failureExternalText, setFailureExternalText] = useState("");
  const [fullscreenPopupVisible, setFullscreenPopupVisible] = useState(false);

  const [reactResizeDetet, setReactResizeDetet] = useState(0);
  const [reactResizeBool, setReactResizeBool] = useState(false);

  // Check Answer
  const [currentDisplayMode, setcurrentDisplayMode] = useState("normal");
  const isVerifyMode = currentDisplayMode === "verify";

  // Answer Explanation
  const [explanationClick, setExplanationClick] = useState(false);
  const [explanationText, setExplanationText] = useState("");
  const [explanationStatus, setExplanationStatus] = useState(false);
  const [explanationVisible, setExplanationVisible] = useState(false);

  //Tutor variables
  const [ttsData, setTtsData] = useState([]);
  //const [tutorialStart, setTutorialStart] = useState(false);
  const [isSubtitle, setIsSubtitle] = useState(true);

  //Teacher feedback variables
  const [feedbackVisible, setFeedbackVisible] = useState(false);
  const [skipUnskipComponent, setSkipUnskipComponent] = useState({});

  //Sequence/succorfail/hint variable
  const [ttsMessageData, setTtsMessageData] = useState("");
  const [ttsPlayStart, setTtsPlayStart] = useState(false);
  const [ttsPlayType, setTtsPlayType] = useState("");
  const [feedbackType, setFeedbackType] = useState("");
  const [displayComponents, setDisplayComponents] = useState(false);
  const [displayControls, setDisplayControls] = useState(false);
  const [hideAnimation, setHideAnimation] = useState(false);
  const [botTalking, setBotTalking] = useState(false);
  const [isReplaySequence, setIsReplaySequence] = useState(false);
  const [displayReplayDonePopup, setDisplayReplayDonePopup] = useState(false);
  const [isReplaySequenceTimerStart, setIsReplaySequenceTimerStart] =
    useState(false);

  const [displayActivityCompletePopup, setDisplayActivityCompletePopup] =
    useState(false);

  const [isDelayRunning, setIsDelayRunning] = useState(false);

  const sequenceTimer = useRef();

  const SAVE_MODE = { SAVE: "SAVE", SUBMIT: "SUBMIT" };

  //Animations variables
  const [displayAnimatedCommonComponents, setDisplayAnimatedCommonComponents] =
    useState(false);

  //User label addition variables
  const [labelArrayList, setLabelArrayList] = useState([]);
  const [selectedLabel, setSelectedLabel] = useState(undefined);
  const [isDeleteClicked, setIsDeleteClicked] = useState(false);
  const [isClearClicked, setIsClearClicked] = useState(false);
  const [activeColor, setActiveColor] = useState("#000000");
  const [colorPickerType, setColorPickerType] = useState(undefined);
  const presetColors = [
    "#000000",
    "#FFFFFF",
    "#828282",
    "#6644FF",
    "#CD2D1A",
    "#FFC42D",
    "#41C54F",
    "#20A7D6",
  ];

  //AI chat bot variables added by Azar
  const [isAiChatBotVisible, setIsAiChatBotVisible] = useState(false);
  const [aiChatResponseData, setAiChatResponseData] = useState({});
  const [challengeResponse, setChallengeResponse] = useState({});
  const [isKnovoApiCall, setIsKnovoApiCall] = useState(false);
  const [isNeedClick, setIsNeedClick] = useState(false);

  //Readmore content variables
  const [readmoreUrl, setReadmoreUrl] = useState("");
  //Guided activity variables
  const [isGuidedActivity, setIsGuidedActivity] = useState(false);
  const [guidedData, setGuidedData] = useState(false);
  const [isGuidedClickEnable, setIsGuidedClickEnable] = useState(false);
  const [isGuidedClicked, setIsGuidedClicked] = useState(false);

  //Scroll functionalities variables
  const [currentPageNumber, setCurrentPageNumber] = useState(-1);
  const [isPageScrolled, setIsPageScrolled] = useState(false);

  //current page data variables
  const [isMultipage, setIsMultipage] = useState(false);
  const [allPagesData, setAllPagesData] = useState([]);
  const [isMultipageActive, setIsMultipageActive] = useState(false);
  const [isPageRefresh, setIsPageRefresh] = useState(false);
  const [overallActivityScore, setOverallActivityScore] = useState(0);
  const [isPageReopened, setIsPageReopened] = useState(true);
  const [isSamePage, setIsSamePage] = useState(true);
  const [isPageNavigated, setIsPageNavigated] = useState(false);
  const [isActivityNavigated, setIsActivityNavigated] = useState(false);
  const [highestPriorityValue, setHighestPriorityValue] = useState(0);

  const [saveUserErrorCount, setSaveUserErrorCount] = useState(0);
  const [selectedContentID, setSelectedContentID] = useState(0);

  //Handle browser back icon
  const onBackButtonEvent = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    const unloadCallback = (event) => {
      event.preventDefault();
      event.returnValue = "";
      return "";
    };

    window.addEventListener("beforeunload", unloadCallback);
    return () => window.removeEventListener("beforeunload", unloadCallback);
  }, []);

  const handleScroll = () => {
    const scrollPosition = window.scrollY; // => scroll position
    console.log(scrollPosition);
  };
  useEffect(() => {
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setDisplayAnimatedCommonComponents(true);
    }, 2000);
  }, []);

  useEffect(() => {
    if (isBgAudioPlayed) {
      setIsImageLoaded(false);
      setSmartPaperData({
        BackgroundImage: "",
        Strokes: [],
        StrokeActions: [],
        InputRows: [],
        ReplayRectangles: [],
        TotalScore: 0,
        EditorImageHeight: 0,
        EditorImageWidth: 0,
        ReplayRectanglesAudio: [],
        Opacity: "rgba(0,0,0,0)",
        TextToSpeech: [],
        Seconds: [],
        Back: false,
        Skip: false,
        Stop: false,
        ChatBotSettings: "",
      });
      setBotTalking(false);
      setPriorityActive(0);
      setHeaderTitle("Smart paper");
      setStrokeArray([]);
      setStrokeActions([]);
      setControlsList([]);
      setEditorStrokeData([]);
      setEditorAllShapesData([]);
      setExpandStrokeActions([]);
      setExpandStrokeArray([]);
      setLabelArrayList([]);
      setSelectedLabel(undefined);
      currentRecordedURL.current = undefined;
      currentRecordedFile.current = undefined;
      setRecordSeconds(0);
      setRecordMinutes(0);
      setcurrentDisplayMode("normal");
      setIsResetClick(false);
      setShowHideLoader(false);
      updateActivityDataFromParent();
    } else {
      setIsImageLoaded(false);
      setIsFloating(false);
      setCurrentMode(CANVAS_MODE.PEN);
      setDisplayComponents(false);
      setTtsPlayStart(false);
      setTtsMessageData("");
      setTtsPlayType("");
      setcurrentDisplayMode("normal");
      setIsResetClick(false);
      setCurrentPageNumber(-2);
    }
  }, [isBgAudioPlayed]);

  function updateActivityDataFromParent() {
    if (
      activityDataFromParent.OtherActivities &&
      activityDataFromParent.OtherActivities !== null &&
      activityDataFromParent.OtherActivities.length > 0
    ) {
      let otherActivityDataCopy = [...activityDataFromParent.OtherActivities];
      otherActivityDataCopy.map((obj, index) => {
        obj.Work = obj.WorkJson;
        obj.Ink = obj.InkJson;
        return obj;
      });
      setAllPagesData(otherActivityDataCopy);
      setTimeout(() => {
        setCurrentPageNumber(0);
      }, 1000);
    } else {
      //setActivitySmartPaperData();
      setCurrentPageNumber(0);
    }
  }

  function clearWhenPageChange() {
    setShowHideLoader(true);
    setPriorityActive(0);
    setStrokeArray([]);
    setStrokeActions([]);
    setControlsList([]);
    setEditorStrokeData([]);
    setEditorAllShapesData([]);
    setExpandStrokeActions([]);
    setExpandStrokeArray([]);
    setLabelArrayList([]);
    setSelectedLabel(undefined);
    currentRecordedURL.current = undefined;
    currentRecordedFile.current = undefined;
    setRecordSeconds(0);
    setRecordMinutes(0);
    setcurrentDisplayMode("normal");
    setIsResetClick(false);
    //setShowHideLoader(false);
  }

  useEffect(() => {
    if (isBgAudioPlayed) {
      if (currentPageNumber > -1) {
        knovoHelpClose();
        setDisplayComponents(false);
        clearWhenPageChange();
        setIsFloating(false);
        setIsFloatingChild(false);
        setCurrentMode(CANVAS_MODE.PEN);
        setCurrentShape(SHAPE_NAME.PEN);
        if (
          activityDataFromParent.OtherActivities &&
          activityDataFromParent.OtherActivities !== null &&
          activityDataFromParent.OtherActivities.length > 0
        ) {
          setTimeout(() => {
            setCurrentActivity(
              activityDataFromParent.OtherActivities[currentPageNumber]
            );
          }, 1000);
        } else {
          // setShowHideLoader(false);
          setCurrentActivity(activityDataFromParent);
        }
      } else if (currentPageNumber === -1) {
        if (OtherActivities && OtherActivities.length > 0) {
          // if (!isActivityNavigated) {
          setActivitySmartPaperData();
          // }
        } else {
          // if (!isActivityNavigated) {
          setCurrentActivity(activityDataFromParent);
          // }
        }
      }
    }
  }, [currentPageNumber]);

  useEffect(() => {
    if (currentPageNumber > -1) {
      setSmartPaperData({
        BackgroundImage: "",
        Strokes: [],
        StrokeActions: [],
        InputRows: [],
        ReplayRectangles: [],
        TotalScore: 0,
        EditorImageHeight: 0,
        EditorImageWidth: 0,
        ReplayRectanglesAudio: [],
        Opacity: "rgba(0,0,0,0)",
        TextToSpeech: [],
        Seconds: [],
        Back: false,
        Skip: false,
        Stop: false,
        ChatBotSettings: "",
      });
      setActivitySmartPaperData();
    }
  }, [currentActivity]);

  function setActivitySmartPaperData() {
    // clearCanvas();
    if (ActivityJson) {
      const exercise = JSON.parse(ActivityJson);
      let replayRectAudioArray = [];
      if (AppName === "SmartPaper") {
        exercise.ReplayRectangles.map((replayRectData, index) => {
          if (replayRectData.AudioUrl && replayRectData.AudioUrl !== "") {
            let audio = new Audio(replayRectData.AudioUrl);
            replayRectAudioArray.push(audio);
          } else {
            replayRectAudioArray.push(undefined);
          }
        });
        if (smartPaperData.ReplayRectanglesAudio) {
          smartPaperData.ReplayRectanglesAudio.map((audio) => {
            if (audio) {
              audio.load();
            }
          });
        }
      }
      setSmartPaperData({
        BackgroundImage: exercise.BackgroundImage,
        InputRows: exercise.InputRows,
        ReplayRectangles: exercise.ReplayRectangles,
        StrokeActions: exercise.StrokeActions,
        Strokes: exercise.Strokes,
        TotalScore: exercise.TotalScore,
        EditorImageWidth: exercise.EditorImageWidth,
        EditorImageHeight: exercise.EditorImageHeight,
        ReplayRectanglesAudio: replayRectAudioArray,
        Opacity: exercise.Opacity,
        TextToSpeech: exercise.TextToSpeech,
        Seconds: exercise.Seconds,
        Back: exercise.Back,
        Skip: exercise.Skip,
        Stop: exercise.Stop,
        ChatBotSettings: exercise.ChatBotSettings
          ? exercise.ChatBotSettings
          : "",
      });

      if (ContainedView && ContainedView.length > 0) {
        setContainedDone(true);
      } else {
        setContainedDone(false);
      }
    }
  }

  //set work json data once tutor message finished
  useEffect(() => {
    if (smartPaperData.BackgroundImage !== "") {
      if (FollowTheFlow) {
        let findHighestPriorityArray = smartPaperData.InputRows.concat(
          smartPaperData.ReplayRectangles
        );
        if (findHighestPriorityArray.length > 0) {
          const highestPriorityValue = Math.max(
            ...findHighestPriorityArray.map((component) => component.Priority),
            0
          );
          setHighestPriorityValue(highestPriorityValue);
        } else {
          setHighestPriorityValue(1);
        }
      } else {
        setHighestPriorityValue(1);
      }
      if (!isResetClick) {
        if (isMultipage) {
          setTimeout(() => {
            showNoteToast();
          }, 1000);
        } else {
          showNoteToast();
        }
      } else if (isResetClick) {
        if (isMultipage) {
          setTimeout(() => {
            showNoteToast();
          }, 1000);
        }
      }
    }
  }, [smartPaperData]);

  function showNoteToast() {
    let skipComponentArray = {};
    let isCorrect = false;
    let inputRows = smartPaperData.InputRows;
    if (inputRows) {
      //Check guided activity present or not
      let indexOfPaper = inputRows.findIndex(
        (obj) =>
          obj.PluginId === "PopupSlide" &&
          obj.MarkData.MarkerType === "guidedActivity"
      );
      if (indexOfPaper !== -1) {
        setIsGuidedActivity(true);
        setGuidedData(inputRows[indexOfPaper].MarkData);
      } else {
        setIsGuidedActivity(false);
        setGuidedData("");
      }
      if (inputRows && inputRows.length > 0) {
        for (const key in inputRows) {
          if (Object.prototype.hasOwnProperty.call(inputRows, key)) {
            //check skip or not
            if (
              inputRows[key].PluginId == "TextArea" ||
              inputRows[key].PluginId == "TextInk" ||
              inputRows[key].PluginId == "HotspotImages" ||
              inputRows[key].PluginId == "EnrichedPDF" ||
              inputRows[key].PluginId == "Visor3D" ||
              inputRows[key].PluginId == "Webpage"
            ) {
              skipComponentArray[inputRows[key].Priority] = true;
            } else {
              if (inputRows[key].PluginId == "RichText") {
                if (inputRows[key].Editable) {
                  skipComponentArray[inputRows[key].Priority] = false;
                } else {
                  skipComponentArray[inputRows[key].Priority] = true;
                }
              } else if (inputRows[key].PluginId == "PopupSlide") {
                if (inputRows[key].MarkData.MarkerType === "guidedActivity") {
                  skipComponentArray[inputRows[key].Priority] = true;
                } else {
                  skipComponentArray[inputRows[key].Priority] = false;
                }
              } else {
                skipComponentArray[inputRows[key].Priority] = false;
              }
            }
          }
        }

        setSkipUnskipComponent(skipComponentArray);
        for (const key in inputRows) {
          if (Object.prototype.hasOwnProperty.call(inputRows, key)) {
            if (
              inputRows[key].PluginId == "PopupSlide" ||
              inputRows[key].PluginId == "TextArea" ||
              inputRows[key].PluginId == "TextInk" ||
              inputRows[key].PluginId == "HotspotImages" ||
              inputRows[key].PluginId == "EnrichedPlayer" ||
              inputRows[key].PluginId == "EnrichedAudio" ||
              inputRows[key].PluginId == "EnrichedPDF" ||
              inputRows[key].PluginId == "Visor3D" ||
              inputRows[key].PluginId == "Webpage"
            ) {
              setExplanationAvailable(false);
            } else {
              setExplanationAvailable(true);
              break;
            }
          }
        }
        setTimeout(() => {
          setWorkJsonData();
        }, 1000);
      } else {
        setTimeout(() => {
          setWorkJsonData();
        }, 1000);
      }
    } else {
      setTimeout(() => {
        setWorkJsonData();
      }, 1000);
    }
  }

  useEffect(() => {
    if (showNavToast) {
      showOrHideToaster(true, NAVIGATION_PAPER, "success");
    }
  }, [showNavToast]);

  function setCommonDataWhenReopen(workJson) {
    setCurrentScore(workJson.Score);
    setCurrentScoreReset(workJson.ResetScore ? workJson.ResetScore : 0);
    setCumulativeAverageScoreOld(
      workJson.CumulativeAverageScoreOld
        ? workJson.CumulativeAverageScoreOld
        : 0
    );
    setAttempts(workJson.AttemptsOverall ? workJson.AttemptsOverall : 0);
    setAttemptsPractice(workJson.Attempts ? workJson.Attempts : 0);
    setTotalResetPractice(
      workJson.TotalResetPractice ? workJson.TotalResetPractice : 0
    );

    setTotalResetOld(workJson.TotalResetOld ? workJson.TotalResetOld : 0);
    setSmartVideoStatus(
      workJson.AllMarkerStatus ? workJson.AllMarkerStatus : {}
    );
    setLabelArrayList(workJson.StudentLabels ? workJson.StudentLabels : []);
    if (workJson.RecordedUrl) {
      currentRecordedURL.current = workJson.RecordedUrl;
    }
    if (workJson.TeacherRecordAudio) {
      currentRecordedTeacherURL.current = workJson.TeacherRecordAudio;
    }
    if (workJson.ExpandInkJson) {
      if (workJson.ExpandInkJson.expandStrokeArray) {
        const convertedStrokeArray = convertToWebFormatExpand(
          workJson.ExpandInkJson.expandStrokeArray,
          {
            width: document.body.clientWidth,
            height: document.body.clientHeight,
          }
        );
        setExpandStrokeArray(convertedStrokeArray);
      } else {
        setExpandStrokeArray([]);
      }
      setExpandStrokeActions(
        workJson.ExpandInkJson.expandStrokeActions
          ? workJson.ExpandInkJson.expandStrokeActions
          : []
      );
    }
  }

  function setPriorityWhenReopen(workJson, isMultipageCopy) {
    if (Completed === 0 && isActive) {
      smartPaperData.InputRows.map((box, index) => {
        if (workJson.priorityCount && workJson.priorityCount === box.Priority) {
          setHintMessage(box.SequenceHint);
        }
      });
      if (isMultipageCopy) {
        setShowHideLoader(false);
        setPriorityActive(workJson.priorityCount ? workJson.priorityCount : 1);
      } else {
        let selectedObject = {};
        for (let index = workJson.priorityCount; index >= 1; index--) {
          let filteredData = smartPaperData.InputRows.filter(
            (e) => e.Priority === index
          );
          if (filteredData.length > 0) {
            let box = filteredData[0];
            if (
              box.PluginId === "AGInput" ||
              box.PluginId === "AGTextList" ||
              box.PluginId === "AGInkList" ||
              box.PluginName === "SSMultipleChoice" ||
              box.PluginName === "SSMultipleAnswer" ||
              box.PluginName === "SSTrueFalse" ||
              box.PluginName === "SSRotatingDial" ||
              box.PluginName === "SSFillinTheBlanks" ||
              box.PluginName === "SPHotspot" ||
              box.PluginId === "MatchTable" ||
              box.PluginId === "Fraction" ||
              box.PluginId === "EquationEditor"
            ) {
            } else {
              if (
                box.SpeechData &&
                box.SpeechData[0] &&
                box.SpeechData[0] !== ""
              ) {
                selectedObject = box;
                break;
              } else if (box === 1) {
                selectedObject = box;
                break;
              }
            }
          }
        }
        if (selectedObject.Priority) {
          setShowHideLoader(false);
          setPriorityActive(selectedObject.Priority);
        } else {
          setShowHideLoader(false);
          setPriorityActive(
            workJson.priorityCount ? workJson.priorityCount : 1
          );
        }
      }
    } else {
      setShowHideLoader(false);
      setPriorityActive(50);
      setHintMessage("");
    }
  }

  //Poppulate work json data to activity
  function setWorkJsonData() {
    if (smartPaperData.BackgroundImage !== "") {
      let activityWorkJson = {};
      let isMultipageCopy = false;
      if (
        activityDataFromParent.OtherActivities &&
        activityDataFromParent.OtherActivities !== null &&
        activityDataFromParent.OtherActivities.length > 0
      ) {
        isMultipageCopy = true;
        setIsMultipage(true);
        activityWorkJson = getWorkJson();
      } else {
        isMultipageCopy = false;
        setIsMultipage(false);
        activityWorkJson = WorkJson;
      }
      setReplayRectangleWhenReopen();
      let condition =
        activityWorkJson !== "" &&
        JSON.parse(activityWorkJson).filter(
          (e) => e.ContentID === ContentID && e.ModeName === "Paper"
        ).length > 0;
      if (condition) {
        let indexOfPaper = JSON.parse(activityWorkJson).findIndex(
          (obj) => obj.ContentID === ContentID && obj.ModeName === "Paper"
        );
        const workJson = JSON.parse(activityWorkJson)[indexOfPaper];
        setCommonDataWhenReopen(workJson);

        if (workJson.listControls.length > 0) {
          setControlsList(workJson.listControls);
        } else {
          if (isBgAudioPlayed) {
            if (!isSamePage) {
              setIsSamePage(true);
            } else {
              setShowHideLoader(false);
              setDisplayComponents(true);
              setTimeout(() => {
                setDisplayControls(true);
                setInitial(true);
              }, 1000);
            }
          }
        }

        setPriorityWhenReopen(workJson, isMultipageCopy);

        if (isMultipageCopy && isMultipageActive) {
          setIsPageRefresh(true);
          setTimeout(() => {
            setIsPageRefresh(false);
            // getEditorStrokesAndShapes();
          }, 1000);
        }
      } else {
        if (isBgAudioPlayed) {
          // setShowHideLoader(false);
          setDisplayComponents(true);
          setTimeout(() => {
            setDisplayControls(true);
            setInitial(true);
          }, 1000);
        }
        if (isMultipageCopy && isMultipageActive) {
          if (!isPageReopened) {
            setShowHideLoader(false);
          }
          setIsPageRefresh(true);
          setTimeout(() => {
            setIsPageRefresh(false);
            //getEditorStrokesAndShapes();
          }, 1000);
        }
        if (Completed === 0 && isActive) {
          setShowHideLoader(false);
          setPriorityActive(1);
        } else {
          setShowHideLoader(false);
          setPriorityActive(50);
        }
      }
    }
  }

  //Find valid work json
  function getWorkJson() {
    let activityWorkJson = {};
    if (currentPageNumber > -1) {
      if (activityDataFromParent.OtherActivities[currentPageNumber]) {
        if (allPagesData[currentPageNumber]) {
          let allPagesDataJson = allPagesData[currentPageNumber];
          if (allPagesDataJson.WorkJson) {
            activityWorkJson = allPagesDataJson.WorkJson;
          } else {
            activityWorkJson = WorkJson;
          }
        } else {
          activityWorkJson = WorkJson;
        }
      } else {
        activityWorkJson = WorkJson;
      }
    } else {
      activityWorkJson = WorkJson;
    }
    return activityWorkJson;
  }

  function setReplayRectangleWhenReopen() {
    setReplayRectangleData(smartPaperData.ReplayRectangles);
    let rectCoordinates = [];
    smartPaperData.ReplayRectangles &&
      smartPaperData.ReplayRectangles.map((rectangle, index) => {
        const { XAxis, YAxis, Width, Height } = rectangle;
        let coordinates = [
          parseFloat(XAxis.split("%")[0]), //tl
          parseFloat(YAxis.split("%")[0]), //tl
          parseFloat(XAxis.split("%")[0]) + parseFloat(Width), //br
          parseFloat(YAxis.split("%")[0]) + parseFloat(Height), //br
        ];
        rectCoordinates.push(coordinates);
      });
    setRectangleCoordinatesArray(rectCoordinates);
  }

  //Pass initial value to child
  useEffect(() => {
    if (initial && !FollowTheFlow) {
      setTimeout(() => {
        setInitial(false);
      }, 2000);
    }
  }, [initial]);

  //save studentDataCall
  useEffect(() => {
    if (activitySaveClick) {
      getStudentWork(false);
    }
  }, [activitySaveClick]);

  //save studentDataCall
  useEffect(() => {
    getRecordingStatus(isRecording);
  }, [isRecording]);

  useEffect(() => {
    getIsVideoPlaying(isVideoPlaying);
  }, [isVideoPlaying]);
  useEffect(() => {
    getIsExpandableView(isExpandableView);
  }, [isExpandableView]);

  useEffect(() => {
    getIsContainedOpen(isPopupSlideVisible);
  }, [isPopupSlideVisible]);

  function callWhenGetStudentWork(isPageCall) {
    window.speechSynthesis.cancel();
    if (sequenceTimer.current) {
      clearTimeout(sequenceTimer.current);
    }
    setAudioStop(true);
    if (isPageCall) {
      setShowHideLoader(true);
    }
    setHintMessage("");
    if (isRecordPlaying) {
      currentRecordedAudioPlayer.current.pause();
      setIsRecordPlaying(false);
      setTimeout(() => {
        setCurrentRecordTime(0);
      }, 700);
    }
    if (replayRectangleAudio) {
      replayRectangleAudio.pause();
      replayRectangleAudio.currentTime = 0;
      setReplayRectangleAudio(undefined);
      setIsAudioReplay(false);
      setIsInitialAudioPlay(false);
      clearTimeout(handleAudioTimeOut);
    }
  }

  function getStudentWork(isRecord, isPageCall) {
    callWhenGetStudentWork(isPageCall);
    let workData = {};
    let expandInkData = {
      expandStrokeArray: convertToCommonFormatExpand(expandStrokeArray, {
        width: document.body.clientWidth,
        height: document.body.clientHeight,
      }),
      expandStrokeActions: expandStrokeActions,
    };
    if (IsReadonly) {
      workData = {
        ContentID: ContentID,
        ModeName: "Paper",
        TimeTaken: minutes + ":" + seconds,
      };
    } else {
      //Attempts-current
      //AttemptsPractice-cumulative
      workData = {
        ContentID: ContentID,
        ModeName: "Paper",
        Score: currentScore,
        TimeTaken: minutesPractice + ":" + secondsPractice,
        Attempts: attemptsPractice,
        listControls: controlsList,
        TotalScore: isPractice ? currentScoreApi : currentScore,
        TimeTakenOverall: minutes + ":" + seconds,
        AttemptsOverall: attempts,
        TotalResetPractice: totalResetPractice,
        ResetScore: currentScoreReset,
        CumulativeAverageScoreOld: cumulativeAverageScoreOld,
        TotalResetOld: totalResetOld,
        priorityCount: priorityActive,
        ExpandInkJson: expandInkData,
        AllMarkerStatus: smartVideoStatus,
        RecordedUrl: currentRecordedURL.current,
        TeacherRecordAudio: currentRecordedTeacherURL.current,
        Platform: "Web",
        StudentLabels: labelArrayList,
      };
    }

    let inkData = {
      strokeArray: convertToCommonFormat(strokeArray, {
        width: canvasDimension ? canvasDimension.width : 0,
        height: canvasDimension ? canvasDimension.height : 0,
      }),
      strokeActions: strokeActions,
      replayRectangleObject: replayRectangleObject,
    };
    const completed = activitySaveType === SAVE_MODE.SAVE ? 0 : 1;
    const resetData = activitySaveType === SAVE_MODE.SAVE ? resetValue : 0;

    if (isPageCall) {
      let studentActivityData = saveCurrentPageDataInLocal(
        completed,
        workData,
        inkData,
        resetData
      );
      handlePageData(studentActivityData);
    } else {
      let allPagesDataCopy = [];
      if (allPagesData.length > 0) {
        let currentPageStudentActivityData = saveCurrentPageDataInLocal(
          completed,
          workData,
          inkData,
          resetData
        );
        allPagesDataCopy = [...allPagesData];
        allPagesDataCopy[currentPageNumber] = currentPageStudentActivityData;
      }

      let workDataToApi = {};
      let inkDataToApi = {};
      if (allPagesDataCopy.length > 0) {
        workDataToApi = allPagesDataCopy[0].WorkJson;
        inkDataToApi = allPagesDataCopy[0].InkJson;
      } else {
        workDataToApi = JSON.stringify([workData]);
        inkDataToApi = JSON.stringify(inkData);
      }
      let studentActivityData = JSON.stringify({
        LessonUnitDistID: currentLessonUnitDistId,
        StudentID: user.LoginID,
        DomainID: user.DomainID,
        ContentID: activityDataFromParent.ContentID,
        Completed: completed,
        TotalPoints: !isPractice ? currentScore : scoreForPractice(),
        Attempts: attemptsPractice,
        Work: workDataToApi,
        Ink: inkDataToApi,
        SpentTime: getTimeSpent(minutesPractice, secondsPractice, false),
        Reset: resetData,
        SubmitDate: getSubmitDate(),
        CumulativeAttempts: attempts,
        CumulativeTimeTaken: getTimeSpentOverall(minutes, seconds, false),
        CumulativeAverage: calculateAverage(),
        TotalTries: totalResetPractice + 1,
        OtherActivity: allPagesDataCopy,
      });
      // if (completed === 0) {
      //   setIsSamePage(false);
      // }
      setIsActivityNavigated(true);
      console.log("studentActivityData", studentActivityData);
      getStudentWorkedDataFromChild(studentActivityData, isRecord);
    }
  }

  function saveCurrentPageDataInLocal(completed, workData, inkData, resetData) {
    let studentActivityData = {
      ContentID: ContentID,
      Attempts: attemptsPractice,
      Work: JSON.stringify([workData]),
      Ink: JSON.stringify(inkData),
      Reset: resetData,
      TotalTries: totalResetPractice + 1,
      WorkJson: JSON.stringify([workData]),
      InkJson: JSON.stringify(inkData),
    };
    return studentActivityData;
  }

  useEffect(() => {
    if (
      activityDataFromParent.OtherActivities &&
      activityDataFromParent.OtherActivities !== null &&
      activityDataFromParent.OtherActivities.length > 0
    ) {
      if (displayComponents) {
        trackStudentData();
      }
    }
  }, [currentScore, displayComponents]);

  useEffect(() => {
    if (allPagesData.length > 0) {
      let overallActivityScoreCopy = 0;

      allPagesData.map((pageData, pageIndex) => {
        if (
          pageData.WorkJson !== "" &&
          JSON.parse(pageData.WorkJson).length > 0
        ) {
          const workJson = JSON.parse(pageData.WorkJson)[0];
          overallActivityScoreCopy = overallActivityScoreCopy + workJson.Score;
        }
      });
      setOverallActivityScore(overallActivityScoreCopy);
    }
  }, [allPagesData]);

  //Track student data when score is updated
  function trackStudentData() {
    let workData = {};
    let expandInkData = {
      expandStrokeArray: convertToCommonFormatExpand(expandStrokeArray, {
        width: document.body.clientWidth,
        height: document.body.clientHeight,
      }),
      expandStrokeActions: expandStrokeActions,
    };
    workData = {
      ContentID: ContentID,
      ModeName: "Paper",
      Score: currentScore,
      TimeTaken: minutesPractice + ":" + secondsPractice,
      Attempts: attemptsPractice,
      listControls: controlsList,
      TotalScore: isPractice ? currentScoreApi : currentScore,
      TimeTakenOverall: minutes + ":" + seconds,
      AttemptsOverall: attempts,
      TotalResetPractice: totalResetPractice,
      ResetScore: currentScoreReset,
      CumulativeAverageScoreOld: cumulativeAverageScoreOld,
      TotalResetOld: totalResetOld,
      priorityCount: priorityActive,
      ExpandInkJson: expandInkData,
      AllMarkerStatus: smartVideoStatus,
      RecordedUrl: currentRecordedURL.current,
      TeacherRecordAudio: currentRecordedTeacherURL.current,
      Platform: "Web",
      StudentLabels: labelArrayList,
    };
    let inkData = {};
    if (Object.keys(allPagesData[currentPageNumber].InkJson).length > 0) {
      inkData = JSON.parse(allPagesData[currentPageNumber].InkJson);
    }
    const completed = 0;
    const resetData = 0;
    let studentActivityData = saveCurrentPageDataInLocal(
      completed,
      workData,
      inkData,
      resetData
    );
    handlePageData(studentActivityData);
  }
  //save current page data
  function handlePageData(studentActivityData) {
    let allPagesDataCopy = [...allPagesData];
    allPagesDataCopy[currentPageNumber] = studentActivityData;
    setAllPagesData(allPagesDataCopy);
  }

  //Call when background image is loaded
  useEffect(() => {
    if (imgRef && isImageLoaded) {
      var myImg = document.querySelector("#sky" + ContentID);
      var imageRealWidth = myImg.naturalWidth;
      var imageRealHeight = myImg.naturalHeight;
      var ansContWidth = canvasAreaDimensions.width;
      var ansContHeight = canvasAreaDimensions.height;
      let xFactor = 0;
      let yFactor = 0;
      if (
        imageRealWidth > imageRealHeight &&
        (imageRealHeight * ansContWidth) / imageRealWidth <= ansContHeight
      ) {
        setCanvasDimension({
          width: ansContWidth,
          height: (imageRealHeight * ansContWidth) / imageRealWidth,
        });
        xFactor = ansContWidth / smartPaperData.EditorImageWidth;
        yFactor =
          (imageRealHeight * ansContWidth) /
          imageRealWidth /
          smartPaperData.EditorImageHeight;
      } else {
        setCanvasDimension({
          width: (ansContHeight * imageRealWidth) / imageRealHeight,
          height: ansContHeight,
        });
        xFactor =
          (ansContHeight * imageRealWidth) /
          imageRealHeight /
          smartPaperData.EditorImageWidth;
        yFactor = ansContHeight / smartPaperData.EditorImageHeight;
      }
      setDimensionFactor({
        xFactor: xFactor,
        yFactor: yFactor,
      });
      getActivityLoaded(false);
    }
  }, [imgRef, isImageLoaded, canvasAreaDimensions]);

  //Set height and width for canvas
  useEffect(() => {
    if (
      canvasDimension &&
      displayComponents &&
      canvasRef.current &&
      canvasRef.current !== null
    ) {
      const canvas = canvasRef.current;
      canvas.width = canvasDimension.width;
      canvas.height = canvasDimension.height;
      canvas.style.width = `${canvasDimension.width}px`;
      canvas.style.height = `${canvasDimension.height}px`;
      setContext(canvas.getContext("2d"));
    }
  }, [canvasDimension, displayComponents, canvasRef]);

  //Set canvas sttroke properties
  useEffect(() => {
    if (context) {
      context.lineCap = "round";
      context.strokeStyle = strokeColor;
      context.lineWidth = strokeWidth;
      contextRef.current = context;
    }
  }, [context, strokeColor, strokeWidth]);

  //calculate bg image width and height
  useEffect(() => {
    if (dimensionFactor && canvasDimension && displayComponents) {
      // if (isImageLoaded) {
      setEditorStrokeData(
        findStrokes(smartPaperData.Strokes, dimensionFactor, {
          width: canvasDimension.width,
          height: canvasDimension.height,
        })
      );
      let smartPaperDataCopy = { ...smartPaperData };
      const svgObjs = smartPaperDataCopy.Strokes.filter((o) =>
        ["circle", "rect", "line"].includes(o.ShapeType)
      ).map((shape) => {
        shape.ShapeHeight = shape.ShapeHeight * dimensionFactor.yFactor;
        shape.ShapeWidth = shape.ShapeWidth * dimensionFactor.xFactor;
        shape.ShapeTop = shape.ShapeTop * dimensionFactor.yFactor;
        shape.ShapeLeft = shape.ShapeLeft * dimensionFactor.xFactor;
        return shape;
      });
      setEditorAllShapesData(svgObjs);
      const teacherActions = smartPaperData.StrokeActions;
      let teacherShapes = [];
      if (teacherActions.length > 0) {
        teacherActions.forEach(({ StrokeID, Action }) => {
          if (Action === "add") {
            const currentTeacherStrokeIndex = svgObjs.findIndex(
              (x) => parseInt(x.ID) === parseInt(StrokeID)
            );
            if (currentTeacherStrokeIndex >= 0) {
              teacherShapes.push(svgObjs[currentTeacherStrokeIndex]);
            }
          } else {
            teacherShapes = teacherShapes.filter(
              (obj) => parseInt(obj.ID) !== parseInt(StrokeID)
            );
          }
        });
      }
      setShapesDataArray(teacherShapes);
    }
  }, [dimensionFactor, displayComponents]);

  //for calculating the score
  useEffect(() => {
    if (controlsList && controlsList.length > 0) {
      let score = 0;
      controlsList.forEach((control) => {
        const item = smartPaperData.InputRows.find(
          (row) => row.ControlID === control.CtlId
        );
        if (item && item.PluginId) {
          if (item.PluginId === "AGTextList" || item.PluginId === "AGInkList") {
            if (parseFloat(control.CtlValue.Value) > 0) {
              score += parseFloat(control.CtlValue.Value);
            }
          } else if (
            item.PluginId === "MatchTable" ||
            item.PluginId === "Fraction" ||
            item.PluginId === "EquationEditor" ||
            item.PluginId === "H5P"
          ) {
            score += control.CtlScore;
          } else if (
            item.PluginId === "PopupSlide" ||
            item.PluginId === "RichText"
          ) {
            //score += parseFloat(control.CtlValue.Score);
          } else {
            if (item.Type === "range") {
              if (item.CorrectAnswer === control.CtlValue.Answer) {
                score += item.Weight;
              } else if (
                parseFloat(control.CtlValue.Answer) >= item.MinValue &&
                parseFloat(control.CtlValue.Answer) <= item.MaxValue
              ) {
                score += item.Weight;
              } else {
              }
            } else {
              if (!item.CaseSensitive) {
                if (item.CorrectAnswer === control.CtlValue.Answer) {
                  score += item.Weight;
                }
              } else {
                if (
                  item.CorrectAnswer.toLowerCase() ===
                  control.CtlValue.Answer.toLowerCase()
                ) {
                  score += item.Weight;
                }
              }
            }
          }
        } else {
          score += control.CtlScore;
        }
      });
      setCurrentScore(score);
      let modifyCurrentScore = scoreForPractice();
      setCurrentScoreApi(currentScoreReset + modifyCurrentScore);

      if (isBgAudioPlayed) {
        if (!isSamePage) {
          setIsSamePage(true);
        } else {
          setShowHideLoader(false);
          setDisplayComponents(true);
          setTimeout(() => {
            setDisplayControls(true);
            setInitial(true);
          }, 1000);
        }
      }
    } else {
      setCurrentScore(0);
      setCurrentScoreApi(currentScoreReset);
    }
  }, [controlsList]);

  useEffect(() => {
    if (
      activityDataFromParent.OtherActivities &&
      activityDataFromParent.OtherActivities !== null &&
      activityDataFromParent.OtherActivities.length > 0
    ) {
      getStudentCurrentScore(overallActivityScore);
    } else {
      getStudentCurrentScore(currentScore);
    }
  }, [currentScore, currentScoreApi, overallActivityScore]);

  //Populate editor strokes and shapes
  useEffect(() => {
    if (context && displayComponents) {
      getEditorStrokesAndShapes();
    }
  }, [
    contextRef.current,
    context,
    resize,
    rectangleCoordinatesArray,
    displayComponents,
  ]);

  useEffect(() => {
    if (context) {
      if (activitySaveType === SAVE_MODE.SAVE) {
        if (!activitySaveClick || displayComponents) {
          clearCanvas();
        }
        if (activitySaveClick) {
          getEditorStrokesAndShapes();
        }
      }
    }
  }, [activitySaveClick]);

  //Populate editor strokes and shapes
  function getEditorStrokesAndShapes() {
    addAllPathsForTeacher(editorStrokeData);
    let InkJsonCopy = "";
    if (
      activityDataFromParent.OtherActivities &&
      activityDataFromParent.OtherActivities !== null &&
      activityDataFromParent.OtherActivities.length > 0
    ) {
      if (currentPageNumber > -1) {
        if (activityDataFromParent.OtherActivities[currentPageNumber]) {
          if (allPagesData[currentPageNumber]) {
            let allPagesDataJson = allPagesData[currentPageNumber];
            if (allPagesDataJson.InkJson) {
              InkJsonCopy = allPagesDataJson.InkJson;
            } else {
              InkJsonCopy = InkJson;
            }
          } else {
            InkJsonCopy = InkJson;
          }
        } else {
          InkJsonCopy = InkJson;
        }
      } else {
        InkJsonCopy = InkJson;
      }
    } else {
      InkJsonCopy = InkJson;
    }
    if (
      InkJsonCopy === "" ||
      Object.keys(JSON.parse(InkJsonCopy)).length === 0
    ) {
      let replayRectangleObjectCopy = {};
      editorStrokeData.forEach((stroke) => {
        const rect = rectangleCoordinatesArray.filter((coordinates) =>
          isInRectangle(coordinates, {
            x: (stroke.points[0].x / canvasDimension.width) * 100,
            y: (stroke.points[0].y / canvasDimension.height) * 100,
          })
        );
        for (let i = 0; i < rect.length; i++) {
          const rectangle = rect[i];
          const rectIndex = rectangleCoordinatesArray.indexOf(rectangle);
          if (rectIndex >= 0) {
            if (replayRectangleObjectCopy[rectIndex]) {
              replayRectangleObjectCopy[rectIndex].push(stroke.id);
            } else {
              replayRectangleObjectCopy[rectIndex] = [stroke.id];
            }
            setReplayRectangleObject(replayRectangleObjectCopy);
          }
        }
      });
      //Editor shapes Data
      editorAllShapesData.forEach((stroke) => {
        const rectObjects = rectangleCoordinatesArray.filter((coordinates) =>
          isInRectangle(coordinates, {
            x: (stroke.ShapeLeft / canvasDimension.width) * 100,
            y: (stroke.ShapeTop / canvasDimension.height) * 100,
          })
        );
        for (let i = 0; i < rectObjects.length; i++) {
          const rectangle = rectObjects[i];
          const rectIndex = rectangleCoordinatesArray.indexOf(rectangle);
          if (rectIndex >= 0) {
            if (replayRectangleObjectCopy[rectIndex]) {
              replayRectangleObjectCopy[rectIndex].push(stroke.ID);
            } else {
              replayRectangleObjectCopy[rectIndex] = [stroke.ID];
            }
            setReplayRectangleObject(replayRectangleObjectCopy);
          }
        }
      });
      setIsResetClick(false);
      if (strokeArray.length > 0) {
        setReplayRectangleObject(replayRectangleObject);
        setStrokeActions(strokeActions);
        setStrokeArray(strokeArray);
        addAllPaths(strokeArray, true);
      }
    } else {
      if (!isResetClick) {
        const inkJson = JSON.parse(InkJsonCopy);
        if (inkJson.strokeActions && inkJson.strokeArray) {
          setStrokeActions(inkJson.strokeActions);
          const convertedStrokeArray = convertToWebFormat(inkJson.strokeArray, {
            width: canvasDimension.width,
            height: canvasDimension.height,
          });
          setStrokeArray(convertedStrokeArray);
          setStrokeColor(
            inkJson.strokeArray[inkJson.strokeArray.length - 1]
              ? inkJson.strokeArray[inkJson.strokeArray.length - 1].color
              : "#000000"
          );
          setReplayRectangleObject(
            inkJson.replayRectangleObject ? inkJson.replayRectangleObject : ""
          );
          addAllPaths(convertedStrokeArray, true);

          addAllPathsForTeacher(editorStrokeData);
        }
        setIsResetClick(false);
      }
    }
  }

  //Call after close expand popup and put expand strokes if any in main activity
  useEffect(() => {
    if (context) {
      putExpandStrokes(true);
    }
  }, [context]);

  //Call when reset click
  useEffect(() => {
    if (isReset) {
      setIsReset(false);
    }
  }, [isReset]);

  useEffect(() => {
    knovoHelpClose();
    if (activityResetType === "resetPractice") {
      funcResetPractice();
    } else if (activityResetType === "resetTest") {
      funcReset();
    }
  }, [activityResetType]);

  //Trigger when reset click for test
  function funcReset() {
    setHideAnimation(false);
    setAllMarkerStatus({});
    setSmartVideoStatus({});
    setPriorityActive(0);
    setFailureCount(0);
    setSuccessCount(0);
    window.speechSynthesis.cancel();
    const exercise = JSON.parse(ActivityJson);
    setAttempts(0);
    setCurrentScore(0);
    setControlsList([]);
    setStrokeArray([]);
    setStrokeActions([]);
    setExpandStrokeArray([]);
    setExpandStrokeActions([]);
    setStrokeColor("#000000");
    clearCanvas();
    clearExpandCanvas();
    setEditorStrokeData([]);
    setLabelArrayList([]);
    setSelectedLabel(undefined);
    setWorkJson(JSON.stringify([]));
    setEditorStrokeData(
      findStrokes(smartPaperData.Strokes, dimensionFactor, {
        width: canvasDimension.width,
        height: canvasDimension.height,
      })
    );
    let replayRectAudioArray = [];
    if (AppName === "SmartPaper") {
      exercise.ReplayRectangles.map((replayRectData, index) => {
        if (replayRectData.AudioUrl && replayRectData.AudioUrl !== "") {
          let audio = new Audio(replayRectData.AudioUrl);
          replayRectAudioArray.push(audio);
        } else {
          replayRectAudioArray.push(undefined);
        }
      });
      if (smartPaperData.ReplayRectanglesAudio) {
        smartPaperData.ReplayRectanglesAudio.map((audio) => {
          if (audio) {
            audio.load();
          }
        });
      }
    }
    setSmartPaperData({
      BackgroundImage: exercise.BackgroundImage,
      InputRows: exercise.InputRows,
      ReplayRectangles: exercise.ReplayRectangles,
      StrokeActions: exercise.StrokeActions,
      Strokes: exercise.Strokes,
      TotalScore: exercise.TotalScore,
      EditorImageWidth: exercise.EditorImageWidth,
      EditorImageHeight: exercise.EditorImageHeight,
      ReplayRectanglesAudio: replayRectAudioArray,
      Opacity: exercise.Opacity,
      TextToSpeech: exercise.TextToSpeech,
      Seconds: exercise.Seconds,
      Back: exercise.Back,
      Skip: exercise.Skip,
      Stop: exercise.Stop,
      ChatBotSettings: exercise.ChatBotSettings ? exercise.ChatBotSettings : "",
    });
    setresetValue(1);
    setTimer(undefined);
    setIsReset(true);
    setCurrentMode(CANVAS_MODE.PEN);
    setInitial(true);
    if (FollowTheFlow) {
      setTimeout(() => {
        setInitial(false);
        setPriorityActive(1);
      }, 2000);
    }
    setExplanationVisible(false);
    setAudioStop(true);
    setExplanationClick(false);
    setIsResetClick(true);
    setTimeout(() => {
      setIsResetClick(false);
    }, 1000);
    getActivityResetStatus();
  }

  //Trigger when reset click for practice
  function resetDatas() {
    window.speechSynthesis.cancel();
    const exercise = JSON.parse(ActivityJson);
    // setIsSamePage(false);
    setIsPageReopened(true);
    setAudioStop(true);
    clearCanvas();
    clearExpandCanvas();
    setEditorStrokeData([]);
    setEditorAllShapesData([]);
    setShapesDataArray([]);
    setIsImageLoaded(false);
    setIsFloating(false);
    setCurrentMode(CANVAS_MODE.PEN);
    setDisplayComponents(false);
    setHideAnimation(false);
    setAllMarkerStatus({});
    setSmartVideoStatus({});
    setPriorityActive(0);
    setFailureCount(0);
    setSuccessCount(0);
    setTtsPlayStart(false);
    setTtsMessageData("");
    setTtsPlayType("");
    setcurrentDisplayMode("normal");
    setControlsList([]);
    setStrokeArray([]);
    setStrokeActions([]);
    setExpandStrokeArray([]);
    setExpandStrokeActions([]);
    setStrokeColor("#000000");
    setLabelArrayList([]);
    setSelectedLabel(undefined);
    setTimer(undefined);
    setCurrentScore(0);
    setIsReset(true);
    setInitial(true);
    if (FollowTheFlow) {
      setTimeout(() => {
        setInitial(false);
        setPriorityActive(1);
      }, 1000);
    }
    setExplanationVisible(false);
    setExplanationClick(false);
    setShowHideLoader(true);
    let replayRectAudioArray = [];
    if (AppName === "SmartPaper") {
      exercise.ReplayRectangles.map((replayRectData, index) => {
        if (replayRectData.AudioUrl && replayRectData.AudioUrl !== "") {
          let audio = new Audio(replayRectData.AudioUrl);
          replayRectAudioArray.push(audio);
        } else {
          replayRectAudioArray.push(undefined);
        }
      });
      if (smartPaperData.ReplayRectanglesAudio) {
        smartPaperData.ReplayRectanglesAudio.map((audio) => {
          if (audio) {
            audio.load();
          }
        });
      }
    }
    if (
      activityDataFromParent.OtherActivities &&
      activityDataFromParent.OtherActivities !== null &&
      activityDataFromParent.OtherActivities.length > 0
    ) {
      setIsPageReopened(true);
      // setAllPagesData([]);
    } else {
      setSmartPaperData({
        BackgroundImage: exercise.BackgroundImage,
        InputRows: exercise.InputRows,
        ReplayRectangles: exercise.ReplayRectangles,
        StrokeActions: exercise.StrokeActions,
        Strokes: exercise.Strokes,
        TotalScore: exercise.TotalScore,
        EditorImageWidth: exercise.EditorImageWidth,
        EditorImageHeight: exercise.EditorImageHeight,
        ReplayRectanglesAudio: replayRectAudioArray,
        Opacity: exercise.Opacity,
        TextToSpeech: exercise.TextToSpeech,
        Seconds: exercise.Seconds,
        Back: exercise.Back,
        Skip: exercise.Skip,
        Stop: exercise.Stop,
        ChatBotSettings: exercise.ChatBotSettings
          ? exercise.ChatBotSettings
          : "",
      });
    }
  }
  function funcResetPractice() {
    setIsResetClick(true);
    resetDatas();
    let calculateScAt = calculateTotalComponents();
    let modifyCurrentScore = 0;
    if (calculateScAt < 1) {
      let modifyScore = Math.round(currentScore * calculateScAt);
      modifyCurrentScore = modifyScore;
    } else {
      modifyCurrentScore = currentScore;
    }
    setCurrentScoreReset(
      (currentScoreReset) => currentScoreReset + modifyCurrentScore
    );

    let tempScoreAverage = 0;
    if (smartPaperData.TotalScore && smartPaperData.TotalScore !== 0) {
      tempScoreAverage =
        (currentScoreApi /
          ((totalResetPractice + 1) * smartPaperData.TotalScore)) *
        100;
    }
    setCumulativeAverageScoreOld(tempScoreAverage);
    setTotalResetOld(totalResetPractice + 1);
    setTotalResetPractice((totalResetPractice) => totalResetPractice + 1);
    setAttemptsPractice(0);
    let otherActivityDataCopy = [...allPagesData];
    if (allPagesData.length > 0) {
      otherActivityDataCopy.map((obj, index) => {
        obj.Work = JSON.stringify([]);
        obj.Ink = JSON.stringify({});
        obj.WorkJson = JSON.stringify([]);
        obj.InkJson = JSON.stringify({});
        return obj;
      });
      setAllPagesData(otherActivityDataCopy);
      setCurrentPageNumber(0);
    }
    saveActivityForStudent(
      JSON.stringify({
        LessonUnitDistID: currentLessonUnitDistId,
        StudentID: user.LoginID,
        DomainID: user.DomainID,
        ContentID: ContentID,
        Completed: 0,
        TotalPoints: 0,
        Attempts: 0,
        Work: JSON.stringify([]),
        Ink: JSON.stringify({}),
        SpentTime: "0:00",
        Reset: 2,
        SubmitDate: getSubmitDate(),
        CumulativeAttempts: attempts,
        CumulativeTimeTaken: getTimeSpentOverall(minutes, seconds, false),
        CumulativeAverage: calculateAverage(),
        TotalTries: totalResetPractice + 1,
        OtherActivity: otherActivityDataCopy,
      }),
      (response) => {
        setTimeout(() => {
          getActivityResetStatus();
          hardResetDone();
          hardResetRandomActivity(false);
          setDisplayComponents(true);
        }, 2000);
      }
    );
  }

  //Call when expand close
  useEffect(() => {
    if (putExpandCall) {
      if (contextRef.current) {
        addAllPathsForTeacher(editorStrokeData);
        addAllPaths(strokeArray, false);
      }
      setPutExpandCall(false);
    }
  }, [putExpandCall]);

  function putExpandStrokes(status) {
    let expandStrokeArrayCopy = [];
    for (let index = 0; index < expandStrokeActions.length; index++) {
      const { StrokeID, Action } = expandStrokeActions[index];
      if (Action === "add") {
        const studentStrokeIndex = expandStrokeArray.findIndex(
          (x) => parseInt(x.id) === parseInt(StrokeID)
        );
        if (studentStrokeIndex >= 0) {
          expandStrokeArrayCopy.push(expandStrokeArray[studentStrokeIndex]);
        }
      }
    }
    //Display expand strokes from expand area to parent
    let convertedStrokeArray = expandStrokeArrayCopy;
    let finalStroke = [];
    if (convertedStrokeArray.length > 0) {
      for (const replayBoxId in convertedStrokeArray) {
        if (Object.hasOwnProperty.call(convertedStrokeArray, replayBoxId)) {
          const currentRectangle = replayRectangleData.find(
            (r) => r.ControlID === convertedStrokeArray[replayBoxId].replayBoxId
          );
          const top =
            (parseFloat(currentRectangle.YAxis.split("%")[0]) *
              canvasDimension.height) /
            100;
          const left =
            (parseFloat(currentRectangle.XAxis.split("%")[0]) *
              canvasDimension.width) /
            100;
          const xAxisPercent =
            ((parseFloat(currentRectangle.XAxis.split("%")[0]) +
              parseFloat(currentRectangle.Width)) *
              canvasDimension.width) /
            100;
          const yAxisPercent =
            ((parseFloat(currentRectangle.YAxis.split("%")[0]) +
              parseFloat(currentRectangle.Height)) *
              canvasDimension.height) /
            100;
          const convertedStroke = { ...convertedStrokeArray[replayBoxId] };
          const translated = translateStrokeToParent(
            convertedStroke,
            -top,
            -left,
            {
              width: canvasDimension.width,
              height: canvasDimension.height,
            },
            {
              xAxis: xAxisPercent,
              yAxis: yAxisPercent,
            }
          );
          if (translated) {
            finalStroke.push(translated);
          }
        }
      }
      addAllPaths(finalStroke, status);
    }
  }

  //Handle Replay pause and play button
  function togglePausePlay() {
    if (isReplayHappening) {
      if (!isPaused) {
        setIsPaused(true);
        clearTimeout(timer);
        if (replayRectangleAudio) {
          replayRectangleAudio.pause();
          setIsInitialAudioPlay(false);
        }
      } else {
        setIsPaused(false);
        if (isExpandableView) {
          expandReplay(replayRect, activeReplayBox, activeExpandBox);
        } else {
          replay(replayRect);
        }
      }
    }
  }

  async function doFastFwd() {
    if (replayRectangleAudio) {
      replayRectangleAudio.pause();
      replayRectangleAudio.currentTime = 0;
      setReplayRectangleAudio(undefined);
      setIsAudioReplay(false);
      setIsInitialAudioPlay(false);
      clearTimeout(handleAudioTimeOut);
    }
    clearTimeout(timer);
    clearCanvas();
    addAllPathsForTeacher(editorStrokeData);
    addAllPaths(strokeArray, false);
    await sleep(100).then(() => {
      setCurrentMode(CANVAS_MODE.REPLAY);
      setIsReplayHappening(false);
      setIsPaused(false);
      setReplayRect(-1);
      setreplayCount(0);
      setIsExpandableView(false);
    });
  }

  //Capture student strokes functionalities
  const startDrawing = ({ nativeEvent }) => {
    if (currentMode === CANVAS_MODE.PEN && Completed === 0 && isActive) {
      isDrawing.current = true;
      const { offsetX, offsetY } = nativeEvent;
      contextRef.current.beginPath();
      pointsArray.push({ x: offsetX, y: offsetY, isDragging: false });
      contextRef.current.moveTo(offsetX, offsetY);
      setstartTime(minutes + ":" + seconds);
    }
  };

  function convertToLine(points) {
    return [
      { x: points[0].x, y: points[0].y },
      {
        x: (points[0].x + points[points.length - 1].x) / 2,
        y: (points[0].y + points[points.length - 1].y) / 2,
      },
      {
        x: (points[0].x + points[1].x) / 2,
        y: (points[0].y + points[1].y) / 2,
      },
      {
        x: (points[points.length - 1].x + points[1].x) / 2,
        y: (points[points.length - 1].y + points[1].y) / 2,
      },
      { x: points[points.length - 1].x, y: points[points.length - 1].y },
    ];
  }

  function convertToRectangle(points) {
    const updatedPoints = [];
    const xArray = points.map((p) => p.x);
    const yArray = points.map((p) => p.y);
    const init = { x: Math.min(...xArray), y: Math.min(...yArray) };
    const end = { x: Math.max(...xArray), y: Math.max(...yArray) };
    let line1 = { x: init.x, y: init.y };
    let line11 = { x: (init.x + end.x) / 2, y: (init.y + init.y) / 2 };
    let varLine101x = (init.x + (init.x + end.x) / 2) / 2;
    let varLine101y = (init.y + (init.y + init.y) / 2) / 2;
    let line101 = { x: varLine101x, y: varLine101y };
    let varLine102x = (end.x + (init.x + end.x) / 2) / 2;
    let varLine102y = (init.y + (init.y + init.y) / 2) / 2;
    let line102 = { x: varLine102x, y: varLine102y };
    let line12 = { x: end.x, y: init.y };
    updatedPoints.push(line1);
    updatedPoints.push(line101);
    updatedPoints.push(line11);
    updatedPoints.push(line102);
    updatedPoints.push(line12);
    let line2 = { x: end.x, y: init.y };
    let line21 = { x: (end.x + end.x) / 2, y: (init.y + end.y) / 2 };
    let varLine201x = (end.x + (end.x + end.x) / 2) / 2;
    let varLine201y = (init.y + (init.y + end.y) / 2) / 2;
    let line201 = { x: varLine201x, y: varLine201y };
    let varLine202x = (end.x + (end.x + end.x) / 2) / 2;
    let varLine202y = (end.y + (init.y + end.y) / 2) / 2;
    let line202 = { x: varLine202x, y: varLine202y };
    let line22 = { x: end.x, y: end.y };
    updatedPoints.push(line2);
    updatedPoints.push(line201);
    updatedPoints.push(line21);
    updatedPoints.push(line202);
    updatedPoints.push(line22);
    let line3 = { x: end.x, y: end.y };
    let line31 = { x: (end.x + init.x) / 2, y: (end.y + end.y) / 2 };
    let varLine301x = (end.x + (end.x + init.x) / 2) / 2;
    let varLine301y = (end.y + (end.y + end.y) / 2) / 2;
    let line301 = { x: varLine301x, y: varLine301y };
    let varLine302x = (init.x + (end.x + init.x) / 2) / 2;
    let varLine302y = (end.y + (end.y + end.y) / 2) / 2;
    let line302 = { x: varLine302x, y: varLine302y };
    let line32 = { x: init.x, y: end.y };
    updatedPoints.push(line3);
    updatedPoints.push(line301);
    updatedPoints.push(line31);
    updatedPoints.push(line302);
    updatedPoints.push(line32);
    let line4 = { x: init.x, y: end.y };
    let line41 = { x: (init.x + init.x) / 2, y: (end.y + init.y) / 2 };
    let varLine401x = (init.x + (init.x + init.x) / 2) / 2;
    let varLine401y = (end.y + (end.y + init.y) / 2) / 2;
    let line401 = { x: varLine401x, y: varLine401y };
    let varLine402x = (init.x + (init.x + init.x) / 2) / 2;
    let varLine402y = (init.y + (end.y + init.y) / 2) / 2;
    let line402 = { x: varLine402x, y: varLine402y };
    let line42 = { x: init.x, y: init.y };
    updatedPoints.push(line4);
    updatedPoints.push(line401);
    updatedPoints.push(line41);
    updatedPoints.push(line402);
    updatedPoints.push(line42);
    return updatedPoints;
  }

  function convertToCircle(points) {
    const xArray = points.map((p) => p.x);
    const yArray = points.map((p) => p.y);
    const init = [Math.min(...xArray), Math.min(...yArray)];
    const end = [Math.max(...xArray), Math.max(...yArray)];
    const centerPoint = [(init[0] + end[0]) / 2, (init[1] + end[1]) / 2];
    const newRadius1 =
      (centerPoint[0] - init[0] + (end[0] - centerPoint[0])) / 2;
    const newRadius2 =
      (centerPoint[1] - init[1] + (end[1] - centerPoint[1])) / 2;
    const newRadius = (newRadius1 + newRadius2) / 2;
    const updatedPoints = getCirclePoints(
      centerPoint[0],
      centerPoint[1],
      newRadius
    );
    return updatedPoints;
  }

  function getCirclePoints(x0, y0, radius) {
    const pointsArray = [];
    for (let i = 0; i <= 360; i = i + 1) {
      pointsArray.push({
        x: x0 + radius * Math.cos(degrees_to_radians(i)),
        y: y0 + radius * Math.sin(degrees_to_radians(i)),
      });
    }
    return pointsArray;
  }

  function degrees_to_radians(degrees) {
    const pi = Math.PI;
    return degrees * (pi / 180);
  }

  function scaleStroke(scaleFactor, xArray, yArray) {
    let strokeArrayCopy = [...strokeArray];
    let expandedStrokeArrayCopy = [...expandStrokeArray];
    const selectedStrokeCopy = { ...selectedStroke };
    const minX = Math.min(...xArray);
    const minY = Math.min(...yArray);
    const updatedData = selectedStrokeCopy.points.map((d) => {
      let x = (d.x - minX) * scaleFactor + minX;
      let y = (d.y - minY) * scaleFactor + minY;
      let xy = { x: x, y: y };
      return xy;
    });
    const presentInStrokeArray = strokeArrayCopy.findIndex(
      (s) => s.id === selectedStrokeCopy.id
    );
    const presentInExpandedStrokeArray = expandedStrokeArrayCopy.findIndex(
      (s) => s.id === selectedStrokeCopy.id
    );
    if (presentInStrokeArray >= 0) {
      strokeArrayCopy[presentInStrokeArray] = {
        ...selectedStrokeCopy,
        points: updatedData,
      };
      setStrokeArray(strokeArrayCopy);
      addAllPaths(strokeArrayCopy, true);
      addAllPathsForTeacher(editorStrokeData);
    } else if (presentInExpandedStrokeArray >= 0) {
      expandedStrokeArrayCopy[presentInExpandedStrokeArray] = {
        ...selectedStrokeCopy,
        points: updatedData,
      };
      setExpandStrokeArray(expandedStrokeArrayCopy);
      addAllPathsExpand(expandedStrokeArrayCopy, true);
      putParentStrokeWhenChange();
    }
    setSelectedStroke({
      ...selectedStrokeCopy,
      points: updatedData,
    });
    currentScaleFactor.current = undefined;
  }

  const finishDrawing = () => {
    if (currentMode === CANVAS_MODE.PEN && isDrawing.current === true) {
      contextRef.current.closePath();
      isDrawing.current = false;
      let strokeArrayCopy = [...strokeArray];
      if (pointsArray.length === 1) {
        pointsArray.push({
          x: pointsArray[0].x,
          y: pointsArray[0].y,
          isDragging: false,
        });
      }
      let dataValue = [];
      if (currentShape === SHAPE_NAME.LINE) {
        dataValue = convertToLine(pointsArray);
      } else if (currentShape === SHAPE_NAME.RECT) {
        dataValue = convertToRectangle(pointsArray);
      } else if (currentShape === SHAPE_NAME.CIRCLE) {
        dataValue = convertToCircle(pointsArray);
      } else {
        dataValue = pointsArray;
      }
      let strokeUuid = Date.now();
      const stroke = {
        id: strokeUuid,
        points: dataValue,
        color: strokeColor,
        width: strokeWidth,
        isDeleted: false,
        userId: user.LoginID,
        startTime: startTime,
        elapsedTime: minutes + ":" + seconds,
        type:
          currentShape === SHAPE_NAME.PEN
            ? STROKE_TYPE.STROKE
            : STROKE_TYPE.SHAPE,
      };
      setstartTime("");
      strokeArrayCopy.push(stroke);
      setStrokeArray(strokeArrayCopy);
      let strokeAction = {
        Action: "add",
        StrokeID: strokeUuid,
        elapsedTime: minutes + ":" + seconds,
      };
      const rect = rectangleCoordinatesArray.filter((coordinates) =>
        isInRectangle(coordinates, {
          x: (pointsArray[0].x / canvasDimension.width) * 100,
          y: (pointsArray[0].y / canvasDimension.height) * 100,
        })
      );
      for (let i = 0; i < rect.length; i++) {
        const rectangle = rect[i];
        const rectIndex = rectangleCoordinatesArray.indexOf(rectangle);
        if (rectIndex >= 0) {
          let replayRectangleObjectCopy = Object.assign(
            {},
            replayRectangleObject
          );
          if (replayRectangleObjectCopy[rectIndex]) {
            replayRectangleObjectCopy[rectIndex].push(stroke.id);
          } else {
            replayRectangleObjectCopy[rectIndex] = [stroke.id];
          }
          setReplayRectangleObject(replayRectangleObjectCopy);
        }
      }
      let strokeActionsCopy = [...strokeActions];
      strokeActionsCopy.push(strokeAction);
      setStrokeActions(strokeActionsCopy);
      setpointsArray([]);
      addAllPaths(strokeArrayCopy, true);
      addAllPathsForTeacher(editorStrokeData);
      if (isReplaySequenceTimerStart) {
        setIsReplaySequence(true);
      }
    }
  };

  const draw = ({ nativeEvent }) => {
    if (currentMode === CANVAS_MODE.PEN) {
      if (!isDrawing.current) {
        return;
      }
      const { offsetX, offsetY } = nativeEvent;
      contextRef.current.lineTo(offsetX, offsetY);
      pointsArray.push({ x: offsetX, y: offsetY, isDragging: false });
      contextRef.current.stroke();
      if (isReplaySequenceTimerStart) {
        setIsReplaySequence(false);
      }
    }
  };

  const addPath = (pointsArray) => {
    contextRef.current.beginPath();
    contextRef.current.moveTo(pointsArray[0].x, pointsArray[0].y);
    pointsArray.forEach((point) => {
      contextRef.current.lineTo(point.x, point.y);
      // contextRef.current.scale(1.02, 1.02);
      contextRef.current.stroke();
    });
    contextRef.current.closePath();
  };

  const clearCanvas = () => {
    if (contextRef.current) {
      contextRef.current.clearRect(
        0,
        0,
        canvasDimension.width,
        canvasDimension.height
      );
    }
  };

  const addAllPaths = (customArray, clear) => {
    if (clear) {
      clearCanvas();
    }
    customArray.forEach((stroke) => {
      if (!stroke.isDeleted) {
        contextRef.current.strokeStyle = stroke.color;
        switch (stroke.width) {
          case 1.5:
            contextRef.current.lineWidth = STROKE_WIDTH.EXTRA_SMALL;
            break;
          case 3:
            contextRef.current.lineWidth = STROKE_WIDTH.SMALL;
            break;
          case 8:
            contextRef.current.lineWidth = STROKE_WIDTH.LARGE;
            break;
          case 10:
            contextRef.current.lineWidth = STROKE_WIDTH.LARGE;
            break;
          default:
            contextRef.current.lineWidth = STROKE_WIDTH.MEDIUM;
            break;
        }
        if (stroke.points.length > 0) {
          addPath(stroke.points);
        }
      }
    });
  };

  const addAllPathsForReplay = (customArray, clear) => {
    if (clear) {
      clearCanvas();
    }
    customArray.forEach((stroke) => {
      contextRef.current.strokeStyle = stroke.color;
      switch (stroke.width) {
        case 1.5:
          contextRef.current.lineWidth = STROKE_WIDTH.EXTRA_SMALL;
          break;
        case 3:
          contextRef.current.lineWidth = STROKE_WIDTH.SMALL;
          break;
        case 8:
          contextRef.current.lineWidth = STROKE_WIDTH.LARGE;
          break;
        case 10:
          contextRef.current.lineWidth = STROKE_WIDTH.LARGE;
          break;
        default:
          contextRef.current.lineWidth = STROKE_WIDTH.MEDIUM;
          break;
      }
      if (stroke.points.length > 0) {
        addPath(stroke.points);
      }
    });
  };

  const addAllPathsForTeacher = (customArray) => {
    if (customArray.length > 0) {
      const teacherActions = smartPaperData.StrokeActions;
      if (teacherActions.length > 0) {
        let teacherStrokes = [];
        teacherActions.forEach(({ StrokeID, Action }) => {
          if (Action === "add") {
            const currentTeacherStrokeIndex = customArray.findIndex(
              (x) => parseInt(x.id) === parseInt(StrokeID)
            );
            if (currentTeacherStrokeIndex >= 0) {
              teacherStrokes.push(customArray[currentTeacherStrokeIndex]);
            }
          } else {
            teacherStrokes = teacherStrokes.filter(
              (obj) => parseInt(obj.id) !== parseInt(StrokeID)
            );
          }
        });
        teacherStrokes.forEach((stroke) => {
          contextRef.current.strokeStyle = stroke.color;
          switch (stroke.width) {
            case 1.5:
              contextRef.current.lineWidth = STROKE_WIDTH.EXTRA_SMALL;
              break;
            case 3:
              contextRef.current.lineWidth = STROKE_WIDTH.SMALL;
              break;
            case 8:
              contextRef.current.lineWidth = STROKE_WIDTH.LARGE;
              break;
            case 10:
              contextRef.current.lineWidth = STROKE_WIDTH.LARGE;
              break;
            default:
              contextRef.current.lineWidth = STROKE_WIDTH.MEDIUM;
              break;
          }
          if (stroke.points.length > 0) {
            addPath(stroke.points);
          }
        });
        contextRef.current.strokeStyle = strokeColor;
        contextRef.current.lineWidth = strokeWidth;
      }
    }
  };
  //End of Capture student strokes functionalities

  // drag related variables
  let dragok = useRef();
  let startX = useRef();
  let startY = useRef();
  // handle mousedown events
  function myDown(e) {
    // tell the browser we're handling this mouse event
    e.preventDefault();
    e.stopPropagation();
    var BB = canvasRef.current.getBoundingClientRect();
    var offsetX = BB.left;
    var offsetY = BB.top;
    // get the current mouse position
    var mx = parseInt(e.clientX - offsetX);
    var my = parseInt(e.clientY - offsetY);
    // test each rect to see if mouse is inside
    dragok.current = false;
    for (var i = 0; i < selectedStroke.points.length; i++) {
      var r = selectedStroke.points[i];
      dragok.current = true;
      r.isDragging = true;
    }
    // save the current mouse position
    startX.current = mx;
    startY.current = my;
    console.log("mouseup");
  }
  // handle mouseup events
  function myUp(e) {
    // tell the browser we're handling this mouse event
    e.preventDefault();
    e.stopPropagation();
    // clear all the dragging flags
    dragok.current = false;
    for (var i = 0; i < selectedStroke.points.length; i++) {
      selectedStroke.points[i].isDragging = false;
    }
    setSelectedLabel(undefined);
  }
  // handle mouse moves
  function myMove(e) {
    // if we're dragging anything...

    if (dragok.current) {
      // tell the browser we're handling this mouse event
      e.preventDefault();
      e.stopPropagation();
      var BB = canvasRef.current.getBoundingClientRect();
      var offsetX = BB.left;
      var offsetY = BB.top;
      // get the current mouse position
      var mx = parseInt(e.clientX - offsetX);
      var my = parseInt(e.clientY - offsetY);
      // calculate the distance the mouse has moved
      // since the last mousemove
      var dx = mx - startX.current;
      var dy = my - startY.current;
      console.log("dex", dx);
      // move each rect that isDragging
      // by the distance the mouse has moved
      // since the last mousemove
      for (var i = 0; i < selectedStroke.points.length; i++) {
        var r = selectedStroke.points[i];
        if (r.isDragging) {
          r.x += dx;
          r.y += dy;
        }
      }

      const currentTeacherStrokeIndex = strokeArray.findIndex(
        (x) => parseInt(x.id) === parseInt(selectedStroke.id)
      );
      let strokeArrayCopy = [...strokeArray];
      if (strokeArrayCopy.length > 0) {
        if (currentTeacherStrokeIndex > -1) {
          strokeArrayCopy[currentTeacherStrokeIndex] = selectedStroke;
        }
        setStrokeArray(strokeArrayCopy);
      }

      // redraw the scene with the new rect positions
      addAllPaths(strokeArrayCopy, true);
      addAllPathsForTeacher(editorStrokeData);
      // reset the starting mouse position for the next mousemove
      startX.current = mx;
      startY.current = my;
    }
  }

  //For expanded strokes
  // drag related variables
  var dragokExpand = useRef();
  let startXExpand = useRef();
  let startYExpand = useRef();
  // handle mousedown events
  function myDownExpand(e) {
    // tell the browser we're handling this mouse event
    e.preventDefault();
    e.stopPropagation();
    var BB = expandCanvasRef.current.getBoundingClientRect();
    var offsetX = BB.left;
    var offsetY = BB.top;
    // get the current mouse position
    var mx = parseInt(e.clientX - offsetX);
    var my = parseInt(e.clientY - offsetY);
    // test each rect to see if mouse is inside
    dragokExpand.current = false;
    for (var i = 0; i < selectedStroke.points.length; i++) {
      var r = selectedStroke.points[i];
      dragokExpand.current = true;
      r.isDragging = true;
    }
    // save the current mouse position
    startXExpand.current = mx;
    startYExpand.current = my;
  }
  // handle mouseup events
  function myUpExpand(e) {
    // tell the browser we're handling this mouse event
    e.preventDefault();
    e.stopPropagation();
    // clear all the dragging flags
    dragokExpand.current = false;
    for (var i = 0; i < selectedStroke.points.length; i++) {
      selectedStroke.points[i].isDragging = false;
    }
    setSelectedStroke(undefined);
  }
  // handle mouse moves
  function myMoveExpand(e) {
    // if we're dragging anything...
    if (dragokExpand.current) {
      // tell the browser we're handling this mouse event
      e.preventDefault();
      e.stopPropagation();
      var BB = expandCanvasRef.current.getBoundingClientRect();
      var offsetX = BB.left;
      var offsetY = BB.top;
      // get the current mouse position
      var mx = parseInt(e.clientX - offsetX);
      var my = parseInt(e.clientY - offsetY);
      // calculate the distance the mouse has moved
      // since the last mousemove
      var dx = mx - startXExpand.current;
      var dy = my - startYExpand.current;
      // move each rect that isDragging
      // by the distance the mouse has moved
      // since the last mousemove

      for (var i = 0; i < selectedStroke.points.length; i++) {
        var r = selectedStroke.points[i];
        if (r.isDragging) {
          r.x += dx;
          r.y += dy;
        }
      }
      const currentTeacherStrokeIndex = expandStrokeArray.findIndex(
        (x) => parseInt(x.id) === parseInt(selectedStroke.id)
      );
      let strokeArrayCopy = [...expandStrokeArray];
      if (strokeArrayCopy.length > 0) {
        if (currentTeacherStrokeIndex > -1) {
          strokeArrayCopy[currentTeacherStrokeIndex] = selectedStroke;
        }
        setExpandStrokeArray(strokeArrayCopy);
      }
      // redraw the scene with the new rect positions
      addAllPathsExpand(strokeArrayCopy, true);
      putParentStrokeWhenChange();
      // reset the starting mouse position for the next mousemove
      startXExpand.current = mx;
      startYExpand.current = my;
    }
  }

  function calcDistance(a, b) {
    return Math.sqrt(Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2));
  }

  function nearestStroke(strokeArray, point, threshold) {
    var minDistances = strokeArray.map((stroke, index) => {
      var distances = stroke.points.map((strokePoint) =>
        calcDistance([strokePoint.x, strokePoint.y], point)
      );
      return Math.min.apply(this, distances);
    });
    var min = Math.min.apply(this, minDistances);
    return min < threshold ? strokeArray[minDistances.indexOf(min)] : null;
  }

  function deleteExpandStroke(e) {
    if (currentAction === ACTION_NAME.DELETE) {
      if (!expandRect.current) {
        expandRect.current = e.target.getBoundingClientRect();
      }
      var x = e.clientX - expandRect.current.left; //x position within the element.
      var y = e.clientY - expandRect.current.top; //y position within the element.
      let expandStrokeArrayCopy = [];
      for (const key in expandStrokeArray) {
        if (Object.prototype.hasOwnProperty.call(expandStrokeArray, key)) {
          if (expandStrokeArray[key].replayBoxId === activeExpandBox) {
            expandStrokeArrayCopy.push(expandStrokeArray[key]);
          }
        }
      }
      let allStrokes = [...expandStrokeArrayCopy];
      const closeStroke = nearestStroke(allStrokes, [x, y], 20);
      if (closeStroke && !closeStroke.isDeleted) {
        if (closeStroke === selectedStroke) {
          let strokeArrayCopy = [...expandStrokeArrayCopy];
          const strokeIndex = strokeArrayCopy.indexOf(closeStroke);
          strokeArrayCopy[strokeIndex].isDeleted = true;
          setExpandStrokeArray(expandStrokeArray);
          addAllPathsExpand(strokeArrayCopy, true);
          afterDeleteOtherStrokes();
          setSelectedStroke(undefined);
          let strokeAction = {
            Action: "remove",
            StrokeID: closeStroke.id,
            elapsedTime: minutes + ":" + seconds,
            replayBoxId: activeExpandBox,
          };
          let strokeActionsCopy = [...expandStrokeActions];
          strokeActionsCopy.push(strokeAction);
          setExpandStrokeActions(strokeActionsCopy);
        } else {
          setSelectedStroke(closeStroke);
        }
      }
    }
  }

  function deleteStroke() {
    const closeStroke = selectedStroke;
    if (closeStroke && !closeStroke.isDeleted) {
      if (
        editorStrokeData.includes(closeStroke) ||
        closeStroke.userId !== user.LoginID
      ) {
        editorStrokeNonDeleteable();
        return;
      }
      let strokeArrayCopy = [...strokeArray];
      const strokeIndex = strokeArrayCopy.indexOf(closeStroke);
      if (strokeIndex > -1) {
        strokeArrayCopy[strokeIndex].isDeleted = true;
        setStrokeArray(strokeArrayCopy);
        addAllPaths(strokeArray, true);
        addAllPathsForTeacher(editorStrokeData);
        putExpandStrokes(false);
        setSelectedStroke(undefined);
        let strokeAction = {
          Action: "remove",
          StrokeID: closeStroke.id,
          elapsedTime: minutes + ":" + seconds,
        };
        let strokeActionsCopy = [...strokeActions];
        strokeActionsCopy.push(strokeAction);
        setStrokeActions(strokeActionsCopy);
      } else {
        let strokeArrayCopy = [...expandStrokeArray];
        const strokeIndex = strokeArrayCopy.indexOf(closeStroke);
        strokeArrayCopy[strokeIndex].isDeleted = true;
        setExpandStrokeArray(expandStrokeArray);
        addAllPathsExpand(strokeArrayCopy, true);
        afterDeleteOtherStrokes();
        setSelectedStroke(undefined);
        let strokeAction = {
          Action: "remove",
          StrokeID: closeStroke.id,
          elapsedTime: minutes + ":" + seconds,
          replayBoxId: activeExpandBox,
        };
        let strokeActionsCopy = [...expandStrokeActions];
        strokeActionsCopy.push(strokeAction);
        setExpandStrokeActions(strokeActionsCopy);
      }
    }
    // }
  }

  function selectStroke(e) {
    // e = Mouse click event
    if (currentMode === CANVAS_MODE.SELECT) {
      if (!rect.current) {
        rect.current = e.target.getBoundingClientRect();
      }
      var x = e.clientX - rect.current.left; //x position within the element.
      var y = e.clientY - rect.current.top; //y position within the element.
      let allStrokes = [...strokeArray].concat([...editorStrokeData]);
      const closeStroke = nearestStroke(allStrokes, [x, y], 20);
      if (closeStroke && !closeStroke.isDeleted) {
        setSelectedStroke(closeStroke);
        if (
          editorStrokeData.includes(closeStroke) ||
          closeStroke.userId !== user.LoginID
        ) {
          editorStrokeNonDeleteable();
          return;
        } else {
          seteditorNonDeletable(false);
        }
      }
    }
  }

  function renderStrokeBorder() {
    return (
      currentMode === CANVAS_MODE.SELECT &&
      selectedStroke &&
      renderSelectedStroke(selectedStroke)
    );
  }

  function renderSelectedStroke(stroke) {
    let xArray = stroke.points.map((data) => data.x);
    let yArray = stroke.points.map((data) => data.y);
    let x = Math.min(...xArray) - 7.5;
    let y = Math.min(...yArray) - 7.5;
    let width = Math.max(...xArray) - Math.min(...xArray) + 15;
    let height = Math.max(...yArray) - Math.min(...yArray) + 15;
    return (
      <div
        className={
          currentMode === CANVAS_MODE.SELECT &&
          currentAction === ACTION_NAME.RESIZE
            ? isExpandableView
              ? "resizableExpand"
              : "resizable"
            : ""
        }
        style={{
          position: "absolute",
          top: y,
          left: x,
          zIndex: 10,
          cursor: "move",
        }}
      >
        {/* {currentMode === CANVAS_MODE.SELECT &&
          currentAction === ACTION_NAME.RESIZE && (
            <div
              style={{
                zIndex: 9999,
                display: "initial",
                pointerEvents: "all",
              }}
            >
              <div
                className="helpersResizable"
                onClick={(e) => {
                  e.stopPropagation();
                }}
                style={{
                  left: -cornerSize / 2,
                  top: -cornerSize / 2,
                  width: cornerSize,
                  height: cornerSize,
                  cursor: "nw-resize",
                }}
              />
              <div
                className="helpersResizable"
                onClick={(e) => {
                  e.stopPropagation();
                }}
                style={{
                  right: -cornerSize / 2,
                  top: -cornerSize / 2,
                  width: cornerSize,
                  height: cornerSize,
                  cursor: "ne-resize",
                }}
              />
              <div
                className="helpersResizable"
                onClick={(e) => {
                  e.stopPropagation();
                }}
                style={{
                  left: -cornerSize / 2,
                  bottom: -cornerSize / 2,
                  width: cornerSize,
                  height: cornerSize,
                  cursor: "sw-resize",
                }}
              />
              <div
                className="helpersResizable"
                onClick={(e) => {
                  e.stopPropagation();
                }}
                style={{
                  right: -cornerSize / 2,
                  bottom: -cornerSize / 2,
                  width: cornerSize,
                  height: cornerSize,
                  cursor: "se-resize",
                }}
              />
            </div>
          )} */}
        {!editorNonDeletable && (
          <div
            className="stroke-delete-container"
            style={{ cursor: "pointer" }}
            onClick={() => {
              deleteStroke();
            }}
          >
            <DeleteForeverIcon
              style={{ width: "20px", height: "20px", color: "#4922fd" }}
            />
          </div>
        )}
        {editorNonDeletable && (
          <img
            src={Images.delete}
            alt="delete"
            style={{
              width: "30px",
              height: "30px",
              objectFit: "contain",
              position: "absolute",
              opacity: 0.7,
              left: "50%",
              top: "50%",
              marginLeft: "-15px",
              marginTop: "-15px",
              MozUserSelect: "none",
              WebkitUserSelect: "none",
              msUserSelect: "none",
              userSelect: "none",
            }}
          />
        )}
        <svg width={width} height={height}>
          <rect
            width={width}
            height={height}
            style={{
              fill: "rgba(0,0,255,0)",
              stroke: "#4922fd",
              strokeWidth: 2,
              zIndex: 4,
            }}
          />
          Sorry, your browser does not support inline SVG.
        </svg>
      </div>
    );
  }

  function editorStrokeNonDeleteable() {
    seteditorNonDeletable(true);
    setTimeout(() => {
      seteditorNonDeletable(false);
      setSelectedStroke(undefined);
    }, 2000);
  }

  function renderReplayRectanglesMask() {
    return replayRectangleData && replayRectangleData.length > 0 ? (
      replayRectangleData.map((r, index) => (
        <div
          key={index.toString()}
          className={r.Priority > priorityActive ? "blur-component" : ""}
          style={{
            position: "absolute",
            width: r.Width.toString() + "%",
            height: r.Height.toString() + "%",
            top: r.YAxis.toString(),
            left: r.XAxis.toString(),
            zIndex: r.Priority > priorityActive ? 7 : 3,
          }}
        />
      ))
    ) : (
      <div
        style={{
          position: "absolute",
          top: "0%",
          left: "0%",
          width: "100%",
          height: "100%",
        }}
      />
    );
  }

  function renderReplayRectangleProperties() {
    return replayRectangleData && replayRectangleData.length > 0 ? (
      replayRectangleData.map((r, index) => {
        let xSplit = r.XAxis.split("%");
        let xSplit1 = parseFloat(xSplit[0]) + parseFloat(r.Width);
        return (
          <span
            style={{
              //  marginLeft: FollowTheFlow ? "-70px" : "-35px",
              marginLeft: "-35px",
              top: r.YAxis.toString(),
              left: xSplit1.toString() + "%",
              position: "absolute",
              borderRadius: "4px",
              zIndex: 10,
              color: "#ffffff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <Button
              className="replay-rectangle-prop-icons"
              hasIconOnly
              iconDescription="Expand"
              renderIcon={Maximize}
              tooltipAlignment="center"
              tooltipPosition="bottom"
              disabled={
                isContained
                  ? true
                  : isBgAudioPlayed
                  ? botTalking
                    ? true
                    : currentMode !== CANVAS_MODE.REPLAY && r.Expand
                    ? false
                    : true
                  : true
              }
              onClick={() => {
                setCurrentMode(CANVAS_MODE.PEN);
                setActiveExpandBox(r.ControlID);
                setActiveReplayBox({ rectangle: r, index: index });
                setIsExpandableView((isExpandableView) => !isExpandableView);
                window.speechSynthesis.cancel();
                setIsFloating(false);
                setIsFloatingChild(false);
                if (isReplaySequenceTimerStart) {
                  setIsReplaySequence(false);
                }
              }}
            />
          </span>
        );
      })
    ) : (
      <div
        style={{
          position: "absolute",
          top: "0%",
          left: "0%",
          width: "100%",
          height: "100%",
        }}
      />
    );
  }

  function renderReplayRectangles() {
    return replayRectangleData && replayRectangleData.length > 0 ? (
      replayRectangleData.map((r, index) => (
        <div
          key={index.toString()}
          style={{
            position: "absolute",
            width: r.Width.toString() + "%",
            height: r.Height.toString() + "%",
            top: r.YAxis.toString(),
            left: r.XAxis.toString(),
            zIndex: currentMode === CANVAS_MODE.REPLAY ? 6 : 3,
          }}
        >
          <p
            style={{
              position: "absolute",
              top: 0,
              color: "#0093d1",
              fontSize: "14px",
            }}
          >
            Show your work
          </p>
          <svg
            style={{
              width: "100%",
              height: "100%",
            }}
          >
            <rect
              style={{
                fill: "rgba(0,0,255,0)",
                stroke: "#0093d1",
                strokeWidth:
                  currentMode === CANVAS_MODE.REPLAY ? 4 : r.Expand ? 2 : 2,
                strokeDasharray: "10,10",
              }}
              width="100%"
              height="100%"
              strokeWidth="2"
              onClick={() => console.log("dsd")}
            />
            Sorry, your browser does not support inline SVG.
          </svg>
          {currentMode === CANVAS_MODE.REPLAY && (
            <span
              className="replay-play-icon-container"
              style={{ zIndex: 6, cursor: "pointer" }}
              onClick={() => {
                if (
                  smartPaperData.ReplayRectangles[index].AudioUrl &&
                  smartPaperData.ReplayRectangles[index].AudioUrl !== ""
                ) {
                  // setcurrentSpeed(
                  //   parseFloat(
                  //     smartPaperData.ReplayRectangles[index].ReplaySpeed
                  //   ) * 1000
                  // );
                }
                checkReplayRectangale(r, index);
                window.speechSynthesis.cancel();
              }}
            >
              <span className="replay-play-icon-color-circle">
                <PlayCircleRoundedIcon
                  style={{ color: "white", width: "30px", height: "30px" }}
                />
              </span>
            </span>
          )}
        </div>
      ))
    ) : (
      <div
        style={{
          position: "absolute",
          top: "0%",
          left: "0%",
          width: "100%",
          height: "100%",
        }}
      />
    );
  }

  function checkReplayRectangale(r, index) {
    //play audio if available
    playReplayAudio(index);
    if (r.Expand) {
      let expandedStudentExplicitStrokes = checkExpandableStroke(r);
      if (expandedStudentExplicitStrokes) {
        setCurrentMode(undefined);
        setActiveExpandBox(r.ControlID);
        setActiveReplayBox({ rectangle: r, index: index });
        setIsExpandableView(true);
        setIsFloatingChild(false);
        setIsFloating(false);
        setReplayRect(index);
        expandReplay(index, { rectangle: r, index: index }, r.ControlID);
      } else {
        setReplayRect(index);
        replay(index);
        setCurrentMode(undefined);
        setActiveExpandBox(r.ControlID);
        setActiveReplayBox({ rectangle: r, index: index });
      }
    } else {
      //old data
      setReplayRect(index);
      replay(index);
      setCurrentMode(undefined);
    }
  }

  function checkExpandableStroke(r) {
    //get all the expanded replay strokes
    let expandStrokeArrayCopy = [];
    for (let index = 0; index < expandStrokeActions.length; index++) {
      const { StrokeID, Action } = expandStrokeActions[index];
      if (Action === "add") {
        const studentStrokeIndex = expandStrokeArray.findIndex(
          (x) =>
            parseInt(x.id) === parseInt(StrokeID) &&
            parseInt(x.replayBoxId) === parseInt(r.ControlID)
        );
        if (studentStrokeIndex >= 0) {
          expandStrokeArrayCopy.push(expandStrokeArray[studentStrokeIndex]);
        }
      }
    }
    let convertedStrokeArray = expandStrokeArrayCopy;
    let finalStroke = [];
    //filter expanded strokes available inside selected box
    if (convertedStrokeArray.length > 0) {
      for (const replayBoxId in convertedStrokeArray) {
        if (Object.hasOwnProperty.call(convertedStrokeArray, replayBoxId)) {
          const convertedStroke = {
            ...convertedStrokeArray[replayBoxId],
          };

          finalStroke.push(convertedStroke);
        }
      }
    }
    const maxData = {
      maxX: canvasDimension.width * (parseFloat(r.Width) / 100),
      maxY: canvasDimension.height * (parseFloat(r.Height) / 100),
    };

    //check explicit stroke present in replay box
    const expandedStudentExplicitStrokes = findContainsExplicitStrokes(
      finalStroke,
      maxData
    );
    return expandedStudentExplicitStrokes;
  }

  function playReplayAudio(rectangleNumber) {
    if (
      smartPaperData.ReplayRectangles[rectangleNumber].AudioUrl &&
      smartPaperData.ReplayRectangles[rectangleNumber].AudioUrl !== ""
    ) {
      const audio = smartPaperData.ReplayRectanglesAudio[rectangleNumber];
      setReplayRectangleAudio(audio);
      setIsAudioReplay(true);
      audio.play();
      setIsInitialAudioPlay(true);
      clearCanvas();
    } else {
      setReplayRectangleAudio(undefined);
      setIsAudioReplay(false);
      setIsInitialAudioPlay(false);
    }
  }

  //Set delay for strokes
  function sleep(ms) {
    return new Promise((resolve) => setTimer(setTimeout(resolve, ms)));
  }

  //replay functionality
  async function replay(rectangleNumber) {
    if (rectangleNumber >= 0) {
      //setreplayCount(0);
      setCurrentMode(undefined);
      setIsReplayHappening(true);

      let strokesInRectangle = replayRectangleObject[rectangleNumber];
      if (strokesInRectangle && strokesInRectangle.length > 0) {
        const allActions = [...smartPaperData.StrokeActions].concat(
          strokeActions
        );
        let strokeActionsInRectangle = allActions.filter((stroke) => {
          return strokesInRectangle.includes(parseInt(stroke.StrokeID));
        });
        //Get all actions outside the current replay box
        let strokeActionsNotInRectangle = allActions.filter((stroke) => {
          return !strokesInRectangle.includes(parseInt(stroke.StrokeID));
        });
        let allReplayStrokes = [];
        let studentShapesReplayDataArrayCopy = [...editorShapesReplayDataArray];
        let studentShapesReplayData = {};
        setIsInitialAudioPlay(false);
        //Display strokes not present in current replay box
        for (
          let index = 0;
          index < strokeActionsNotInRectangle.length;
          index++
        ) {
          const { StrokeID, Action } = strokeActionsNotInRectangle[index];
          if (Action === "add") {
            const strokeIndex = strokeArray.findIndex(
              (x) => parseInt(x.id) === parseInt(StrokeID)
            );

            if (strokeIndex >= 0) {
              allReplayStrokes.push(strokeArray[strokeIndex]);
            } else {
              const shapeIndex = editorAllShapesData.findIndex(
                (x) => parseInt(x.ID) === parseInt(StrokeID)
              );
              if (shapeIndex >= 0) {
                studentShapesReplayData = editorAllShapesData[shapeIndex];
                studentShapesReplayDataArrayCopy.push(studentShapesReplayData);
              } else {
                const teacherStrokeIndex = editorStrokeData.findIndex(
                  (x) => parseInt(x.id) === parseInt(StrokeID)
                );
                if (teacherStrokeIndex >= 0) {
                  allReplayStrokes.push(editorStrokeData[teacherStrokeIndex]);
                }
              }
            }
          } else {
            const shapeIndex = editorAllShapesData.findIndex(
              (x) => parseInt(x.ID) === parseInt(StrokeID)
            );
            if (shapeIndex >= 0) {
              studentShapesReplayDataArrayCopy =
                studentShapesReplayDataArrayCopy.filter(
                  (obj) => parseInt(obj.ID) !== parseInt(StrokeID)
                );
            } else {
              allReplayStrokes = allReplayStrokes.filter(
                (obj) => parseInt(obj.id) !== parseInt(StrokeID)
              );
            }
          }
          addAllPathsForReplay(allReplayStrokes, true);
          setEditorShapesReplayDataArray(studentShapesReplayDataArrayCopy);
        }
        //Display strokes inside the replay box one by one
        let replayValue = 0;
        let currentReplayStrokeIndex = 0;
        if (replayCount > 0) {
          //Display already played strokes and shapes
          for (let index = 0; index < replayCount; index++) {
            const { StrokeID, Action } = strokeActionsInRectangle[index];
            if (Action === "add") {
              const strokeIndex = strokeArray.findIndex(
                (x) => parseInt(x.id) === parseInt(StrokeID)
              );

              if (strokeIndex >= 0) {
                replayValue = 0;
                allReplayStrokes.push(strokeArray[strokeIndex]);
              } else {
                const shapeIndex = editorAllShapesData.findIndex(
                  (x) => parseInt(x.ID) === parseInt(StrokeID)
                );
                if (shapeIndex >= 0) {
                  replayValue = 1;
                  studentShapesReplayData = editorAllShapesData[shapeIndex];
                  studentShapesReplayDataArrayCopy.push(
                    studentShapesReplayData
                  );
                } else {
                  const teacherStrokeIndex = editorStrokeData.findIndex(
                    (x) => parseInt(x.id) === parseInt(StrokeID)
                  );
                  if (teacherStrokeIndex >= 0) {
                    replayValue = 0;
                    allReplayStrokes.push(editorStrokeData[teacherStrokeIndex]);
                  }
                }
              }
            } else {
              const shapeIndex = editorAllShapesData.findIndex(
                (x) => parseInt(x.ID) === parseInt(StrokeID)
              );
              if (shapeIndex >= 0) {
                replayValue = 1;
                studentShapesReplayDataArrayCopy =
                  studentShapesReplayDataArrayCopy.filter(
                    (obj) => parseInt(obj.ID) !== parseInt(StrokeID)
                  );
              } else {
                replayValue = 0;
                allReplayStrokes = allReplayStrokes.filter(
                  (obj) => parseInt(obj.id) !== parseInt(StrokeID)
                );
              }
            }
            await sleep(0).then(() => {
              if (replayValue === 0) {
                addAllPathsForReplay(allReplayStrokes, true);
              } else {
                replayValue = 0;
                setEditorShapesReplayDataArray(
                  studentShapesReplayDataArrayCopy
                );
              }
              setreplayCount(index);
            });
          }
          currentReplayStrokeIndex = replayCount;
        } else {
          currentReplayStrokeIndex = 0;
        }
        for (
          let index = currentReplayStrokeIndex;
          index < strokeActionsInRectangle.length;
          index++
        ) {
          const { StrokeID, Action } = strokeActionsInRectangle[index];
          if (Action === "add") {
            const strokeIndex = strokeArray.findIndex(
              (x) => parseInt(x.id) === parseInt(StrokeID)
            );
            if (strokeIndex >= 0) {
              replayValue = 0;
              allReplayStrokes.push(strokeArray[strokeIndex]);
            } else {
              const shapeIndex = editorAllShapesData.findIndex(
                (x) => parseInt(x.ID) === parseInt(StrokeID)
              );
              if (shapeIndex >= 0) {
                replayValue = 1;
                studentShapesReplayData = editorAllShapesData[shapeIndex];
                studentShapesReplayDataArrayCopy.push(studentShapesReplayData);
              } else {
                const teacherStrokeIndex = editorStrokeData.findIndex(
                  (x) => parseInt(x.id) === parseInt(StrokeID)
                );
                if (teacherStrokeIndex >= 0) {
                  replayValue = 0;
                  allReplayStrokes.push(editorStrokeData[teacherStrokeIndex]);
                }
              }
            }
          } else {
            const shapeIndex = editorAllShapesData.findIndex(
              (x) => parseInt(x.ID) === parseInt(StrokeID)
            );
            if (shapeIndex >= 0) {
              replayValue = 1;
              studentShapesReplayDataArrayCopy =
                studentShapesReplayDataArrayCopy.filter(
                  (obj) => parseInt(obj.ID) !== parseInt(StrokeID)
                );
            } else {
              replayValue = 0;
              allReplayStrokes = allReplayStrokes.filter(
                (obj) => parseInt(obj.id) !== parseInt(StrokeID)
              );
            }
          }
          await sleep(currentSpeed).then(() => {
            if (replayValue === 0) {
              addAllPathsForReplay(allReplayStrokes, true);
            } else {
              replayValue = 0;
              setEditorShapesReplayDataArray(studentShapesReplayDataArrayCopy);
            }
            setreplayCount(index);
          });
        }

        //Expanded strokes replay in parent
        let allReplayStrokesExpand = [];
        let expandStrokeArrayCopy = [];
        let expandStrokeActionCopy = [];
        let expandStrokeCopy = [];

        if (expandStrokeArray.length > 0 && activeExpandBox) {
          for (const key in expandStrokeArray) {
            if (Object.prototype.hasOwnProperty.call(expandStrokeArray, key)) {
              if (expandStrokeArray[key].replayBoxId === activeExpandBox) {
                expandStrokeArrayCopy.push(expandStrokeArray[key]);
              }
            }
          }
        }
        if (expandStrokeActions.length > 0 && activeExpandBox) {
          for (const key in expandStrokeActions) {
            if (
              Object.prototype.hasOwnProperty.call(expandStrokeActions, key)
            ) {
              if (expandStrokeActions[key].replayBoxId === activeExpandBox) {
                expandStrokeActionCopy.push(expandStrokeActions[key]);
              }
            }
          }
        }
        for (let index = 0; index < expandStrokeActionCopy.length; index++) {
          const { StrokeID, Action } = expandStrokeActionCopy[index];
          if (Action === "add") {
            const strokeIndex = expandStrokeArray.findIndex(
              (x) => parseInt(x.id) === parseInt(StrokeID)
            );
            if (strokeIndex >= 0) {
              allReplayStrokesExpand.push(expandStrokeArray[strokeIndex]);
            }
          } else {
            allReplayStrokesExpand = allReplayStrokesExpand.filter(
              (obj) => parseInt(obj.id) !== parseInt(StrokeID)
            );
          }
        }
        for (let i = 0; i < allReplayStrokesExpand.length; i++) {
          const strokeExpand = { ...allReplayStrokesExpand[i] };
          expandStrokeCopy.push(strokeExpand);
        }

        //Convert to parent
        let convertedStrokeArray = expandStrokeCopy;
        let finalStroke = [];
        if (convertedStrokeArray.length > 0) {
          for (const replayBoxId in convertedStrokeArray) {
            if (Object.hasOwnProperty.call(convertedStrokeArray, replayBoxId)) {
              const currentRectangle = replayRectangleData.find(
                (r) =>
                  r.ControlID === convertedStrokeArray[replayBoxId].replayBoxId
              );
              const top =
                (parseFloat(currentRectangle.YAxis.split("%")[0]) *
                  canvasDimension.height) /
                100;
              const left =
                (parseFloat(currentRectangle.XAxis.split("%")[0]) *
                  canvasDimension.width) /
                100;
              const xAxisPercent =
                ((parseFloat(currentRectangle.XAxis.split("%")[0]) +
                  parseFloat(currentRectangle.Width)) *
                  canvasDimension.width) /
                100;
              const yAxisPercent =
                ((parseFloat(currentRectangle.YAxis.split("%")[0]) +
                  parseFloat(currentRectangle.Height)) *
                  canvasDimension.height) /
                100;
              const convertedStroke = {
                ...convertedStrokeArray[replayBoxId],
              };
              const translated = translateStrokeToParent(
                convertedStroke,
                -top,
                -left,
                {
                  width: canvasDimension.width,
                  height: canvasDimension.height,
                },
                {
                  xAxis: xAxisPercent,
                  yAxis: yAxisPercent,
                }
              );
              if (translated) {
                finalStroke.push(translated);
              }
            }
            await sleep(currentSpeed).then(() => {
              addAllPaths(finalStroke, false);
              setreplayCount(replayBoxId);
            });
          }
        }
        clearCanvas();
        addAllPathsForTeacher(editorStrokeData);
        addAllPaths(strokeArray, false);
        putExpandStrokes(false);
        await sleep(currentSpeed).then(() => {
          setEditorShapesReplayDataArray([]);
          setCurrentMode(CANVAS_MODE.REPLAY);
          setIsReplayHappening(false);
          setReplayRect(-1);
          setreplayCount(0);
          setReplayRectangleAudio(undefined);
        });
      } else {
        setIsInitialAudioPlay(false);
        setEditorShapesReplayDataArray([]);
        alert(NOTHING_FOR_REPLAY);
        setCurrentMode(CANVAS_MODE.REPLAY);
        setIsReplayHappening(false);
        setReplayRect(-1);
        setReplayRectangleAudio(undefined);
      }
    }
  }

  //replay functionality for expandable
  async function expandReplay(
    rectangleNumber,
    activeReplayBox,
    activeExpandBox
  ) {
    if (rectangleNumber >= 0) {
      setreplayCount(0);
      setCurrentMode(undefined);
      setIsReplayHappening(true);
      setIsFloating(true);
      let allReplayStrokes = [];
      let allReplayStrokesExpand = [];
      let otherStrokeCopy = [];
      let expandStrokeActionCopy = [];
      let expandStrokeCopy = [];
      let studentShapesReplayDataArrayCopy = [];
      let replayValue = 0;
      const top =
        (parseFloat(activeReplayBox.rectangle.YAxis.split("%")[0]) *
          canvasDimension.height) /
        100;
      const left =
        (parseFloat(activeReplayBox.rectangle.XAxis.split("%")[0]) *
          canvasDimension.width) /
        100;
      let strokesInRectangle = replayRectangleObject[rectangleNumber];

      if (
        (strokesInRectangle && strokesInRectangle.length > 0) ||
        (expandStrokeArray.length > 0 && activeExpandBox)
      ) {
        const allActions = [...smartPaperData.StrokeActions].concat(
          strokeActions
        );
        let strokeActionsInRectangle = [];
        if (strokesInRectangle && strokesInRectangle.length > 0) {
          strokeActionsInRectangle = allActions.filter((stroke) => {
            return strokesInRectangle.includes(parseInt(stroke.StrokeID));
          });
        }

        if (expandStrokeActions.length > 0 && activeExpandBox) {
          for (const key in expandStrokeActions) {
            if (
              Object.prototype.hasOwnProperty.call(expandStrokeActions, key)
            ) {
              if (expandStrokeActions[key].replayBoxId === activeExpandBox) {
                expandStrokeActionCopy.push(expandStrokeActions[key]);
              }
            }
          }
        }

        let overallExpandActions = [...strokeActionsInRectangle].concat(
          expandStrokeActionCopy
        );
        setIsInitialAudioPlay(false);
        let playedExpandedActions = [];
        for (let index = 0; index < expandReplayCount; index++) {
          playedExpandedActions.push(overallExpandActions[index]);
        }
        if (playedExpandedActions.length > 0) {
          for (let index = 0; index < playedExpandedActions.length; index++) {
            const { StrokeID, Action } = playedExpandedActions[index];
            //check action present in strokeArray
            const strokeIndex = strokeArray.findIndex(
              (x) => parseInt(x.id) === parseInt(StrokeID)
            );
            if (strokeIndex >= 0) {
              // display student stroke array
              const studentParStroke = { ...strokeArray[strokeIndex] };
              const studentParexpandedStroke = translateStroke(
                studentParStroke,
                top,
                left
              );
              otherStrokeCopy.push(studentParexpandedStroke);
              await sleep(currentSpeed).then(() => {
                addAllPathsForReplayExpand(otherStrokeCopy, true);
              });
            } else {
              const shapeIndex = editorAllShapesData.findIndex(
                (x) => parseInt(x.ID) === parseInt(StrokeID)
              );
              if (shapeIndex >= 0) {
                replayValue = 1;
                await sleep(currentSpeed).then(() => {
                  editorShapesReplayDataArray.push(
                    editorAllShapesData[shapeIndex]
                  );
                });
              } else {
                const teacherStrokeIndex = editorStrokeData.findIndex(
                  (x) => parseInt(x.id) === parseInt(StrokeID)
                );
                if (teacherStrokeIndex >= 0) {
                  replayValue = 0;
                  // display teacher stroke array
                  const editorStroke = {
                    ...editorStrokeData[teacherStrokeIndex],
                  };
                  const expandedStroke = translateStroke(
                    editorStroke,
                    top,
                    left
                  );
                  otherStrokeCopy.push(expandedStroke);
                  await sleep(0).then(() => {
                    addAllPathsForReplayExpand(otherStrokeCopy, true);
                  });
                } else {
                  const expandStrokeIndex = expandStrokeArray.findIndex(
                    (x) => parseInt(x.id) === parseInt(StrokeID)
                  );
                  if (expandStrokeIndex >= 0) {
                    const strokeExpand = {
                      ...expandStrokeArray[expandStrokeIndex],
                    };
                    expandStrokeCopy.push(strokeExpand);
                    if (Action === "add") {
                      await sleep(0).then(() => {
                        addAllPathsForReplayExpand(expandStrokeCopy, false);
                      });
                    } else {
                      expandStrokeCopy = expandStrokeCopy.filter(
                        (obj) => parseInt(obj.id) !== parseInt(StrokeID)
                      );
                      await sleep(0).then(() => {
                        let allStrokes = [...otherStrokeCopy].concat(
                          expandStrokeCopy
                        );
                        addAllPathsForReplayExpand(allStrokes, true);
                      });
                    }
                  }
                }
              }
            }
          }
        }
        for (
          let index = expandReplayCount;
          index < overallExpandActions.length;
          index++
        ) {
          const { StrokeID, Action } = overallExpandActions[index];
          //check action present in strokeArray
          const strokeIndex = strokeArray.findIndex(
            (x) => parseInt(x.id) === parseInt(StrokeID)
          );
          if (strokeIndex >= 0) {
            // display student stroke array
            const studentParStroke = { ...strokeArray[strokeIndex] };
            const studentParexpandedStroke = translateStroke(
              studentParStroke,
              top,
              left
            );
            otherStrokeCopy.push(studentParexpandedStroke);
            await sleep(currentSpeed).then(() => {
              addAllPathsForReplayExpand(otherStrokeCopy, true);
            });
          } else {
            const shapeIndex = editorAllShapesData.findIndex(
              (x) => parseInt(x.ID) === parseInt(StrokeID)
            );
            if (shapeIndex >= 0) {
              replayValue = 1;
              await sleep(currentSpeed).then(() => {
                editorShapesReplayDataArray.push(
                  editorAllShapesData[shapeIndex]
                );
              });
            } else {
              const teacherStrokeIndex = editorStrokeData.findIndex(
                (x) => parseInt(x.id) === parseInt(StrokeID)
              );
              if (teacherStrokeIndex >= 0) {
                replayValue = 0;
                // display teacher stroke array
                const editorStroke = {
                  ...editorStrokeData[teacherStrokeIndex],
                };
                const expandedStroke = translateStroke(editorStroke, top, left);
                otherStrokeCopy.push(expandedStroke);
                await sleep(currentSpeed).then(() => {
                  addAllPathsForReplayExpand(otherStrokeCopy, true);
                });
              } else {
                const expandStrokeIndex = expandStrokeArray.findIndex(
                  (x) => parseInt(x.id) === parseInt(StrokeID)
                );
                if (expandStrokeIndex >= 0) {
                  const strokeExpand = {
                    ...expandStrokeArray[expandStrokeIndex],
                  };
                  expandStrokeCopy.push(strokeExpand);
                  if (Action === "add") {
                    await sleep(currentSpeed).then(() => {
                      addAllPathsForReplayExpand(expandStrokeCopy, false);
                    });
                  } else {
                    expandStrokeCopy = expandStrokeCopy.filter(
                      (obj) => parseInt(obj.id) !== parseInt(StrokeID)
                    );
                    await sleep(currentSpeed).then(() => {
                      let allStrokes = [...otherStrokeCopy].concat(
                        expandStrokeCopy
                      );
                      addAllPathsForReplayExpand(allStrokes, true);
                    });
                  }
                }
              }
            }
            setExpandReplayCount(index);
          }
        }

        let overallStrokesArray = [...allReplayStrokes]
          .concat(studentShapesReplayDataArrayCopy)
          .concat(allReplayStrokesExpand);

        addAllPathsForReplayExpand(otherStrokeCopy, false);
        addAllPathsForReplayExpand(allReplayStrokesExpand, false);
        await sleep(currentSpeed).then(() => {
          setEditorShapesReplayDataArray([]);
          setCurrentMode(CANVAS_MODE.REPLAY);
          setIsReplayHappening(false);
          setReplayRect(-1);
          setReplayRectangleAudio(undefined);
          setIsExpandableView(false);
          setPutExpandCall(true);
          setExpandReplayCount(0);
        });
      } else {
        setIsExpandableView(false);
        setIsInitialAudioPlay(false);
        alert(NOTHING_FOR_REPLAY);
        setEditorShapesReplayDataArray([]);
        setCurrentMode(CANVAS_MODE.REPLAY);
        setIsReplayHappening(false);
        setReplayRect(-1);
        setReplayRectangleAudio(undefined);
        setExpandReplayCount(0);
      }
    }
  }

  async function togglePen() {
    if (replayRectangleAudio) {
      replayRectangleAudio.pause();
      replayRectangleAudio.currentTime = 0;
      setReplayRectangleAudio(undefined);
      setIsAudioReplay(false);
      setIsInitialAudioPlay(false);
      clearTimeout(handleAudioTimeOut);
    }
    setShowWidth(false);
    setIsFloatingChild(true);
    setShowShapes(true);
    clearTimeout(timer);
    await sleep(100).then(() => {
      setStrokeWidth(STROKE_WIDTH.MEDIUM);
      setCurrentMode(CANVAS_MODE.PEN);
      setIsReplayHappening(false);
    });
  }

  function handleSmartVideoJson(value, ControlID) {
    const smartVideoStatusCopy = { ...smartVideoStatus };
    smartVideoStatusCopy[ControlID] = value;
    setSmartVideoStatus(smartVideoStatusCopy);
  }

  function handleSuccessChange(successValue) {
    if (isPractice) {
      showSuccessModal();
      setSuccess(successValue);
      playAnimationSound("validation", successValue);
      if (successValue) {
        getValidationFeedback("success", true);
      } else {
        getValidationFeedback("failure", true);
      }
    }
  }

  function showSuccessModal() {
    setValidationVisible(true);
    setTimeout(() => {
      setValidationVisible(false);
    }, 750);
  }

  function onPriorityChange(componentPriority, componentControlID) {
    if (FollowTheFlow) {
      if (componentPriority === priorityActive) {
        if (isPractice) {
          if (componentPriority > 0) {
            let indexOfCurrentControl = smartPaperData.InputRows.findIndex(
              (obj) => obj.Priority === componentPriority
            );
            if (
              indexOfCurrentControl >= 0 &&
              smartPaperData &&
              smartPaperData.InputRows &&
              smartPaperData.InputRows[indexOfCurrentControl]
            ) {
              if (
                smartPaperData.InputRows[indexOfCurrentControl].PluginId ===
                "RichText"
              ) {
                setIsPageReopened(false);
                setTimeout(() => {
                  setPriorityActive((priorityActive) => priorityActive + 1);
                }, 1000);
              }
            }
          }
        } else {
          setIsPageReopened(false);
          setTimeout(() => {
            setPriorityActive((priorityActive) => priorityActive + 1);
          }, 1000);
        }
        setShowHint(false);
      }
    }
  }

  function sequenceMessage(componentHintMessage) {
    setHintMessage(componentHintMessage);
  }
  function toggleReplayMode() {
    setShowWidth(false);
    if (currentMode === CANVAS_MODE.REPLAY) {
      setCurrentMode(CANVAS_MODE.PEN);
      setSelectedStroke(undefined);
      setStrokeWidth(strokeWidth);
    } else {
      setReplayRect(-1);
      setCurrentMode(CANVAS_MODE.REPLAY);
      setStrokeWidth(STROKE_WIDTH.NONE);
      setIsPaused(false);
    }
  }

  function calculateAverage() {
    let overallAverageScore = 0;
    let modifyCurrentScore = 0;
    if (smartPaperData.TotalScore && smartPaperData.TotalScore !== 0) {
      let calculateScAt = calculateTotalComponents();
      if (calculateScAt < 1) {
        let modifyScore = Math.round(currentScore * calculateScAt);
        modifyCurrentScore = modifyScore;
      } else {
        modifyCurrentScore = currentScore;
      }
      let currentAverageScore = Math.round(
        (modifyCurrentScore / smartPaperData.TotalScore) * 100
      );
      if (cumulativeAverageScoreOld === 0) {
        overallAverageScore = Math.round(
          (modifyCurrentScore / smartPaperData.TotalScore) * 100
        );
      } else {
        overallAverageScore = Math.round(
          (cumulativeAverageScoreOld * totalResetOld + currentAverageScore) /
            (totalResetPractice + 1)
        );
      }
    }
    return overallAverageScore;
  }

  function scoreForPractice() {
    let modifyCurrentScore = 0;
    if (
      activityDataFromParent.OtherActivities &&
      activityDataFromParent.OtherActivities !== null &&
      activityDataFromParent.OtherActivities.length > 0
    ) {
      modifyCurrentScore = overallActivityScore;
    } else {
      let calculateScAt = calculateTotalComponents();
      if (calculateScAt < 1) {
        let modifyScore = Math.round(currentScore * calculateScAt);
        modifyCurrentScore = modifyScore;
      } else {
        modifyCurrentScore = currentScore;
      }
    }

    return modifyCurrentScore;
  }

  function calculateTotalComponents() {
    let noOfComponents = 0;
    let calculateScAt = 0;
    smartPaperData.InputRows.map((box, index) => {
      if (
        box.PluginId === "AGInput" ||
        box.PluginId === "AGTextList" ||
        box.PluginId === "AGInkList" ||
        box.PluginName === "SSMultipleChoice" ||
        box.PluginName === "SSMultipleAnswer" ||
        box.PluginName === "SSTrueFalse" ||
        box.PluginName === "SSRotatingDial" ||
        box.PluginName === "SSFillinTheBlanks" ||
        box.PluginName === "SPHotspot" ||
        box.PluginId === "MatchTable" ||
        box.PluginId === "Fraction" ||
        box.PluginId === "EquationEditor"
      ) {
        noOfComponents = noOfComponents + 1;
      }
    });
    if (attemptsPractice !== 0) {
      calculateScAt = noOfComponents / attemptsPractice;
    }
    return calculateScAt;
  }

  function isInRectangle(coordinates, point) {
    const [x1, y1, x2, y2] = coordinates;
    const { x, y } = point;
    return x > x1 && x < x2 && y > y1 && y < y2;
  }

  const [outsideClick, setOutsideClick] = useState(false);
  function onOutsideClickChange(clickOutside) {
    setOutsideClick(clickOutside);
  }
  const [showAlertDone, setShowAlertDone] = useState(false);
  useEffect(() => {
    if (!showToastModal) {
      setShowAlertDone(false);
    }
    if (showAlertDone) {
      showOrHideToaster(
        true,
        " This activity has already been submitted. Editing is not allowed at this time.",
        "warning"
      );
    }
  }, [showAlertDone, showToastModal]);

  const handleExpand = () => {
    setPutExpandCall(true);
    setActiveReplayBox(undefined);
    setActiveExpandBox(undefined);
    setExpandImageCoordinates(undefined);
    setCurrentMode(CANVAS_MODE.PEN);
    setIsExpandableView(false);
  };

  const [showWidth, setShowWidth] = useState(false);
  const [showShapes, setShowShapes] = useState(true);
  const [showSelects, setShowSelects] = useState(false);

  useEffect(() => {
    let x1 = document.styleSheets[0];
    x1.addRule(".modal-content", "height: 100% !important");
  }, []);

  useEffect(() => {
    if (isExpandableView) {
      setInitialExpand(true);
      const expandCanvas = expandCanvasRef.current;
      setExpandContext(expandCanvas.getContext("2d"));
    }
  }, [isExpandableView]);

  useEffect(() => {
    if (activeReplayBox) {
      const box1Top =
        parseFloat(activeReplayBox.rectangle.YAxis.split("%")[0]) +
        parseFloat(activeReplayBox.rectangle.Height);
      const box1Left =
        parseFloat(activeReplayBox.rectangle.XAxis.split("%")[0]) +
        parseFloat(activeReplayBox.rectangle.Width);

      const expandImageCoor = {
        left: activeReplayBox.rectangle.XAxis,
        top: activeReplayBox.rectangle.YAxis,
        width: activeReplayBox.rectangle.Width,
        height: activeReplayBox.rectangle.Height,
        box1Top: box1Top,
        box1Left: box1Left,
      };
      setExpandImageCoordinates(expandImageCoor);
    }
  }, [activeReplayBox]);

  useEffect(() => {
    if (expandContext) {
      expandContext.lineCap = "round";
      expandContext.strokeStyle = strokeColor;
      expandContext.lineWidth = strokeWidth;
      expandContextRef.current = expandContext;

      if (initialExpand) {
        if (expandStrokeArray.length > 0 && activeExpandBox) {
          let expandStrokeArrayCopy = [];
          for (const key in expandStrokeArray) {
            if (Object.prototype.hasOwnProperty.call(expandStrokeArray, key)) {
              if (expandStrokeArray[key].replayBoxId === activeExpandBox) {
                expandStrokeArrayCopy.push(expandStrokeArray[key]);
              }
            }
          }
          addAllPathsExpand(expandStrokeArrayCopy, false);
        }

        //Seperate teacher and student strokes for expandable screen
        let strokesInRectangle = replayRectangleObject[activeReplayBox.index];
        if (strokesInRectangle && strokesInRectangle.length > 0) {
          const allActions = [...smartPaperData.StrokeActions].concat(
            strokeActions
          );
          let strokeActionsInRectangle = allActions.filter((stroke) => {
            return strokesInRectangle.includes(parseInt(stroke.StrokeID));
          });
          let allReplayStrokes = [];
          let allShapesExpandDataArrayCopy = [];
          let allShapesExpandData = {};
          for (
            let index = 0;
            index < strokeActionsInRectangle.length;
            index++
          ) {
            const { StrokeID, Action } = strokeActionsInRectangle[index];

            if (Action === "add") {
              const strokeIndex = strokeArray.findIndex(
                (x) => parseInt(x.id) === parseInt(StrokeID)
              );
              if (strokeIndex >= 0) {
                allReplayStrokes.push(strokeArray[strokeIndex]);
              } else {
                const shapeIndex = editorAllShapesData.findIndex(
                  (x) => parseInt(x.ID) === parseInt(StrokeID)
                );
                if (shapeIndex >= 0) {
                  allShapesExpandData = editorAllShapesData[shapeIndex];
                  allShapesExpandDataArrayCopy.push(allShapesExpandData);
                } else {
                  const teacherStrokeIndex = editorStrokeData.findIndex(
                    (x) => parseInt(x.id) === parseInt(StrokeID)
                  );
                  if (teacherStrokeIndex >= 0) {
                    allReplayStrokes.push(editorStrokeData[teacherStrokeIndex]);
                  }
                }
              }
            } else {
              const shapeIndex = editorAllShapesData.findIndex(
                (x) => parseInt(x.ID) === parseInt(StrokeID)
              );
              if (shapeIndex >= 0) {
                allShapesExpandDataArrayCopy =
                  allShapesExpandDataArrayCopy.filter(
                    (obj) => parseInt(obj.ID) !== parseInt(StrokeID)
                  );
              } else {
                allReplayStrokes = allReplayStrokes.filter(
                  (obj) => parseInt(obj.id) !== parseInt(StrokeID)
                );
              }
            }
          }

          const top =
            (parseFloat(activeReplayBox.rectangle.YAxis.split("%")[0]) *
              canvasDimension.height) /
            100;
          const left =
            (parseFloat(activeReplayBox.rectangle.XAxis.split("%")[0]) *
              canvasDimension.width) /
            100;
          let expandedStrokeCopy = [];
          for (let i = 0; i < allReplayStrokes.length; i++) {
            const editorStroke = { ...allReplayStrokes[i] };
            const expandedStroke = translateStroke(editorStroke, top, left);
            expandedStrokeCopy.push(expandedStroke);
          }
          addAllPathsExpand(expandedStrokeCopy, false);

          //Add student and editor shapes to expand from parent
          let expandedShapesCopy = [];
          for (let i = 0; i < allShapesExpandDataArrayCopy.length; i++) {
            const editorShapes = { ...allShapesExpandDataArrayCopy[i] };
            const expandedShapes = translateShapesToExpand(
              editorShapes,
              top,
              left
            );
            expandedShapesCopy.push(expandedShapes);
          }
          setAllShapesExpandDataArray(expandedShapesCopy);
        }
        setInitialExpand(false);
      }
    }
  }, [expandContext, strokeColor, strokeWidth]);

  useEffect(() => {
    onHideHeader(displayActivityCompletePopup);
    if (displayActivityCompletePopup) {
      if (isGuidedActivity && isGuidedClicked) {
        onWarningBotDialog(
          "You're done with the practice. Click continue to take test?"
        );
      } else {
        onWarningBotDialog(
          "You're done with this activity. Would you like to submit now?"
        );
      }
    } else {
      onWarningBotDialog("");
    }
  }, [displayActivityCompletePopup]);
  useEffect(() => {
    handleGuidedActivity(isGuidedClicked);
  }, [isGuidedClicked]);

  useEffect(() => {
    onHideHeader(displayReplayDonePopup);
    if (displayReplayDonePopup) {
      onWarningBotDialog("Are you done writing?");
    } else {
      onWarningBotDialog("");
    }
  }, [displayReplayDonePopup]);

  //cancel replay timer when click other action
  useEffect(() => {
    if (confirmPopupVisible) {
      setIsReplaySequence(false);
      setAudioStop(true);
    } else {
      if (isReplaySequenceTimerStart) {
        setIsReplaySequence(true);
      }
    }
  }, [confirmPopupVisible]);

  //Sequence text to speech audio
  useEffect(() => {
    if (FollowTheFlow && Completed === 0 && displayComponents) {
      if (priorityActive > 0) {
        if (priorityActive <= highestPriorityValue) {
          setIsPageNavigated(false);
        }
        let indexOfCurrentControl = smartPaperData.InputRows.findIndex(
          (obj) => obj.Priority === priorityActive
        );
        if (indexOfCurrentControl >= 0) {
          checkCurrentComponent(indexOfCurrentControl);
        } else if (smartPaperData.ReplayRectangles.length > 0) {
          let indexOfCurrentControl = smartPaperData.ReplayRectangles.findIndex(
            (obj) => obj.Priority === priorityActive
          );
          if (
            indexOfCurrentControl >= 0 &&
            smartPaperData &&
            smartPaperData.ReplayRectangles &&
            smartPaperData.ReplayRectangles[indexOfCurrentControl]
          ) {
            setPriorityActive((priorityActive) => priorityActive + 1);
          } else {
            callLastControlIsFinished();
          }
        } else {
          callLastControlIsFinished();
        }
      }
    }
  }, [priorityActive, displayComponents]);

  //Check next control is input components

  function checkCurrentComponent(indexOfCurrentControl) {
    //find current control is available in controlslist
    let indexOfCurrentControlInControlList = controlsList.findIndex(
      (obj) =>
        obj.CtlId === smartPaperData.InputRows[indexOfCurrentControl].ControlID
    );
    if (indexOfCurrentControlInControlList >= 0) {
      let item = smartPaperData.InputRows[indexOfCurrentControl];
      let control = controlsList[indexOfCurrentControlInControlList];
      if (isPractice) {
        if (item && item.PluginId) {
          if (item.PluginId === "AGTextList" || item.PluginId === "AGInkList") {
            if (parseFloat(control.CtlValue.Value) > 0) {
              setPriorityActive((priorityActive) => priorityActive + 1);
            }
          } else if (
            item.PluginId === "MatchTable" ||
            item.PluginId === "Fraction" ||
            item.PluginId === "EquationEditor" ||
            item.PluginId === "H5P"
          ) {
            if (control.CtlScore > 0) {
              setIsPageNavigated(false);
              setPriorityActive((priorityActive) => priorityActive + 1);
            }
          } else if (
            item.PluginId === "PopupSlide" &&
            item.MarkData.MarkerType === "guidedActivity"
          ) {
            setIsPageNavigated(false);
            setPriorityActive((priorityActive) => priorityActive + 1);
          } else if (
            item.PluginId === "PopupSlide" ||
            item.PluginId === "RichText"
          ) {
            //score += parseFloat(control.CtlValue.Score);
          } else {
            if (item.Type === "range") {
              if (item.CorrectAnswer === control.CtlValue.Answer) {
                setIsPageNavigated(false);
                setPriorityActive((priorityActive) => priorityActive + 1);
              } else if (
                parseFloat(control.CtlValue.Answer) >= item.MinValue &&
                parseFloat(control.CtlValue.Answer) <= item.MaxValue
              ) {
                setIsPageNavigated(false);
                setPriorityActive((priorityActive) => priorityActive + 1);
              } else {
              }
            } else {
              if (!item.CaseSensitive) {
                if (item.CorrectAnswer === control.CtlValue.Answer) {
                  setIsPageNavigated(false);
                  setPriorityActive((priorityActive) => priorityActive + 1);
                }
              } else {
                if (
                  item.CorrectAnswer.toLowerCase() ===
                  control.CtlValue.Answer.toLowerCase()
                ) {
                  setIsPageNavigated(false);
                  setPriorityActive((priorityActive) => priorityActive + 1);
                }
              }
            }
          }
        } else {
          if (control.CtlScore > 0) {
            setIsPageNavigated(false);
            setPriorityActive((priorityActive) => priorityActive + 1);
          }
        }
      } else {
        setIsPageNavigated(false);
        setPriorityActive((priorityActive) => priorityActive + 1);
      }
    } else {
      if (
        indexOfCurrentControl >= 0 &&
        smartPaperData &&
        smartPaperData.InputRows &&
        smartPaperData.InputRows[indexOfCurrentControl]
      ) {
        //set current control seauence message
        if (smartPaperData.InputRows[indexOfCurrentControl].SpeechData) {
          setTtsPlayType("sequence");
          setTtsMessageData(
            smartPaperData.InputRows[indexOfCurrentControl].SpeechData
          );
          setTtsPlayStart(true);
        }
        //set readmore url for current component
        if (
          smartPaperData.InputRows[indexOfCurrentControl]
            .CorrectAnswerExplanation
        ) {
          setReadmoreUrl(
            smartPaperData.InputRows[indexOfCurrentControl]
              .CorrectAnswerExplanation
          );
        } else {
          setReadmoreUrl("");
        }
      } else {
        setIsPageNavigated(false);
        setPriorityActive((priorityActive) => priorityActive + 1);
      }
    }
  }

  //Check contained or multipage then dispaly submit or move next page

  function callLastControlIsFinished() {
    //Check conatined activity or not
    if (isContained) {
      setDisplayActivityCompletePopup(false);
      if (isMultipage && activityDataFromParent.OtherActivities) {
        ////Display submit pop up if it is last page
        if (
          currentPageNumber + 1 ===
          activityDataFromParent.OtherActivities.length
        ) {
        } else {
          setDisplayActivityCompletePopup(false);
          if (
            currentPageNumber <
            activityDataFromParent.OtherActivities.length - 1
          ) {
            if (isPageReopened) {
            } else {
              // setDisplayComponents(false);
              setIsMultipageActive(true);
              clearCanvas();
              getStudentWork(false, true);
              setIsPageScrolled(true);
              setTimeout(() => {
                setIsPageScrolled(false);
                setCurrentPageNumber(
                  (currentPageNumber) => currentPageNumber + 1
                );
              }, 2000);
            }
          }
        }
      }
    } else {
      //Check multipage or not
      if (isMultipage && activityDataFromParent.OtherActivities) {
        ////Display submit pop up if it is last page
        if (
          currentPageNumber + 1 ===
          activityDataFromParent.OtherActivities.length
        ) {
          if (Completed === 0 && isActive) {
            if (isPageNavigated) {
            } else {
              setDisplayActivityCompletePopup(true);
            }
          } else {
            setDisplayActivityCompletePopup(false);
          }
        } else {
          setDisplayActivityCompletePopup(false);
          if (
            currentPageNumber <
            activityDataFromParent.OtherActivities.length - 1
          ) {
            if (isPageReopened) {
            } else {
              // setDisplayComponents(false);
              setIsMultipageActive(true);
              clearCanvas();
              getStudentWork(false, true);
              setIsPageScrolled(true);
              setTimeout(() => {
                setIsPageScrolled(false);
                setCurrentPageNumber(
                  (currentPageNumber) => currentPageNumber + 1
                );
              }, 2000);
            }
            // if (allPagesData[currentPageNumber].WorkJson && !isPageScrolled) {
            //   //Move to next page when user attempt all the components in current
            //   let currentWorkJson = JSON.parse(
            //     allPagesData[currentPageNumber].WorkJson
            //   )[0];
            //   let currentPriorityActive = currentWorkJson.priorityCount;
            //   if (currentPriorityActive < smartPaperData.InputRows.length) {
            //     if (priorityActive > smartPaperData.InputRows.length) {
            //       setIsMultipageActive(true);
            //       clearCanvas();
            //       getStudentWork(false, true);
            //       setIsPageScrolled(true);
            //       setTimeout(() => {
            //         setIsPageScrolled(false);
            //       }, 2000);
            //       setCurrentPageNumber(
            //         (currentPageNumber) => currentPageNumber + 1
            //       );
            //     }
            //   } else {
            //     if (priorityActive > smartPaperData.InputRows.length) {
            //       setIsMultipageActive(true);
            //       clearCanvas();
            //       getStudentWork(false, true);
            //       setIsPageScrolled(true);
            //       setTimeout(() => {
            //         setIsPageScrolled(false);
            //       }, 2000);
            //       setCurrentPageNumber(
            //         (currentPageNumber) => currentPageNumber + 1
            //       );
            //     }
            //   }
            // } else {
            //   if (priorityActive > smartPaperData.InputRows.length) {
            //     setIsMultipageActive(true);
            //     clearCanvas();
            //     getStudentWork(false, true);
            //     setIsPageScrolled(true);
            //     setTimeout(() => {
            //       setIsPageScrolled(false);
            //     }, 2000);
            //     setCurrentPageNumber(
            //       (currentPageNumber) => currentPageNumber + 1
            //     );
            //   }
            // }
          }
        }
      } else {
        setDisplayActivityCompletePopup(true);
      }
    }
  }

  useEffect(() => {
    if (botTalking) {
    } else {
      if (document.getElementById("pnNo" + priorityActive)) {
        document.getElementById("pnNo" + priorityActive).focus();
        document.getElementById("pnNo" + priorityActive).click();
      }
    }
  }, [botTalking]);

  //Check next priority is input control
  useEffect(() => {
    if (priorityActive > 0) {
      let indexOfCurrentControl = smartPaperData.InputRows.findIndex(
        (obj) => obj.Priority === priorityActive
      );

      if (
        indexOfCurrentControl >= 0 &&
        smartPaperData &&
        smartPaperData.InputRows &&
        smartPaperData.InputRows[indexOfCurrentControl]
      ) {
        if (
          smartPaperData.InputRows[indexOfCurrentControl].PluginName ===
            "SSMultipleChoice" ||
          smartPaperData.InputRows[indexOfCurrentControl].PluginName ===
            "SSMultipleAnswer" ||
          smartPaperData.InputRows[indexOfCurrentControl].PluginName ===
            "SSTrueFalse" ||
          smartPaperData.InputRows[indexOfCurrentControl].PluginName ===
            "SSRotatingDial" ||
          smartPaperData.InputRows[indexOfCurrentControl].PluginName ===
            "SSFillinTheBlanks" ||
          smartPaperData.InputRows[indexOfCurrentControl].PluginName ===
            "SPHotspot" ||
          smartPaperData.InputRows[indexOfCurrentControl].PluginId ===
            "AGInput" ||
          smartPaperData.InputRows[indexOfCurrentControl].PluginId ===
            "AGTextList" ||
          smartPaperData.InputRows[indexOfCurrentControl].PluginId ===
            "AGInkList" ||
          smartPaperData.InputRows[indexOfCurrentControl].PluginId ===
            "PopupSlide" ||
          smartPaperData.InputRows[indexOfCurrentControl].PluginId ===
            "EnrichedPlayer" ||
          smartPaperData.InputRows[indexOfCurrentControl].PluginId ===
            "EnrichedAudio" ||
          smartPaperData.InputRows[indexOfCurrentControl].PluginId ===
            "MatchTable" ||
          smartPaperData.InputRows[indexOfCurrentControl].PluginId ===
            "Fraction" ||
          smartPaperData.InputRows[indexOfCurrentControl].PluginId ===
            "EquationEditor"
        ) {
        } else {
          if (
            smartPaperData.InputRows[indexOfCurrentControl].PluginId ===
            "RichText"
          ) {
            setInitial(true);
            setTimeout(() => {
              setInitial(false);
            }, 2000);
          }
        }
      } else {
      }
    }
  }, [priorityActive]);

  function renderFailureExternalPopup() {
    let urlText = "";
    if (failureExternalText !== "") {
      urlText = failureExternalText;
      if (urlText.includes("https://www.youtube.com/")) {
        let splitTextArr = urlText.split("https://www.youtube.com");
        urlText = "https://www.youtube.com/embed" + splitTextArr[1];
      } else if (urlText.includes("https://youtu.be/")) {
        let splitTextArr = urlText.split("https://youtu.be");
        urlText = "https://www.youtube.com/embed" + splitTextArr[1];
      }
    }
    return (
      <div
        style={{
          width: "100vw",
          height: "100vh",
          position: "absolute",
          top: 0,
          backgroundColor: "#00000080",
          zIndex: 10,
          alignSelf: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: fullscreenPopupVisible ? "100%" : "80%",
            height: fullscreenPopupVisible ? "100%" : "80%",
            backgroundColor: "white",
            borderRadius: "10px",
            padding: "1%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "10%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
              }}
            >
              <div
                style={{
                  width: "10%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setFullscreenPopupVisible(
                    (fullscreenPopupVisible) => !fullscreenPopupVisible
                  );
                }}
              >
                <FullscreenIcon
                  style={{
                    width: "30px",
                    height: "30px",
                    color: fullscreenPopupVisible ? "#0093d1" : "black",
                  }}
                />
                <p
                  style={{
                    margin: "0px",
                    color: "black",
                    fontSize: SMALL_DESKTOP,
                    color: fullscreenPopupVisible ? "#0093d1" : "black",
                  }}
                >
                  Fullscreen
                </p>
              </div>
            </div>
            <CloseIcon
              style={{
                width: "30px",
                height: "30px",
                cursor: "pointer",
                color: "black",
                zIndex: 4,
              }}
              onClick={() => {
                setFailureExternalText("");
                setFailurePopupVisible(false);
                setFullscreenPopupVisible(false);
              }}
            />
          </div>
          <span
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "#BDBDBD",
              marginBottom: "1%",
            }}
          />
          <iframe
            src={urlText}
            title="description"
            style={{ width: "100%", height: "90%" }}
          />
        </div>
      </div>
    );
  }

  //Expand strokes start drawing
  const startDrawingExpand = ({ nativeEvent }) => {
    if (currentMode === CANVAS_MODE.PEN && Completed === 0 && isActive) {
      isDrawing.current = true;
      const { offsetX, offsetY } = nativeEvent;
      expandContextRef.current.beginPath();
      expandPointsArray.push({ x: offsetX, y: offsetY });
      expandContextRef.current.moveTo(offsetX, offsetY);
      setstartTime(minutes + ":" + seconds);
    }
  };

  //Expand strokes finish drawing
  const finishDrawingExpand = () => {
    if (currentMode === CANVAS_MODE.PEN && isDrawing.current === true) {
      expandContextRef.current.closePath();
      isDrawing.current = false;
      let strokeArrayCopy = [...expandStrokeArray];
      let expandStrokeUuid = Date.now();
      if (expandPointsArray.length === 1) {
        expandPointsArray.push({
          x: expandPointsArray[0].x,
          y: expandPointsArray[0].y,
          isDragging: false,
        });
      }
      let dataValue = [];
      if (currentShape === SHAPE_NAME.LINE) {
        dataValue = convertToLine(expandPointsArray);
      } else if (currentShape === SHAPE_NAME.RECT) {
        dataValue = convertToRectangle(expandPointsArray);
      } else if (currentShape === SHAPE_NAME.CIRCLE) {
        dataValue = convertToCircle(expandPointsArray);
      } else {
        dataValue = expandPointsArray;
      }
      const stroke = {
        id: expandStrokeUuid,
        points: dataValue,
        color: strokeColor,
        width: strokeWidth,
        isDeleted: false,
        userId: user.LoginID,
        startTime: startTime,
        elapsedTime: minutes + ":" + seconds,
        replayBoxId: activeExpandBox,
        type:
          currentShape === SHAPE_NAME.PEN
            ? STROKE_TYPE.STROKE
            : STROKE_TYPE.SHAPE,
      };
      setstartTime("");
      strokeArrayCopy.push(stroke);
      setExpandStrokeArray(strokeArrayCopy);
      let strokeAction = {
        Action: "add",
        StrokeID: expandStrokeUuid,
        elapsedTime: minutes + ":" + seconds,
        replayBoxId: activeExpandBox,
      };
      let strokeActionsCopy = [...expandStrokeActions];
      strokeActionsCopy.push(strokeAction);
      setExpandStrokeActions(strokeActionsCopy);
      setExpandPointsArray([]);
      strokeArrayCopy = strokeArrayCopy.filter(
        (obj) => parseInt(obj.replayBoxId) === parseInt(activeExpandBox)
      );
      addAllPathsExpand(strokeArrayCopy, true);
      putParentStrokeWhenChange();
    }
  };

  //Expand strokes draw functionality
  const drawExpand = ({ nativeEvent }) => {
    if (currentMode === CANVAS_MODE.PEN) {
      if (!isDrawing.current) {
        return;
      }
      const { offsetX, offsetY } = nativeEvent;
      expandContextRef.current.lineTo(offsetX, offsetY);
      expandPointsArray.push({ x: offsetX, y: offsetY, isDragging: false });
      expandContextRef.current.stroke();
    }
  };

  const addPathExpand = (pointsArray) => {
    expandContextRef.current.beginPath();
    expandContextRef.current.moveTo(pointsArray[0].x, pointsArray[0].y);
    pointsArray.forEach((point) => {
      expandContextRef.current.lineTo(point.x, point.y);
      expandContextRef.current.stroke();
    });
    expandContextRef.current.closePath();
  };

  const clearExpandCanvas = () => {
    if (expandContextRef.current) {
      expandContextRef.current.clearRect(
        0,
        0,
        document.body.clientWidth,
        document.body.clientHeight
      );
    }
  };

  const addAllPathsExpand = (customArray, clear) => {
    if (clear) {
      clearExpandCanvas();
    }
    customArray.forEach((stroke) => {
      if (!stroke.isDeleted) {
        expandContextRef.current.strokeStyle = stroke.color;
        switch (stroke.width) {
          case 1.5:
            expandContextRef.current.lineWidth = STROKE_WIDTH.EXTRA_SMALL;
            break;
          case 3:
            expandContextRef.current.lineWidth = STROKE_WIDTH.SMALL;
            break;
          case 8:
            expandContextRef.current.lineWidth = STROKE_WIDTH.LARGE;
            break;
          case 10:
            expandContextRef.current.lineWidth = STROKE_WIDTH.LARGE;
            break;
          default:
            expandContextRef.current.lineWidth = STROKE_WIDTH.MEDIUM;
            break;
        }
        if (stroke.points.length > 0) {
          addPathExpand(stroke.points);
        }
        expandContextRef.current.strokeStyle = strokeColor;
        expandContextRef.current.lineWidth = strokeWidth;
      }
    });
  };

  const addAllPathsForReplayExpand = (customArray, clear) => {
    if (clear) {
      clearExpandCanvas();
    }
    customArray.forEach((stroke) => {
      expandContextRef.current.strokeStyle = stroke.color;
      switch (stroke.width) {
        case 1.5:
          expandContextRef.current.lineWidth = STROKE_WIDTH.EXTRA_SMALL;
          break;
        case 3:
          expandContextRef.current.lineWidth = STROKE_WIDTH.SMALL;
          break;
        case 8:
          expandContextRef.current.lineWidth = STROKE_WIDTH.LARGE;
          break;
        case 10:
          expandContextRef.current.lineWidth = STROKE_WIDTH.LARGE;
          break;
        default:
          expandContextRef.current.lineWidth = STROKE_WIDTH.MEDIUM;
          break;
      }
      if (stroke.points.length > 0) {
        addPathExpand(stroke.points);
      }
    });
  };

  function afterDeleteOtherStrokes() {
    if (expandStrokeArray.length > 0 && activeExpandBox) {
      let expandStrokeArrayCopy = [];
      for (const key in expandStrokeArray) {
        if (Object.prototype.hasOwnProperty.call(expandStrokeArray, key)) {
          if (expandStrokeArray[key].replayBoxId === activeExpandBox) {
            expandStrokeArrayCopy.push(expandStrokeArray[key]);
          }
        }
      }
      addAllPathsExpand(expandStrokeArrayCopy, false);
    }

    //Seperate teacher and student strokes for expandable screen
    let strokesInRectangle = replayRectangleObject[activeReplayBox.index];
    if (strokesInRectangle && strokesInRectangle.length > 0) {
      const allActions = [...smartPaperData.StrokeActions].concat(
        strokeActions
      );
      let strokeActionsInRectangle = allActions.filter((stroke) => {
        return strokesInRectangle.includes(parseInt(stroke.StrokeID));
      });
      let allReplayStrokes = [];
      for (let index = 0; index < strokeActionsInRectangle.length; index++) {
        const { StrokeID, Action } = strokeActionsInRectangle[index];
        if (Action === "add") {
          const strokeIndex = strokeArray.findIndex(
            (x) => parseInt(x.id) === parseInt(StrokeID)
          );
          if (strokeIndex >= 0) {
            allReplayStrokes.push(strokeArray[strokeIndex]);
          } else {
            const teacherStrokeIndex = editorStrokeData.findIndex(
              (x) => parseInt(x.id) === parseInt(StrokeID)
            );
            if (teacherStrokeIndex > -1) {
              allReplayStrokes.push(editorStrokeData[teacherStrokeIndex]);
            }
          }
        } else {
          allReplayStrokes = allReplayStrokes.filter(
            (obj) => parseInt(obj.id) !== parseInt(StrokeID)
          );
        }
      }
      const top =
        (parseFloat(activeReplayBox.rectangle.YAxis.split("%")[0]) *
          canvasDimension.height) /
        100;
      const left =
        (parseFloat(activeReplayBox.rectangle.XAxis.split("%")[0]) *
          canvasDimension.width) /
        100;
      let expandedStrokeCopy = [];
      for (let i = 0; i < allReplayStrokes.length; i++) {
        const editorStroke = { ...allReplayStrokes[i] };
        const expandedStroke = translateStroke(editorStroke, top, left);
        expandedStrokeCopy.push(expandedStroke);
      }
      addAllPathsExpand(expandedStrokeCopy, false);
    }
  }

  function putParentStrokeWhenChange() {
    //Seperate teacher and student strokes for expandable screen
    let strokesInRectangle = replayRectangleObject[activeReplayBox.index];
    if (strokesInRectangle && strokesInRectangle.length > 0) {
      const allActions = [...smartPaperData.StrokeActions].concat(
        strokeActions
      );
      let strokeActionsInRectangle = allActions.filter((stroke) => {
        return strokesInRectangle.includes(parseInt(stroke.StrokeID));
      });
      let allReplayStrokes = [];
      for (let index = 0; index < strokeActionsInRectangle.length; index++) {
        const { StrokeID, Action } = strokeActionsInRectangle[index];
        if (Action === "add") {
          const strokeIndex = strokeArray.findIndex(
            (x) => parseInt(x.id) === parseInt(StrokeID)
          );
          if (strokeIndex >= 0) {
            allReplayStrokes.push(strokeArray[strokeIndex]);
          } else {
            const teacherStrokeIndex = editorStrokeData.findIndex(
              (x) => parseInt(x.id) === parseInt(StrokeID)
            );
            if (teacherStrokeIndex > -1) {
              allReplayStrokes.push(editorStrokeData[teacherStrokeIndex]);
            }
          }
        } else {
          allReplayStrokes = allReplayStrokes.filter(
            (obj) => parseInt(obj.id) !== parseInt(StrokeID)
          );
        }
      }
      const top =
        (parseFloat(activeReplayBox.rectangle.YAxis.split("%")[0]) *
          canvasDimension.height) /
        100;
      const left =
        (parseFloat(activeReplayBox.rectangle.XAxis.split("%")[0]) *
          canvasDimension.width) /
        100;
      let expandedStrokeCopy = [];
      for (let i = 0; i < allReplayStrokes.length; i++) {
        const editorStroke = { ...allReplayStrokes[i] };
        const expandedStroke = translateStroke(editorStroke, top, left);
        expandedStrokeCopy.push(expandedStroke);
      }
      addAllPathsExpand(expandedStrokeCopy, false);
    }
  }

  //Select Expand strokes
  function selectExpandStroke(e) {
    if (currentMode === CANVAS_MODE.SELECT) {
      if (!expandRect.current) {
        expandRect.current = e.target.getBoundingClientRect();
      }
      var x = e.clientX - expandRect.current.left; //x position within the element.
      var y = e.clientY - expandRect.current.top; //y position within the element.
      let expandStrokeArrayCopy = [];
      for (const key in expandStrokeArray) {
        if (Object.prototype.hasOwnProperty.call(expandStrokeArray, key)) {
          if (expandStrokeArray[key].replayBoxId === activeExpandBox) {
            expandStrokeArrayCopy.push(expandStrokeArray[key]);
          }
        }
      }
      let allStrokes = [...expandStrokeArrayCopy];
      const closeStroke = nearestStroke(allStrokes, [x, y], 20);
      if (closeStroke && !closeStroke.isDeleted) {
        setSelectedStroke(closeStroke);
      }
    }
  }

  function renderExpandStrokeBorder() {
    return (
      currentMode === CANVAS_MODE.SELECT &&
      selectedStroke &&
      renderSelectedStroke(selectedStroke)
    );
  }

  function renderPopupExpand() {
    return (
      <div className="expand-container">
        <div
          style={{
            width: document.body.clientWidth,
            height: document.body.clientHeight,
            position: "relative",
          }}
        >
          {!isReplayHappening && (
            <div className="expand-close-icon">
              <Button
                className="replay-rectangle-prop-icons"
                hasIconOnly
                iconDescription="Close"
                renderIcon={Close}
                tooltipAlignment="center"
                tooltipPosition="bottom"
                onClick={() => {
                  setIsFloating(false);
                  setIsFloatingChild(false);
                  handleExpand();
                  putExpandStrokes(true);
                  if (isReplaySequenceTimerStart) {
                    setIsReplaySequence(true);
                  }
                }}
              />
            </div>
          )}
          <div
            style={{
              display: "flex",
              alignSelf: "center",
              width: "fit-content",
              position: "relative",
              height: "fit-content",
            }}
            onClick={(event) => {
              if (currentMode === CANVAS_MODE.SELECT) {
                selectExpandStroke(event);
              }
            }}
          >
            <canvas
              width={document.body.clientWidth}
              height={document.body.clientHeight}
              ref={expandCanvasRef}
              onMouseDown={(event) => {
                if (currentMode === CANVAS_MODE.SELECT && selectedStroke) {
                  myDownExpand(event);
                } else {
                  startDrawingExpand(event);
                }
              }}
              onMouseUp={(event) => {
                if (currentMode === CANVAS_MODE.SELECT && selectedStroke) {
                  myUpExpand(event);
                } else {
                  finishDrawingExpand(event);
                }
              }}
              onMouseMove={(event) => {
                if (currentMode === CANVAS_MODE.SELECT && selectedStroke) {
                  myMoveExpand(event);
                } else {
                  drawExpand(event);
                }
              }}
              onMouseOut={(event) => {
                if (currentMode === CANVAS_MODE.SELECT && selectedStroke) {
                  // myUpExpand(event);
                } else {
                  finishDrawingExpand(event);
                }
              }}
              style={{
                zIndex: 5,
                cursor:
                  currentMode === CANVAS_MODE.PEN && Completed === 0 && isActive
                    ? "crosshair"
                    : "default",
              }}
            />
            {expandImageCoordinates && (
              <div
                style={{
                  width: canvasDimension.width,
                  height: canvasDimension.height,
                  position: "absolute",
                }}
              >
                <div
                  style={{
                    width: canvasDimension.width,
                    height: canvasDimension.height,
                    top: "-" + expandImageCoordinates.top,
                    left: "-" + expandImageCoordinates.left,
                    display: "flex",
                    position: "absolute",
                    backgroundImage: `url(${smartPaperData.BackgroundImage})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    zIndex: 1,
                  }}
                >
                  <div
                    style={{
                      width: expandImageCoordinates.width + "%",
                      height: expandImageCoordinates.height + "%",
                      top: expandImageCoordinates.top,
                      left: expandImageCoordinates.left,
                      position: "absolute",
                    }}
                  />
                  <span
                    style={{
                      backgroundColor: smartPaperData.Opacity,
                      width: expandImageCoordinates.width + "%",
                      height: expandImageCoordinates.height + "%",
                      top: expandImageCoordinates.top,
                      left: expandImageCoordinates.left,
                      position: "absolute",
                      alignSelf: "center",
                    }}
                  />

                  <div
                    style={{
                      backgroundColor: "white",
                      top: expandImageCoordinates.box1Top
                        .toString()
                        .concat("%"),
                      height: (100 - expandImageCoordinates.box1Top)
                        .toString()
                        .concat("%"),
                      width: "100%",
                      position: "absolute",
                      zIndex: 999,
                    }}
                  />
                  <div
                    style={{
                      backgroundColor: "white",
                      left: expandImageCoordinates.box1Left
                        .toString()
                        .concat("%"),
                      height: "100%",
                      width: (100 - expandImageCoordinates.box1Left)
                        .toString()
                        .concat("%"),
                      position: "absolute",
                      zIndex: 999,
                    }}
                  />
                </div>
              </div>
            )}

            {/* Editor shapes */}
            {!isReplayHappening &&
              allShapesExpandDataArray.length > 0 &&
              allShapesExpandDataArray.map((shapesData, index) => {
                if (shapesData.ShapeType === "line") {
                  return (
                    <div
                      style={{
                        position: "absolute",
                        left: shapesData.ShapeLeft,
                        top: shapesData.ShapeTop,
                        transform: [
                          {
                            rotate:
                              shapesData.ShapeRotation.toString().concat("deg"),
                          },
                          { scaleX: shapesData.ScaleX },
                          { scaleY: shapesData.ScaleY },
                        ],
                        zIndex: 7,
                      }}
                    >
                      <svg
                        key={index.toString()}
                        height={shapesData.ShapeHeight + shapesData.Width}
                        width={shapesData.ShapeWidth + shapesData.Width}
                      >
                        <line
                          x1="0"
                          y1="0"
                          x2={shapesData.ShapeWidth}
                          y2={shapesData.ShapeHeight}
                          stroke={shapesData.Color}
                          strokeWidth={shapesData.Width}
                        />
                      </svg>
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={index.toString()}
                      style={{
                        width:
                          shapesData.ShapeType === "rect" ||
                          shapesData.ShapeType === "circle"
                            ? shapesData.ShapeWidth > 0
                              ? shapesData.ShapeWidth + shapesData.Width * 2
                              : 0
                            : shapesData.ShapeWidth,
                        height:
                          shapesData.ShapeType === "rect" ||
                          shapesData.ShapeType === "circle"
                            ? shapesData.ShapeHeight > 0
                              ? shapesData.ShapeHeight + shapesData.Width * 2
                              : 0
                            : shapesData.ShapeHeight,
                        top: shapesData.ShapeTop,
                        left: shapesData.ShapeLeft,
                        position: "absolute",
                        justifyContent: "center",
                        display: "flex",
                        backgroundColor:
                          shapesData.ShapeType === "line"
                            ? shapesData.Color
                            : "",
                        transform: `rotate(${
                          shapesData.ShapeRotation + "deg"
                        })`,
                        transform: `scale( ${shapesData.ScaleX}, ${shapesData.ScaleY} )`,
                        zIndex: 7,
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius:
                            shapesData.ShapeType === "circle" ? "50%" : 0,
                          justifyContent: "center",
                          display: "flex",
                          borderWidth:
                            shapesData.ShapeType === "line"
                              ? shapesData.Width / 2
                              : shapesData.Width,
                          borderColor: shapesData.Color,
                          borderStyle:
                            shapesData.ShapeWidth === 0 ||
                            shapesData.ShapeHeight === 0
                              ? "none"
                              : "solid",
                          backgroundColor:
                            shapesData.ShapeType === "line"
                              ? shapesData.Color
                              : "",
                        }}
                      />
                    </div>
                  );
                }
              })}

            {/* Teacher shapes Replay */}
            {isReplayHappening &&
              editorShapesReplayDataArray.length > 0 &&
              editorShapesReplayDataArray.map((shapesData, index) => {
                if (shapesData.ShapeType === "line") {
                  return (
                    <div
                      style={{
                        position: "absolute",
                        left: shapesData.ShapeLeft,
                        top: shapesData.ShapeTop,
                        transform: [
                          {
                            rotate:
                              shapesData.ShapeRotation.toString().concat("deg"),
                          },
                          { scaleX: shapesData.ScaleX },
                          { scaleY: shapesData.ScaleY },
                        ],
                        zIndex: 7,
                      }}
                    >
                      <svg
                        key={index.toString()}
                        height={shapesData.ShapeHeight + shapesData.Width}
                        width={shapesData.ShapeWidth + shapesData.Width}
                      >
                        <line
                          x1="0"
                          y1="0"
                          x2={shapesData.ShapeWidth}
                          y2={shapesData.ShapeHeight}
                          stroke={shapesData.Color}
                          strokeWidth={shapesData.Width}
                        />
                      </svg>
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={index.toString()}
                      style={{
                        width:
                          shapesData.ShapeType === "rect" ||
                          shapesData.ShapeType === "circle"
                            ? shapesData.ShapeWidth > 0
                              ? shapesData.ShapeWidth + shapesData.Width * 2
                              : 0
                            : shapesData.ShapeWidth,
                        height:
                          shapesData.ShapeType === "rect" ||
                          shapesData.ShapeType === "circle"
                            ? shapesData.ShapeHeight > 0
                              ? shapesData.ShapeHeight + shapesData.Width * 2
                              : 0
                            : shapesData.ShapeHeight,
                        top: shapesData.ShapeTop,
                        left: shapesData.ShapeLeft,
                        position: "absolute",
                        justifyContent: "center",
                        display: "flex",
                        backgroundColor:
                          shapesData.ShapeType === "line" ? "#000000" : "",
                        transform: `rotate(${
                          shapesData.ShapeRotation + "deg"
                        })`,
                        transform: `scale( ${shapesData.ScaleX}, ${shapesData.ScaleY} )`,
                        zIndex: 7,
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius:
                            shapesData.ShapeType === "circle" ? "50%" : 0,
                          justifyContent: "center",
                          display: "flex",
                          borderWidth:
                            shapesData.ShapeType === "line"
                              ? shapesData.Width / 2
                              : shapesData.Width,
                          borderColor: shapesData.Color,
                          borderStyle:
                            shapesData.ShapeWidth === 0 ||
                            shapesData.ShapeHeight === 0
                              ? "none"
                              : "solid",
                        }}
                      />
                    </div>
                  );
                }
              })}
            {renderExpandStrokeBorder()}
          </div>
        </div>
      </div>
    );
  }

  function handleExpandFloatingChildWidth(size) {
    if (size === "xs") {
      document.body.click();
      setStrokeWidth(STROKE_WIDTH.EXTRA_SMALL);
    } else if (size === "s") {
      document.body.click();
      setStrokeWidth(STROKE_WIDTH.SMALL);
    } else if (size === "m") {
      document.body.click();
      setStrokeWidth(STROKE_WIDTH.MEDIUM);
    } else if (size === "l") {
      document.body.click();
      setStrokeWidth(STROKE_WIDTH.LARGE);
    }
  }

  function handleExpandFloatingChildReplay(speed) {
    if (speed === "1/2x") {
      document.body.click();
      setcurrentSpeed(REPLAY_SPEED.HALFTIME);
    } else if (speed === "1x") {
      document.body.click();
      setcurrentSpeed(REPLAY_SPEED.ONETIME);
    } else if (speed === "2x") {
      document.body.click();
      setcurrentSpeed(REPLAY_SPEED.TWOTIMES);
    }
  }

  function handleFloatingClick(mode) {
    if (mode === CANVAS_MODE.PEN) {
      setShowHint(false);
      setShowWidth(false);
      setShowSelects(false);
      setCurrentAction(undefined);
      setSelectedStroke(undefined);
      if (Completed === 1 || !isActive || IsReadonly) {
        if (replayRectangleAudio) {
          replayRectangleAudio.pause();
          replayRectangleAudio.currentTime = 0;
          setReplayRectangleAudio(undefined);
          setIsAudioReplay(false);
          setIsInitialAudioPlay(false);
          clearTimeout(handleAudioTimeOut);
        }
        setShowAlertDone(true);
      } else {
        if (currentMode !== CANVAS_MODE.PEN) {
          togglePen();
        } else {
          setCurrentMode(undefined);
          setIsFloatingChild(false);
          setShowShapes(false);
        }
      }
    } else if (mode === CANVAS_MODE.SELECT) {
      document.body.click();
      setShowShapes(false);
      setShowWidth(false);
      setCurrentMode(CANVAS_MODE.SELECT);
      setIsFloatingChild(true);
      setShowSelects(true);
    } else if (mode === CANVAS_MODE.REPLAY) {
      setCurrentAction(undefined);
      setSelectedStroke(undefined);
      toggleReplayMode();
      setShowHint(false);
    } else if (mode === CANVAS_MODE.RECORD) {
      setAudioStop(true);
      if (currentMode !== CANVAS_MODE.RECORD) {
        setCurrentMode(CANVAS_MODE.RECORD);
        if (currentRecordedURL.current) {
        } else {
          if (Completed === 0 && isActive) {
            startRecording();
          } else {
            showOrHideToaster(true, "No recording available", "warning");
            setCurrentMode(CANVAS_MODE.PEN);
          }
        }
      }
      setShowHint(false);
      window.speechSynthesis.cancel();
    } else if (mode === CANVAS_MODE.LABEL) {
      setIsFloatingChild(false);
      setShowShapes(false);
      setShowWidth(false);
      setCurrentMode(CANVAS_MODE.LABEL);
      setShowSelects(false);
    }
  }

  function handleFloatingChildPen(shape) {
    if (shape === "pen") {
      document.body.click();
      setCurrentShape(SHAPE_NAME.PEN);
    } else if (shape === "line") {
      document.body.click();
      setCurrentShape(SHAPE_NAME.LINE);
    } else if (shape === "square") {
      document.body.click();
      setCurrentShape(SHAPE_NAME.RECT);
    } else if (shape === "circle") {
      document.body.click();
      setCurrentShape(SHAPE_NAME.CIRCLE);
    }
  }

  function renderWidths() {
    return (
      <div className="palette-stroke-size-container">
        <Button
          className={
            strokeWidth === STROKE_WIDTH.SMALL
              ? "tool-sub-icon tool-sub-icons-1 icons-small tool-sub-icons-1-selected"
              : "tool-sub-icon tool-sub-icons-1 icons-small"
          }
          hasIconOnly
          iconDescription="Small"
          renderIcon={CircleSolid}
          tooltipAlignment="center"
          tooltipPosition="top"
          onClick={() => {
            handleExpandFloatingChildWidth("s");
          }}
        />
        <Button
          className={
            strokeWidth === STROKE_WIDTH.MEDIUM
              ? "tool-sub-icon tool-sub-icons-1 icons-medium tool-sub-icons-1-selected"
              : "tool-sub-icon tool-sub-icons-1 icons-medium"
          }
          hasIconOnly
          iconDescription="Medium"
          renderIcon={CircleSolid}
          tooltipAlignment="center"
          tooltipPosition="top"
          onClick={() => {
            handleExpandFloatingChildWidth("m");
          }}
        />
        <Button
          className={
            strokeWidth === STROKE_WIDTH.LARGE
              ? "tool-sub-icon tool-sub-icons-1 tool-sub-icons-1-selected"
              : "tool-sub-icon tool-sub-icons-1"
          }
          hasIconOnly
          iconDescription="Large"
          renderIcon={CircleSolid}
          tooltipAlignment="center"
          tooltipPosition="top"
          onClick={() => {
            handleExpandFloatingChildWidth("l");
          }}
        />
      </div>
    );
  }

  function renderShapeChildContainer() {
    return (
      <div
        className={
          isFloating ? "palette-div-1 bounceInUpToolbar" : "palette-div-1"
        }
        style={{
          borderRadius: "8px",
          pointerEvents: displayWalkThrough ? "none" : "auto",
        }}
      >
        {renderWidths()}
        <div className="palette-stroke-size-container">
          <Button
            className={
              currentShape === SHAPE_NAME.RECT
                ? "tool-sub-icon tool-sub-icons-2 tool-sub-icons-2-selected"
                : "tool-sub-icon tool-sub-icons-2"
            }
            hasIconOnly
            iconDescription="Square"
            renderIcon={SquareFill}
            tooltipAlignment="center"
            tooltipPosition="top"
            onClick={() => {
              handleFloatingChildPen("square");
            }}
          />
          <Button
            className={
              currentShape === SHAPE_NAME.CIRCLE
                ? "tool-sub-icon tool-sub-icons-2 tool-sub-icons-2-selected"
                : "tool-sub-icon tool-sub-icons-2"
            }
            hasIconOnly
            iconDescription="Circle"
            renderIcon={CircleSolid}
            tooltipAlignment="center"
            tooltipPosition="top"
            onClick={() => {
              handleFloatingChildPen("circle");
            }}
          />
          <Button
            className={
              currentShape === SHAPE_NAME.LINE
                ? "tool-sub-icon tool-sub-icons-2 tool-sub-icons-2-selected"
                : "tool-sub-icon tool-sub-icons-2"
            }
            hasIconOnly
            iconDescription="Line"
            renderIcon={DirectionStraightRight}
            tooltipAlignment="center"
            tooltipPosition="top"
            onClick={() => {
              handleFloatingChildPen("line");
            }}
          />
        </div>
        <div className="palette-stroke-color-container">
          <div
            className={
              strokeColor === "#000000"
                ? "color-circle-outer color-circle-outer-selected"
                : "color-circle-outer"
            }
            onClick={() => {
              setStrokeColor("#000000");
            }}
          >
            <div
              className="color-circle"
              style={{ backgroundColor: "#000000" }}
            />
          </div>
          <div
            className={
              strokeColor === "#4922fd"
                ? "color-circle-outer color-circle-outer-selected"
                : "color-circle-outer"
            }
            onClick={() => {
              setStrokeColor("#4922fd");
            }}
          >
            <div
              className="color-circle"
              style={{ backgroundColor: "#4922fd" }}
            />
          </div>
          <div
            className={
              strokeColor === "#df3428"
                ? "color-circle-outer color-circle-outer-selected"
                : "color-circle-outer"
            }
            onClick={() => {
              setStrokeColor("#df3428");
            }}
          >
            <div
              className="color-circle"
              style={{ backgroundColor: "#df3428" }}
            />
          </div>
          <div
            className={
              strokeColor === "#ffc42d"
                ? "color-circle-outer color-circle-outer-selected"
                : "color-circle-outer"
            }
            onClick={() => {
              setStrokeColor("#ffc42d");
            }}
          >
            <div
              className="color-circle"
              style={{ backgroundColor: "#ffc42d" }}
            />
          </div>
        </div>
      </div>
    );
  }
  function renderPenChildContainer() {
    return (
      <div
        className={
          isFloating ? "palette-div-1 bounceInUpToolbar" : "palette-div-1"
        }
        style={{ pointerEvents: displayWalkThrough ? "none" : "auto" }}
      >
        {renderWidths()}
        <div className="palette-stroke-color-container">
          <div
            className={
              strokeColor === "#000000"
                ? "color-circle-outer color-circle-outer-selected"
                : "color-circle-outer"
            }
            onClick={() => {
              setStrokeColor("#000000");
            }}
          >
            <div
              className="color-circle"
              style={{ backgroundColor: "#000000" }}
            />
          </div>
          <div
            className={
              strokeColor === "#4922fd"
                ? "color-circle-outer color-circle-outer-selected"
                : "color-circle-outer"
            }
            onClick={() => {
              setStrokeColor("#4922fd");
            }}
          >
            <div
              className="color-circle"
              style={{ backgroundColor: "#4922fd" }}
            />
          </div>
          <div
            className={
              strokeColor === "#df3428"
                ? "color-circle-outer color-circle-outer-selected"
                : "color-circle-outer"
            }
            onClick={() => {
              setStrokeColor("#df3428");
            }}
          >
            <div
              className="color-circle"
              style={{ backgroundColor: "#df3428" }}
            />
          </div>
          <div
            className={
              strokeColor === "#ffc42d"
                ? "color-circle-outer color-circle-outer-selected"
                : "color-circle-outer"
            }
            onClick={() => {
              setStrokeColor("#ffc42d");
            }}
          >
            <div
              className="color-circle"
              style={{ backgroundColor: "#ffc42d" }}
            />
          </div>
        </div>
      </div>
    );
  }

  function renderLabelChildContainer() {
    return (
      <div
        className={
          isFloating ? "palette-div-1 bounceInUpToolbar" : "palette-div-1"
        }
        style={{
          borderRadius: "8px",
          pointerEvents: displayWalkThrough ? "none" : "auto",
        }}
      >
        <div className="palette-stroke-size-container">
          <Button
            className={
              selectedLabel &&
              colorPickerType &&
              colorPickerType === "textColor"
                ? "shape-div shape-div-selected"
                : "shape-div"
            }
            hasIconOnly
            iconDescription="Text Color"
            renderIcon={TextColor}
            tooltipAlignment="center"
            tooltipPosition="top"
            onClick={() => {
              setColorPickerType("textColor");
            }}
          />
          <Button
            className={
              selectedLabel && selectedLabel.underline
                ? "shape-div shape-div-selected"
                : "shape-div"
            }
            hasIconOnly
            iconDescription="Underline"
            renderIcon={TextUnderline}
            tooltipAlignment="center"
            tooltipPosition="top"
            onClick={() => {
              handleLabeltextChange("underline");
              setColorPickerType(undefined);
            }}
          />
          <Button
            className={
              selectedLabel && selectedLabel.italic
                ? "shape-div shape-div-selected"
                : "shape-div"
            }
            hasIconOnly
            iconDescription="Italic"
            renderIcon={TextItalic}
            tooltipAlignment="center"
            tooltipPosition="top"
            onClick={() => {
              handleLabeltextChange("italic");
              setColorPickerType(undefined);
            }}
          />
          <Button
            className={
              selectedLabel && selectedLabel.bold
                ? "shape-div shape-div-selected"
                : "shape-div"
            }
            hasIconOnly
            iconDescription="Bold"
            renderIcon={TextBold}
            tooltipAlignment="center"
            tooltipPosition="top"
            onClick={() => {
              handleLabeltextChange("bold");
              setColorPickerType(undefined);
            }}
          />
        </div>
        <div className="palette-stroke-size-container">
          <Button
            className={
              selectedLabel &&
              colorPickerType &&
              colorPickerType === "fillColor"
                ? "shape-div shape-div-selected"
                : "shape-div"
            }
            hasIconOnly
            iconDescription="Text Fill"
            renderIcon={TextFill}
            tooltipAlignment="center"
            tooltipPosition="top"
            onClick={() => {
              setColorPickerType("fillColor");
            }}
          />
          <Button
            className={
              selectedLabel && selectedLabel.textAlign === "left"
                ? "shape-div shape-div-selected"
                : "shape-div"
            }
            hasIconOnly
            iconDescription="Left"
            renderIcon={TextAlignLeft}
            tooltipAlignment="center"
            tooltipPosition="top"
            onClick={() => {
              handleLabeltextChange("align", "left");
              setColorPickerType(undefined);
            }}
          />
          <Button
            className={
              selectedLabel && selectedLabel.textAlign === "center"
                ? "shape-div shape-div-selected"
                : "shape-div"
            }
            hasIconOnly
            iconDescription="Center"
            renderIcon={TextAlignCenter}
            tooltipAlignment="center"
            tooltipPosition="top"
            onClick={() => {
              handleLabeltextChange("align", "center");
              setColorPickerType(undefined);
            }}
          />
          <Button
            className={
              selectedLabel && selectedLabel.textAlign === "right"
                ? "shape-div shape-div-selected"
                : "shape-div"
            }
            hasIconOnly
            iconDescription="Right"
            renderIcon={TextAlignRight}
            tooltipAlignment="center"
            tooltipPosition="top"
            onClick={() => {
              handleLabeltextChange("align", "right");
              setColorPickerType(undefined);
            }}
          />
        </div>
        <div className="palette-stroke-color-container">
          <Button
            className={
              isDeleteClicked ? "shape-div shape-div-selected" : "shape-div"
            }
            hasIconOnly
            iconDescription="Clear"
            renderIcon={Reset}
            tooltipAlignment="center"
            tooltipPosition="top"
            onClick={() => {
              if (selectedLabel) {
                setColorPickerType(undefined);
                setIsClearClicked(true);
                handleLabeltextChange("clear");
                setTimeout(() => {
                  setIsClearClicked(false);
                }, 200);
              } else {
                showOrHideToaster(true, "Select label to clear", "warning");
              }
            }}
          />
          <Button
            className={
              isDeleteClicked ? "shape-div shape-div-selected" : "shape-div"
            }
            hasIconOnly
            iconDescription="Delete"
            renderIcon={TrashCan}
            tooltipAlignment="center"
            tooltipPosition="top"
            onClick={() => {
              if (selectedLabel) {
                setColorPickerType(undefined);
                setIsDeleteClicked(true);
                handleLabeltextChange("delete");
                setTimeout(() => {
                  setIsDeleteClicked(false);
                }, 200);
              } else {
                showOrHideToaster(true, "Select label to delete", "warning");
              }
            }}
          />
        </div>
      </div>
    );
  }

  function renderReplayChildContainer() {
    return (
      <div
        className={
          isFloating ? "palette-div-1 bounceInUpToolbar" : "palette-div-1"
        }
        style={{ pointerEvents: displayWalkThrough ? "none" : "auto" }}
      >
        <div className="palette-stroke-size-container">
          <div
            className="size-div"
            onClick={() => {
              togglePausePlay();
            }}
          >
            {isPaused ? (
              <PlayCircleRoundedIcon
                style={{ width: "30px", height: "30px", color: "#4922fd" }}
              />
            ) : (
              <PauseCircleFilledRoundedIcon
                style={{ width: "30px", height: "30px", color: "#4922fd" }}
              />
            )}
          </div>
          <div
            className="size-div"
            onClick={() => {
              doFastFwd();
            }}
          >
            <SkipNextRoundedIcon
              style={{ width: "30px", height: "30px", color: "#4922fd" }}
            />
          </div>
        </div>
        <div className="palette-stroke-size-container">
          <div
            className={
              currentSpeed === REPLAY_SPEED.HALFTIME
                ? "speed-div speed-div-selected"
                : "speed-div"
            }
            style={{
              color:
                currentSpeed === REPLAY_SPEED.HALFTIME ? "#ffffff" : "#000000",
              fontSize: "12px",
              fontFamily: "Manrope",
            }}
            onClick={() => {
              handleExpandFloatingChildReplay("1/2x");
            }}
          >
            0.5x
          </div>
          <div
            className={
              currentSpeed === REPLAY_SPEED.ONETIME
                ? "speed-div speed-div-selected"
                : "speed-div"
            }
            style={{
              color:
                currentSpeed === REPLAY_SPEED.ONETIME ? "#ffffff" : "#000000",
              fontSize: "12px",
              fontFamily: "Manrope",
            }}
            onClick={() => {
              handleExpandFloatingChildReplay("1x");
            }}
          >
            1x
          </div>
          <div
            className={
              currentSpeed === REPLAY_SPEED.TWOTIMES
                ? "speed-div speed-div-selected"
                : "speed-div"
            }
            style={{
              color:
                currentSpeed === REPLAY_SPEED.TWOTIMES ? "#ffffff" : "#000000",
              fontSize: "12px",
              fontFamily: "Manrope",
            }}
            onClick={() => {
              handleExpandFloatingChildReplay("2x");
            }}
          >
            2x
          </div>
        </div>
      </div>
    );
  }

  function renderRecordingChildContainer() {
    return (
      <div
        className={
          isFloating ? "palette-div-1 bounceInUpToolbar" : "palette-div-1"
        }
        style={{ pointerEvents: displayWalkThrough ? "none" : "auto" }}
      >
        <div className="palette-stroke-size-container">
          <div className="palette-recording-labe-container">
            <span className="palette-recording-label">
              {!isRecording && currentRecordedURL.current
                ? "Playing"
                : "Recording"}
              <span className="palette-recording-label recording-labeltimer">
                {" "}
                {currentRecordedURL.current
                  ? getTime(currentRecordTime) + " / " + getTime(recordDuration)
                  : getTimeForRecordingUI()}
              </span>
            </span>
          </div>
          {!isRecording && currentRecordedURL.current && (
            <span>
              {Completed === 0 && (
                <div
                  className="size-div"
                  onClick={() => {
                    if (currentRecordedAudioPlayer.current) {
                      currentRecordedAudioPlayer.current.pause();
                      setIsRecordPlaying(false);
                    }
                    setIsRecordDeleteClick(true);
                    setIsRecording(false);
                  }}
                >
                  <DeleteRoundedIcon
                    style={{
                      width: "20px",
                      height: "20px",
                      color: "#4922fd",
                    }}
                  />
                </div>
              )}
            </span>
          )}
        </div>
      </div>
    );
  }

  function renderPalletePop() {
    return (
      <div
        className="palette-container"
        style={{
          justifyContent: isReplayHappening || !isFloating ? "end" : "unset",
          bottom: 0,
        }}
      >
        {isFloating ? (
          currentMode === CANVAS_MODE.PEN ? (
            currentShape === SHAPE_NAME.PEN ? (
              renderPenChildContainer()
            ) : (
              renderShapeChildContainer()
            )
          ) : currentMode === CANVAS_MODE.RECORD ? (
            renderRecordingChildContainer()
          ) : currentMode === CANVAS_MODE.REPLAY || isReplayHappening ? (
            renderReplayChildContainer()
          ) : currentMode === CANVAS_MODE.LABEL && selectedLabel ? (
            renderLabelChildContainer()
          ) : (
            <div
              className="palette-div-1 bounceInUpToolbar"
              style={{ borderRadius: "15px" }}
            />
          )
        ) : (
          <div
            className="palette-div-1 bounceInUpToolbar"
            style={{ height: isFloating ? "40%" : "" }}
          />
        )}
        <div
          className={
            isFloating
              ? "palette-div-2 bounceInUpToolbar"
              : isBgAudioPlayed
              ? "palette-div-2"
              : "palette-div-2 bounceInUp"
          }
          style={{
            width: isFloating ? undefined : "300px",
            height: isFloating ? "50%" : "20px",
            display: isReplayHappening ? "none" : "flex",
            borderRadius: isFloating ? "8px" : "8px 8px 0px 0px",
            zIndex:
              displayActivityCompletePopup || displayReplayDonePopup ? 6 : 21,
          }}
        >
          {isFloating && (
            <div className="second-container-div1">
              <div className="pen-mode-container">
                <img
                  src={
                    strokeColor === "#4922fd"
                      ? Images.stroke_pen_blue
                      : strokeColor === "#df3428"
                      ? Images.stroke_pen_red
                      : strokeColor === "#ffc42d"
                      ? Images.stroke_pen_yellow
                      : Images.stroke_pen_black
                  }
                  style={{
                    height:
                      currentMode === CANVAS_MODE.PEN &&
                      currentShape === SHAPE_NAME.PEN
                        ? "80px"
                        : "70px",
                    display: "flex",
                    alignSelf: "end",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (!isRecording && !isRecordPlaying) {
                      setSelectedStroke(undefined);
                      setSelectedLabel(undefined);
                      setColorPickerType(undefined);
                      setCurrentMode(CANVAS_MODE.PEN);
                      setCurrentShape(SHAPE_NAME.PEN);
                      handleExpandFloatingChildWidth("m");
                    }
                  }}
                />
              </div>
              <div className="parent-select-container">
                <div
                  className={
                    Completed === 1 ||
                    !isActive ||
                    isRecording ||
                    isRecordPlaying
                      ? "tooltip-container parent-container cursor-disable"
                      : currentMode === CANVAS_MODE.PEN &&
                        currentShape !== SHAPE_NAME.PEN
                      ? "tooltip-container parent-container parent-container-selected"
                      : "tooltip-container parent-container"
                  }
                  onClick={() => {
                    if (!isRecording && !isRecordPlaying) {
                      setSelectedStroke(undefined);
                      setSelectedLabel(undefined);
                      setColorPickerType(undefined);
                      setCurrentMode(CANVAS_MODE.PEN);
                      handleFloatingChildPen("square");
                      handleExpandFloatingChildWidth("m");
                    }
                  }}
                >
                  <img
                    src={
                      Completed === 1 ||
                      !isActive ||
                      isRecording ||
                      isRecordPlaying
                        ? Images.shape_disable
                        : currentMode === CANVAS_MODE.PEN &&
                          currentShape !== SHAPE_NAME.PEN
                        ? Images.shape_select
                        : Images.shape_unselect
                    }
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "contain",
                    }}
                  />
                  <span class="tooltiptext">Shapes</span>
                </div>
                <div
                  className={
                    Completed === 1 ||
                    !isActive ||
                    isRecording ||
                    isRecordPlaying
                      ? "tooltip-container parent-container cursor-disable"
                      : currentMode === CANVAS_MODE.SELECT
                      ? "tooltip-container parent-container parent-container-selected"
                      : "tooltip-container parent-container"
                  }
                  onClick={() => {
                    if (
                      Completed === 0 &&
                      isActive &&
                      !isRecording &&
                      !isRecordPlaying
                    ) {
                      handleFloatingClick(CANVAS_MODE.SELECT);
                      setColorPickerType(undefined);
                    }
                  }}
                >
                  <img
                    src={
                      Completed === 1 ||
                      !isActive ||
                      isRecording ||
                      isRecordPlaying
                        ? Images.select_arrow_disable
                        : currentMode === CANVAS_MODE.SELECT
                        ? Images.select_arrow_select
                        : Images.select_arrow_unselect
                    }
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "contain",
                    }}
                  />
                  <span class="tooltiptext">Select</span>
                </div>
                <div
                  className={
                    Completed === 1 ||
                    !isActive ||
                    isRecording ||
                    isRecordPlaying ||
                    isExpandableView
                      ? "tooltip-container parent-container cursor-disable"
                      : currentMode === CANVAS_MODE.LABEL
                      ? "tooltip-container parent-container parent-container-selected"
                      : "tooltip-container parent-container"
                  }
                  onClick={() => {
                    if (
                      Completed === 0 &&
                      isActive &&
                      !isRecording &&
                      !isRecordPlaying &&
                      !isExpandableView
                    ) {
                      setIsFloatingChild(false);
                      handleFloatingClick(CANVAS_MODE.LABEL);
                    }
                  }}
                >
                  <img
                    src={
                      Completed === 1 ||
                      !isActive ||
                      isRecording ||
                      isRecordPlaying ||
                      isExpandableView
                        ? Images.label_add_disable
                        : currentMode === CANVAS_MODE.LABEL
                        ? Images.label_add_select
                        : Images.label_add_unselect
                    }
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "contain",
                    }}
                  />
                  <span class="tooltiptext">Add Label</span>
                </div>
              </div>

              <div className="mic-replay-container">
                {!isRecording && !currentRecordedURL.current ? (
                  <div
                    className={
                      Completed === 1 ||
                      !isActive ||
                      isRecording ||
                      isRecordPlaying ||
                      isExpandableView ||
                      isContained
                        ? "tooltip-container parent-container cursor-disable"
                        : currentMode === CANVAS_MODE.RECORD
                        ? "tooltip-container parent-container parent-container-selected"
                        : "tooltip-container parent-container"
                    }
                    onClick={() => {
                      if (
                        Completed === 0 &&
                        isActive &&
                        !isExpandableView &&
                        !isContained
                      ) {
                        setSelectedStroke(undefined);
                        setSelectedLabel(undefined);
                        setColorPickerType(undefined);
                        handleFloatingClick(CANVAS_MODE.RECORD);
                      }
                    }}
                  >
                    <img
                      src={
                        Completed || !isActive || isExpandableView
                          ? Images.voice_recordning_disable
                          : Images.voice_recordning
                      }
                      style={{
                        width: "30px",
                        height: "30px",
                        objectFit: "contain",
                      }}
                    />
                    <span class="tooltiptext">Voice Record</span>
                  </div>
                ) : isRecording ? (
                  <div
                    className={
                      currentMode === CANVAS_MODE.RECORD
                        ? "tooltip-container parent-container parent-container-selected"
                        : "tooltip-container parent-container"
                    }
                    onClick={() => {
                      stopRecording();
                    }}
                  >
                    <div
                      className="color-circle-outer color-circle-outer-selected"
                      style={{
                        borderColor: "#EE3A24",
                        width: "35px",
                        height: "35px",
                        margin: "0px",
                      }}
                    >
                      <div
                        className="color-circle circle-medium"
                        style={{
                          backgroundColor: "#EE3A24",
                          width: "25px",
                          height: "25px",
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div
                    className={
                      currentMode === CANVAS_MODE.RECORD
                        ? "tooltip-container parent-container parent-container-selected"
                        : "tooltip-container parent-container"
                    }
                    onClick={() => {
                      handleFloatingClick(CANVAS_MODE.RECORD);
                      setSelectedStroke(undefined);
                      setSelectedLabel(undefined);
                      setColorPickerType(undefined);
                      if (currentRecordedURL.current) {
                        if (!isRecordPlaying) {
                          currentRecordedAudioPlayer.current = new Audio(
                            currentRecordedURL.current
                          );

                          const playPromise =
                            currentRecordedAudioPlayer.current.play();

                          if (playPromise !== undefined) {
                            playPromise
                              .then((data) => {
                                console.log(
                                  "audio played auto",
                                  currentRecordedAudioPlayer.current
                                );
                              })
                              .catch((error) => {
                                console.log("playback prevented");
                                currentRecordedURL.current = undefined;
                              });
                          }
                          setIsRecordPlaying(true);
                        } else {
                          currentRecordedAudioPlayer.current.pause();
                          setIsRecordPlaying(false);
                          setTimeout(() => {
                            setCurrentRecordTime(0);
                          }, 700);
                        }
                      }
                    }}
                  >
                    {isRecordPlaying ? (
                      <StopCircleRoundedIcon
                        style={{
                          width: "30px",
                          height: "30px",
                          color: "#4922fd",
                        }}
                      />
                    ) : (
                      <PlayCircleRoundedIcon
                        style={{
                          width: "30px",
                          height: "30px",
                          color: "#4922fd",
                        }}
                      />
                    )}
                  </div>
                )}

                <div
                  className={
                    currentMode === CANVAS_MODE.REPLAY
                      ? "tooltip-container parent-container parent-container-selected"
                      : "tooltip-container parent-container"
                  }
                  onClick={() => {
                    if (!isRecording && !isRecordPlaying && !isExpandableView) {
                      setSelectedStroke(undefined);
                      setSelectedLabel(undefined);
                      setColorPickerType(undefined);
                      handleFloatingClick(CANVAS_MODE.REPLAY);
                    }
                  }}
                >
                  <img
                    src={
                      currentMode === CANVAS_MODE.REPLAY
                        ? Images.replay_select
                        : Images.replay_unselect
                    }
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "contain",
                    }}
                  />
                  <span class="tooltiptext">Replay</span>
                </div>
              </div>
            </div>
          )}
        </div>
        {!isReplayHappening && (
          <div
            className="pallete-collapse"
            onClick={() => {
              if (isBgAudioPlayed) {
                setIsFloating((floating) => !floating);
              }
            }}
            style={{
              zIndex:
                displayActivityCompletePopup || displayReplayDonePopup ? 6 : 21,
            }}
          >
            {isFloating ? (
              <ArrowDropDownRoundedIcon
                style={{
                  width: "25px",
                  height: "25px",
                  color: "#ffffff",
                }}
              />
            ) : (
              <ArrowDropUpRoundedIcon
                style={{
                  width: "25px",
                  height: "25px",
                  color: "#ffffff",
                }}
              />
            )}
          </div>
        )}
      </div>
    );
  }

  function renderPalleteWakthroughPop() {
    return (
      <div
        className="palette-container"
        style={{
          justifyContent: isReplayHappening || !isFloating ? "end" : "unset",
          bottom: 0,
          zIndex:
            displayWalkThrough && currentWalkThroughStep < 3 ? 0 : undefined,
        }}
      >
        {currentWalkThroughStep === 5 ? (
          renderPenChildContainer()
        ) : currentWalkThroughStep === 6 ? (
          renderShapeChildContainer()
        ) : currentWalkThroughStep === 8 ? (
          renderRecordingChildContainer()
        ) : currentWalkThroughStep === 9 ? (
          renderReplayChildContainer()
        ) : (
          <div
            className="palette-div-1 bounceInUpToolbar"
            style={{ borderRadius: "15px" }}
          />
        )}
        <div
          className="palette-div-2"
          style={{
            width: currentWalkThroughStep > 2 ? undefined : "300px",
            height: currentWalkThroughStep > 2 ? "50%" : "20px",
            display: isReplayHappening ? "none" : "flex",
            borderRadius:
              currentWalkThroughStep > 2 ? "15px" : "15px 15px 0px 0px",
          }}
        >
          {currentWalkThroughStep > 3 && currentWalkThroughStep < 10 && (
            <div className="second-container-div1">
              <div className="pen-mode-container">
                <img
                  src={Images.stroke_pen}
                  style={{
                    height: currentWalkThroughStep === 5 ? "80px" : "70px",
                    display: "flex",
                    alignSelf: "end",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (!isRecording && !isRecordPlaying) {
                      setSelectedStroke(undefined);
                      setCurrentMode(CANVAS_MODE.PEN);
                      setCurrentShape(SHAPE_NAME.PEN);
                      handleExpandFloatingChildWidth("m");
                    }
                  }}
                />
              </div>
              <div
                className={
                  currentWalkThroughStep === 6
                    ? "parent-container parent-container-selected"
                    : "parent-container"
                }
              >
                <img
                  src={
                    currentWalkThroughStep === 6
                      ? Images.shape_select
                      : Images.shape_unselect
                  }
                  style={{
                    width: "30px",
                    height: "30px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div className="parent-select-container">
                <div
                  className={
                    currentWalkThroughStep === 7
                      ? "parent-container parent-container-selected"
                      : "parent-container"
                  }
                >
                  <img
                    src={Images.select_arrow_unselect}
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
              <div className="mic-replay-container">
                <div
                  className={
                    currentWalkThroughStep === 8
                      ? "parent-container parent-container-selected"
                      : "parent-container"
                  }
                >
                  <MicRoundedIcon
                    style={{
                      width: "25px",
                      height: "25px",
                      color: "#000000",
                    }}
                  />
                </div>

                <div
                  className={
                    currentWalkThroughStep === 9
                      ? "parent-container parent-container-selected"
                      : "parent-container"
                  }
                >
                  <img
                    src={
                      currentMode === CANVAS_MODE.REPLAY
                        ? Images.replay_select
                        : Images.replay_unselect
                    }
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        {currentWalkThroughStep > 3 && currentWalkThroughStep < 10 && (
          <div
            style={{
              position: "absolute",
              bottom: 0,
              height:
                currentWalkThroughStep === 4 || currentWalkThroughStep === 7
                  ? "60%"
                  : "100%",
              width: currentWalkThroughStep === 6 ? "35%" : "30%",
              backgroundColor: "lightgray",
              zIndex: 20,
              borderRadius: "10px",
            }}
          ></div>
        )}
      </div>
    );
  }

  function renderVideoPopupSlide() {
    return (
      <div
        style={{
          backgroundColor: "white",
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          zIndex: 9999,
        }}
      >
        <div
          style={{ backgroundColor: "white", width: "100%", height: "100%" }}
        >
          <KnovoActivityScreen
            isContained={true}
            closeContained={(status) => {
              setIsGuidedClicked(false);
              setShowHideLoader(false);
              setisPopupSlideVisible(false);
              let allMarkerStatusCopy = {
                ...allMarkerStatus,
              };
              allMarkerStatusCopy[currentContainedID.current] = "working";
              setAllMarkerStatus(allMarkerStatusCopy);
              handleSmartVideoJson(
                allMarkerStatusCopy,
                currentVideoPlayer.current
              );
              if (currentPopupValue.current === "popupSlide") {
                if (isGuidedClicked) {
                } else {
                  if (FollowTheFlow) {
                    let markerStatusList =
                      smartVideoStatus[currentVideoPlayer.current];
                    let checkMarkPresent =
                      markerStatusList &&
                      markerStatusList.hasOwnProperty(
                        currentContainedID.current
                      );

                    if (checkMarkPresent) {
                      if (currentVideoPlayer.current) {
                        let indexOfCurrentControl =
                          smartPaperData.InputRows.findIndex(
                            (obj) =>
                              obj.ControlID === currentVideoPlayer.current
                          );

                        if (
                          indexOfCurrentControl >= 0 &&
                          smartPaperData &&
                          smartPaperData.InputRows &&
                          smartPaperData.InputRows[indexOfCurrentControl]
                        ) {
                          if (
                            priorityActive <=
                            smartPaperData.InputRows[indexOfCurrentControl]
                              .Priority
                          ) {
                            setPriorityActive(
                              (priorityActive) => priorityActive + 1
                            );
                          }
                        }
                      }
                    } else {
                      setPriorityActive((priorityActive) => priorityActive + 1);
                    }
                  }
                }

                currentContainedID.current = undefined;
                currentPopupValue.current = undefined;
                setVideoResume(false);
              } else {
                setVideoResume(true);
              }
            }}
          />
        </div>
      </div>
    );
  }

  function renderExternalPopup() {
    let urlText = "";
    if (currentPopupValue.current) {
      urlText = currentPopupValue.current.MarkerValue;
      if (urlText.includes("https://www.youtube.com/")) {
        let splitTextArr = urlText.split("https://www.youtube.com");
        urlText = "https://www.youtube.com/embed" + splitTextArr[1];
      } else if (urlText.includes("https://youtu.be/")) {
        let splitTextArr = urlText.split("https://youtu.be");
        urlText = "https://www.youtube.com/embed" + splitTextArr[1];
      }
    }
    return (
      <div
        style={{
          width: "100vw",
          height: "100vh",
          position: "absolute",
          top: 0,
          backgroundColor: "#00000080",
          zIndex: 10,
          alignSelf: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "80%",
            height: "80%",
            backgroundColor: "white",
            borderRadius: "10px",
            padding: "1%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "10%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <p
              style={{
                width: "100%",
                margin: "auto",
                color: "black",
                fontSize: LARGE_DESKTOP,
              }}
            >
              {currentPopupValue.current &&
                currentPopupValue.current.MarkerName}
            </p>
            <CloseIcon
              style={{
                width: "30px",
                height: "30px",
                cursor: "pointer",
                color: "black",
                zIndex: 4,
              }}
              onClick={() => {
                if (isNeedClick) {
                  currentPopupValue.current = undefined;
                  setExternalPopupVisible(false);
                  setTextPopupVisible(false);
                  setIsNeedClick(false);
                } else {
                  let allMarkerStatusCopy = {
                    ...allMarkerStatus,
                  };
                  allMarkerStatusCopy[currentContainedID.current] = "working";
                  setAllMarkerStatus(allMarkerStatusCopy);
                  handleSmartVideoJson(
                    allMarkerStatusCopy,
                    currentVideoPlayer.current
                  );
                  if (FollowTheFlow) {
                    let markerStatusList =
                      smartVideoStatus[currentVideoPlayer.current];
                    let checkMarkPresent =
                      markerStatusList &&
                      markerStatusList.hasOwnProperty(
                        currentContainedID.current
                      );
                    if (checkMarkPresent) {
                      if (currentVideoPlayer.current) {
                        let indexOfCurrentControl =
                          smartPaperData.InputRows.findIndex(
                            (obj) =>
                              obj.ControlID === currentVideoPlayer.current
                          );

                        if (
                          indexOfCurrentControl >= 0 &&
                          smartPaperData &&
                          smartPaperData.InputRows &&
                          smartPaperData.InputRows[indexOfCurrentControl]
                        ) {
                          if (
                            priorityActive <=
                            smartPaperData.InputRows[indexOfCurrentControl]
                              .Priority
                          ) {
                            setPriorityActive(
                              (priorityActive) => priorityActive + 1
                            );
                          }
                        }
                      }
                    } else {
                      setPriorityActive((priorityActive) => priorityActive + 1);
                    }
                  }
                  currentPopupValue.current = undefined;
                  setExternalPopupVisible(false);
                  setTextPopupVisible(false);
                }
              }}
            />
          </div>
          <span
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "#BDBDBD",
              marginBottom: "1%",
            }}
          />
          <iframe
            src={currentPopupValue.current && urlText}
            title="description"
            style={{ width: "100%", height: "90%" }}
          />
        </div>
      </div>
    );
  }

  function renderPopupText() {
    return (
      <div
        style={{
          width: "100vw",
          height: "100vh",
          position: "absolute",
          top: 0,
          zIndex: 10,
          alignSelf: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#00000080",
        }}
      >
        <div
          style={{
            width: "30%",
            maxHeight: "40%",
            minHeight: "20%",
            backgroundColor: "white",
            borderRadius: "10px",
            padding: "1%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "10%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <p
              style={{
                width: "100%",
                margin: "auto",
                color: "black",
                fontSize: LARGE_DESKTOP,
              }}
            >
              {currentPopupValue.current &&
                currentPopupValue.current.MarkerName}
            </p>
            <CloseIcon
              style={{
                width: "30px",
                height: "30px",
                cursor: "pointer",
                color: "black",
                zIndex: 4,
              }}
              onClick={() => {
                if (isNeedClick) {
                  currentPopupValue.current = undefined;
                  setExternalPopupVisible(false);
                  setTextPopupVisible(false);
                  setIsNeedClick(false);
                } else {
                  let allMarkerStatusCopy = {
                    ...allMarkerStatus,
                  };
                  allMarkerStatusCopy[currentContainedID.current] = "working";
                  setAllMarkerStatus(allMarkerStatusCopy);
                  handleSmartVideoJson(
                    allMarkerStatusCopy,
                    currentVideoPlayer.current
                  );
                  if (FollowTheFlow) {
                    let markerStatusList =
                      smartVideoStatus[currentVideoPlayer.current];
                    let checkMarkPresent =
                      markerStatusList &&
                      markerStatusList.hasOwnProperty(
                        currentContainedID.current
                      );
                    if (checkMarkPresent) {
                      if (currentVideoPlayer.current) {
                        let indexOfCurrentControl =
                          smartPaperData.InputRows.findIndex(
                            (obj) =>
                              obj.ControlID === currentVideoPlayer.current
                          );

                        if (
                          indexOfCurrentControl >= 0 &&
                          smartPaperData &&
                          smartPaperData.InputRows &&
                          smartPaperData.InputRows[indexOfCurrentControl]
                        ) {
                          if (
                            priorityActive <=
                            smartPaperData.InputRows[indexOfCurrentControl]
                              .Priority
                          ) {
                            setPriorityActive(
                              (priorityActive) => priorityActive + 1
                            );
                          }
                        }
                      }
                    } else {
                      setPriorityActive((priorityActive) => priorityActive + 1);
                    }
                  }
                  currentPopupValue.current = undefined;
                  setExternalPopupVisible(false);
                  setTextPopupVisible(false);
                }
              }}
            />
          </div>
          <span
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: "#BDBDBD",
            }}
          />
          <div style={{ width: "100%", height: "88%", padding: "2%" }}>
            <p
              style={{
                width: "100%",
                height: "100%",
                color: "black",
                whiteSpace: "pre-wrap",
                overflow: "auto",
                overflowX: "hidden",
                wordWrap: "break-word",
                margin: "auto",
              }}
            >
              {currentPopupValue.current &&
                currentPopupValue.current.MarkerValue}
            </p>
          </div>
        </div>
      </div>
    );
  }

  useEffect(() => {
    if (currentRecordedAudioPlayer.current) {
      currentRecordedAudioPlayer.current.addEventListener("ended", () => {
        setIsRecordPlaying(false);
        setCurrentRecordTime(0);
      });
      return () => {
        currentRecordedAudioPlayer.current.removeEventListener("ended", () => {
          setIsRecordPlaying(false);
          setCurrentRecordTime(0);
        });
      };
    }
  }, [currentRecordedAudioPlayer.current]);

  useEffect(() => {
    if (currentRecordedAudioPlayer.current) {
      currentRecordedAudioPlayer.current.addEventListener("timeupdate", (e) => {
        setCurrentRecordTime(e.target.currentTime);
        setRecordDuration(e.target.duration);
      });
    }
  }, [currentRecordedAudioPlayer.current]);

  function getTime(time) {
    if (!isNaN(time)) {
      return (
        Math.floor(time / 60) + ":" + ("0" + Math.floor(time % 60)).slice(-2)
      );
    }
  }

  useEffect(() => {
    let interval = null;
    if (isRecording) {
      interval = setInterval(() => {
        if (recordseconds > 59) {
          setRecordSeconds(0);
          setRecordMinutes((recordminutes) => recordminutes + 1);
        } else {
          setRecordSeconds((recordseconds) => recordseconds + 1);
        }
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isRecording, recordseconds]);

  function getTimeForRecordingUI() {
    return recordminutes + " : " + ("0" + recordseconds).slice(-2);
  }

  function startRecording() {
    // Start recording. Browser will request permission to use your microphone.
    recorder
      .start()
      .then((data) => {
        setIsRecording(true);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  function stopRecording() {
    // Once you are done singing your best song, stop and get the mp3.
    recorder
      .stop()
      .getMp3()
      .then(([buffer, blob]) => {
        // do what ever you want with buffer and blob
        // Example: Create a mp3 file and play
        setIsRecording(false);
        const file = new File(buffer, "me-at-thevoice.mp3", {
          type: blob.type,
          lastModified: Date.now(),
        });
        currentRecordedFile.current = file;
        setIsRecordSaveClick(true);
      })
      .catch((e) => {
        alert("We could not retrieve your message");
      });
  }

  function uploadRecording(file) {
    setShowHideLoader(true);
    let form = new FormData();
    form.append("file", file);
    fetch("https://learnpodseditornodeserver.knomadixapp.com/upload", {
      method: "POST",
      credentials: "same-origin",
      body: form,
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.text().then((text) => {
          return JSON.parse(text);
        });
      })
      .then((result) => {
        let { url, name, mimetype } = result;
        currentRecordedURL.current = url;
        setShowHideLoader(false);

        if (Completed === 0) {
          getStudentWork(true);
        }
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error(e);
      });
  }

  function deleteRecording(url) {
    setShowHideLoader(true);
    let fileId = url.split("/").pop();
    let DELETE_FILE_lp_URL = encodeURI(
      "https://learnpodseditornodeserver.knomadixapp.com/delete?file=" + fileId
    );

    return fetch(DELETE_FILE_lp_URL, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: fileId }),
    })
      .then((response) => {
        setShowHideLoader(false);
        if (!response.ok) {
          throw Error(response.statusText);
        } else {
          currentRecordedURL.current = undefined;
          currentRecordedFile.current = undefined;
          setRecordSeconds(0);
          setRecordMinutes(0);
          setCurrentRecordTime(0);
          setRecordDuration(0);
          if (Completed === 0) {
            getStudentWork(true);
          }
          setCurrentMode(CANVAS_MODE.PEN);
        }
        return 200;
      })
      .then((result) => {
        console.log("result", result);
      })
      .catch((e) => {
        console.log("e", e);
      });
  }

  useEffect(() => {
    if (isRecordSaveClick) {
      getRecordAction("save");
    } else if (isRecordDeleteClick) {
      getRecordAction("delete");
    }
  }, [isRecordSaveClick, isRecordDeleteClick]);

  useEffect(() => {
    if (recordPopupClick === "saveCancel") {
      setIsRecordSaveClick(false);
      currentRecordedFile.current = undefined;
      setIsRecording(false);
      setRecordSeconds(0);
      setRecordMinutes(0);
      setCurrentMode(CANVAS_MODE.PEN);
    } else if (recordPopupClick === "deleteCancel") {
      setIsRecordSaveClick(false);
      setIsRecordDeleteClick(false);
      currentRecordedFile.current = undefined;
      setIsRecording(false);
      setRecordSeconds(0);
      setRecordMinutes(0);
    } else if (recordPopupClick === "recordSave") {
      if (currentRecordedFile.current) {
        uploadRecording(currentRecordedFile.current);
        setIsRecordSaveClick(false);
      }
    } else if (recordPopupClick === "recordDelete") {
      if (currentRecordedURL.current) {
        deleteRecording(currentRecordedURL.current);
        setIsRecordDeleteClick(false);
      }
    }
  }, [recordPopupClick]);

  interact(".resizable").resizable({
    edges: { top: true, left: true, bottom: true, right: true },
    listeners: {
      start: function (event) {
        currentScaleFactor.current = event.rect.width;
      },
      move: function (event) {
        let { x, y } = event.target.dataset;

        x = (parseFloat(x) || 0) + event.deltaRect.left;
        y = (parseFloat(y) || 0) + event.deltaRect.top;

        // Object.assign(event.target.style, {
        //   width: `${event.rect.width}px`,
        //   height: `${event.rect.height}px`,
        // });
        // Object.assign(event.target.dataset, { x, y });
      },
      end: function (event) {
        let { x, y } = event.target.dataset;
        x = (parseFloat(x) || 0) + event.deltaRect.left;
        y = (parseFloat(y) || 0) + event.deltaRect.top;

        // Object.assign(event.target.style, {
        //   width: `${event.rect.width}px`,
        //   height: `${event.rect.height}px`,
        // });
        // Object.assign(event.target.dataset, { x, y });
        if (currentScaleFactor.current && selectedStroke) {
          let scaleFactor = event.rect.width / currentScaleFactor.current;
          const xArray = selectedStroke.points.map((p) => p.x);
          const yArray = selectedStroke.points.map((p) => p.y);
          scaleStroke(scaleFactor, xArray, yArray);
        }
      },
    },
  });

  //Expandable shapes interact.js
  interact(".resizableExpand").resizable({
    edges: { top: true, left: true, bottom: true, right: true },
    listeners: {
      start: function (event) {
        currentScaleFactor.current = event.rect.width;
      },
      move: function (event) {
        let { x, y } = event.target.dataset;
        x = (parseFloat(x) || 0) + event.deltaRect.left;
        y = (parseFloat(y) || 0) + event.deltaRect.top;

        // Object.assign(event.target.style, {
        //   width: `${event.rect.width}px`,
        //   height: `${event.rect.height}px`,
        // });
        // Object.assign(event.target.dataset, { x, y });
      },
      end: function (event) {
        let { x, y } = event.target.dataset;
        x = (parseFloat(x) || 0) + event.deltaRect.left;
        y = (parseFloat(y) || 0) + event.deltaRect.top;

        // Object.assign(event.target.style, {
        //   width: `${event.rect.width}px`,
        //   height: `${event.rect.height}px`,
        // });
        // Object.assign(event.target.dataset, { x, y });
        if (currentScaleFactor.current && selectedStroke) {
          let scaleFactor = event.rect.width / currentScaleFactor.current;
          const xArray = selectedStroke.points.map((p) => p.x);
          const yArray = selectedStroke.points.map((p) => p.y);
          scaleStroke(scaleFactor, xArray, yArray);
        }
      },
    },
  });

  function checkAndMoveNextComponent() {
    if (skipUnskipComponent[priorityActive]) {
      setTtsPlayStart(false);
      setIsDelayRunning(true);

      let indexOfCurrentInputControl = smartPaperData.InputRows.findIndex(
        (obj) => obj.Priority === priorityActive
      );

      if (indexOfCurrentInputControl >= 0) {
        smartPaperData.InputRows.length > 0 &&
          smartPaperData.InputRows.map((box) => {
            if (box.Priority == priorityActive) {
              setIsReplaySequenceTimerStart(false);
              sequenceTimer.current = setTimeout(() => {
                setIsPageReopened(false);
                setPriorityActive((priorityActive) => priorityActive + 1);
                setIsDelayRunning(false);
              }, box.Delay * 1000);
            }
          });
      }
    } else if (!skipUnskipComponent[priorityActive]) {
      let indexOfCurrentReplayControl =
        smartPaperData.ReplayRectangles.findIndex(
          (obj) => obj.Priority === priorityActive
        );
      if (indexOfCurrentReplayControl >= 0) {
        smartPaperData.ReplayRectangles.length > 0 &&
          smartPaperData.ReplayRectangles.map((box) => {
            if (box.Priority == priorityActive) {
              if (isPractice) {
                setIsReplaySequenceTimerStart(true);
                setIsReplaySequence(true);
              } else {
                setIsReplaySequenceTimerStart(false);
                sequenceTimer.current = setTimeout(() => {
                  setIsPageReopened(false);
                  setPriorityActive((priorityActive) => priorityActive + 1);
                  setIsDelayRunning(false);
                }, box.Delay * 1000);
              }
            }
          });
      }
    }
  }
  useEffect(() => {
    if (isReplaySequence) {
      sequenceTimer.current = setTimeout(() => {
        setDisplayReplayDonePopup(true);
        setIsReplaySequence(false);
      }, 300000);
    } else {
      if (sequenceTimer.current) {
        clearTimeout(sequenceTimer.current);
      }
    }
  }, [isReplaySequence]);

  function handleSucAndFailFeedbackChange(feedback) {
    if (isPractice && FollowTheFlow) {
      window.speechSynthesis.cancel();
      if (feedback) {
        setFeedbackType("success");
        setFailureExternalText("");
        setFailureCount(0);
        setSuccessCount(1);
      } else {
        setFeedbackType("failure");
        setSuccessCount(0);
        setFailureCount((failureCount) => failureCount + 1);
      }
    }
  }

  //Failure message Sequence
  useEffect(() => {
    if (failureCount > 0) {
      if (failureCount === 4) {
        setFailureCount(1);
      } else {
        let indexOfCurrentControl = smartPaperData.InputRows.findIndex(
          (obj) => obj.Priority === priorityActive
        );

        if (
          indexOfCurrentControl >= 0 &&
          smartPaperData &&
          smartPaperData.InputRows &&
          smartPaperData.InputRows[indexOfCurrentControl]
        ) {
          if (
            failureCount === 1 &&
            smartPaperData.InputRows[indexOfCurrentControl].Failure1
          ) {
            if (
              smartPaperData.InputRows[indexOfCurrentControl].Failure1.length >
              0
            ) {
              if (
                smartPaperData.InputRows[indexOfCurrentControl]
                  .FailureExternalLink1 &&
                smartPaperData.InputRows[indexOfCurrentControl]
                  .FailureExternalLink1 !== ""
              ) {
                setFailureExternalText(
                  smartPaperData.InputRows[indexOfCurrentControl]
                    .FailureExternalLink1
                );
              } else {
                setFailureExternalText("");
              }
              setTtsPlayType("feedback");
              setTtsMessageData(
                smartPaperData.InputRows[indexOfCurrentControl].Failure1
              );
              setTtsPlayStart(true);
            } else {
              setFailureCount(2);
            }
          } else if (
            failureCount === 2 &&
            smartPaperData.InputRows[indexOfCurrentControl].Failure2
          ) {
            if (
              smartPaperData.InputRows[indexOfCurrentControl].Failure2.length >
              0
            ) {
              if (
                smartPaperData.InputRows[indexOfCurrentControl]
                  .FailureExternalLink2 &&
                smartPaperData.InputRows[indexOfCurrentControl]
                  .FailureExternalLink2 !== ""
              ) {
                setFailureExternalText(
                  smartPaperData.InputRows[indexOfCurrentControl]
                    .FailureExternalLink2
                );
              } else {
                setFailureExternalText("");
              }
              setTtsPlayType("feedback");
              setTtsMessageData(
                smartPaperData.InputRows[indexOfCurrentControl].Failure2
              );
              setTtsPlayStart(true);
            } else {
              setFailureCount(3);
            }
          } else if (
            failureCount === 3 &&
            smartPaperData.InputRows[indexOfCurrentControl].Failure3
          ) {
            if (
              smartPaperData.InputRows[indexOfCurrentControl].Failure3.length >
              0
            ) {
              if (
                smartPaperData.InputRows[indexOfCurrentControl]
                  .FailureExternalLink3 &&
                smartPaperData.InputRows[indexOfCurrentControl]
                  .FailureExternalLink3 !== ""
              ) {
                setFailureExternalText(
                  smartPaperData.InputRows[indexOfCurrentControl]
                    .FailureExternalLink3
                );
              } else {
                setFailureExternalText("");
              }
              setTtsPlayType("feedback");
              setTtsMessageData(
                smartPaperData.InputRows[indexOfCurrentControl].Failure3
              );
              setTtsPlayStart(true);
            } else {
              if (
                smartPaperData.InputRows[indexOfCurrentControl].Failure1
                  .length > 0
              ) {
                setFailureCount(1);
              } else {
                setFailureCount(0);
              }
            }
          }
        }
      }
    }
  }, [failureCount]);
  //Success message Sequence
  useEffect(() => {
    if (successCount === 1) {
      let indexOfCurrentControl = smartPaperData.InputRows.findIndex(
        (obj) => obj.Priority === priorityActive
      );

      if (
        indexOfCurrentControl >= 0 &&
        smartPaperData &&
        smartPaperData.InputRows &&
        smartPaperData.InputRows[indexOfCurrentControl]
      ) {
        if (smartPaperData.InputRows[indexOfCurrentControl].Success) {
          if (
            smartPaperData.InputRows[indexOfCurrentControl].Success.length > 0
          ) {
            setTtsPlayType("feedback");
            setTtsMessageData(
              smartPaperData.InputRows[indexOfCurrentControl].Success
            );
            setTtsPlayStart(true);
          } else {
            setPriorityActive((priorityActive) => priorityActive + 1);
          }
        } else {
          setPriorityActive((priorityActive) => priorityActive + 1);
        }
      }
      setSuccessCount(0);
    }
  }, [successCount]);

  function handleAiFeedbackChange(feedback, feedbackStatus) {
    if (isPractice && FollowTheFlow) {
      window.speechSynthesis.cancel();
      if (feedbackStatus) {
        setFeedbackType("success");
        // setFailureExternalText("");
        // setFailureCount(0);
        // setSuccessCount(1);
        optionFeedbackSuccess(feedback, feedbackStatus);
      } else {
        setFeedbackType("failure");
        // setSuccessCount(0);
        // setFailureCount((failureCount) => failureCount + 1);
        optionFeedbackSuccess(feedback, feedbackStatus);
      }
    }
  }

  function optionFeedbackSuccess(feedbackText, feedbackStatus) {
    if (feedbackText && feedbackText !== "") {
      let feedbackArray = [feedbackText];
      setTtsPlayType("feedback");
      setTtsMessageData(feedbackArray);
      setTtsPlayStart(true);
    } else {
      if (feedbackStatus) {
        setIsPageReopened(false);
        setPriorityActive((priorityActive) => priorityActive + 1);
      }
    }
    // if (
    //   indexOfCurrentControl >= 0 &&
    //   smartPaperData &&
    //   smartPaperData.InputRows &&
    //   smartPaperData.InputRows[indexOfCurrentControl]
    // ) {
    //   if (smartPaperData.InputRows[indexOfCurrentControl].Success) {
    //     if (
    //       smartPaperData.InputRows[indexOfCurrentControl].Success.length > 0
    //     ) {
    //       setTtsPlayType("feedback");
    //       setTtsMessageData(
    //         smartPaperData.InputRows[indexOfCurrentControl].Success
    //       );
    //       setTtsPlayStart(true);
    //     } else {
    //       setPriorityActive((priorityActive) => priorityActive + 1);
    //     }
    //   } else {
    //     setPriorityActive((priorityActive) => priorityActive + 1);
    //   }
    // }
  }

  // function optionFeedbackFailure(feedbackText,feedbackStatus) {
  //   if (feedbackText&&feedbackText!=="") {
  //   let feedbackArray = [feedbackText]
  //   setTtsPlayType("feedback");
  //   setTtsMessageData(
  //     feedbackArray
  //   );
  //   setTtsPlayStart(true);
  // }else{
  //   setPriorityActive((priorityActive) => priorityActive + 1);
  // }
  // }

  //Failure message Sequence
  // useEffect(() => {
  //   if (failureCount > 0) {
  //     if (failureCount === 4) {
  //       setFailureCount(1);
  //     } else {
  //       let indexOfCurrentControl = smartPaperData.InputRows.findIndex(
  //         (obj) => obj.Priority === priorityActive
  //       );

  //       if (
  //         indexOfCurrentControl >= 0 &&
  //         smartPaperData &&
  //         smartPaperData.InputRows &&
  //         smartPaperData.InputRows[indexOfCurrentControl]
  //       ) {
  //         if (
  //           failureCount === 1 &&
  //           smartPaperData.InputRows[indexOfCurrentControl].Failure1
  //         ) {
  //           if (
  //             smartPaperData.InputRows[indexOfCurrentControl].Failure1.length >
  //             0
  //           ) {
  //             if (
  //               smartPaperData.InputRows[indexOfCurrentControl]
  //                 .FailureExternalLink1 &&
  //               smartPaperData.InputRows[indexOfCurrentControl]
  //                 .FailureExternalLink1 !== ""
  //             ) {
  //               setFailureExternalText(
  //                 smartPaperData.InputRows[indexOfCurrentControl]
  //                   .FailureExternalLink1
  //               );
  //             } else {
  //               setFailureExternalText("");
  //             }
  //             setTtsPlayType("feedback");
  //             setTtsMessageData(
  //               smartPaperData.InputRows[indexOfCurrentControl].Failure1
  //             );
  //             setTtsPlayStart(true);
  //           } else {
  //             setFailureCount(2);
  //           }
  //         } else if (
  //           failureCount === 2 &&
  //           smartPaperData.InputRows[indexOfCurrentControl].Failure2
  //         ) {
  //           if (
  //             smartPaperData.InputRows[indexOfCurrentControl].Failure2.length >
  //             0
  //           ) {
  //             if (
  //               smartPaperData.InputRows[indexOfCurrentControl]
  //                 .FailureExternalLink2 &&
  //               smartPaperData.InputRows[indexOfCurrentControl]
  //                 .FailureExternalLink2 !== ""
  //             ) {
  //               setFailureExternalText(
  //                 smartPaperData.InputRows[indexOfCurrentControl]
  //                   .FailureExternalLink2
  //               );
  //             } else {
  //               setFailureExternalText("");
  //             }
  //             setTtsPlayType("feedback");
  //             setTtsMessageData(
  //               smartPaperData.InputRows[indexOfCurrentControl].Failure2
  //             );
  //             setTtsPlayStart(true);
  //           } else {
  //             setFailureCount(3);
  //           }
  //         } else if (
  //           failureCount === 3 &&
  //           smartPaperData.InputRows[indexOfCurrentControl].Failure3
  //         ) {
  //           if (
  //             smartPaperData.InputRows[indexOfCurrentControl].Failure3.length >
  //             0
  //           ) {
  //             if (
  //               smartPaperData.InputRows[indexOfCurrentControl]
  //                 .FailureExternalLink3 &&
  //               smartPaperData.InputRows[indexOfCurrentControl]
  //                 .FailureExternalLink3 !== ""
  //             ) {
  //               setFailureExternalText(
  //                 smartPaperData.InputRows[indexOfCurrentControl]
  //                   .FailureExternalLink3
  //               );
  //             } else {
  //               setFailureExternalText("");
  //             }
  //             setTtsPlayType("feedback");
  //             setTtsMessageData(
  //               smartPaperData.InputRows[indexOfCurrentControl].Failure3
  //             );
  //             setTtsPlayStart(true);
  //           } else {
  //             if (
  //               smartPaperData.InputRows[indexOfCurrentControl].Failure1
  //                 .length > 0
  //             ) {
  //               setFailureCount(1);
  //             } else {
  //               setFailureCount(0);
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // }, [failureCount]);
  //Success message Sequence
  // useEffect(() => {
  //   if (successCount === 1) {
  //     let indexOfCurrentControl = smartPaperData.InputRows.findIndex(
  //       (obj) => obj.Priority === priorityActive
  //     );
  //     setSuccessCount(0);
  //   }
  // }, [successCount]);

  function handleAttemptChange(attemptValue) {
    setAttempts((attempts) => attempts + attemptValue);
    setAttemptsPractice((attempts) => attempts + attemptValue);
  }

  //handled normal control data
  function handleValueChange(value, ControlID, richText) {
    const presentIndex = controlsList.findIndex(
      (item) => item.CtlId === ControlID
    );
    let controlListCopy = [...controlsList];
    if (presentIndex >= 0) {
      controlListCopy[presentIndex] = {
        CtlId: ControlID,
        CtlValue: value,
        CtlScore: value.Value,
        elapsedTime: minutes + ":" + seconds,
      };
    } else {
      controlListCopy.push({
        CtlId: ControlID,
        CtlValue: value,
        CtlScore: value.Value,
        elapsedTime: minutes + ":" + seconds,
      });
    }
    if (richText) {
    } else {
      if (value.ModeName === "SmartSlide") {
        handleAttemptChange(value.TempAttempts);
      } else {
        // for attempts other than smart slide
        handleAttemptChange(1);
      }
    }
    setControlsList(controlListCopy);
  }

  //handled embedded control data
  function handleValueChangeEmbeded(
    ctlID,
    ctlValue,
    ctlScore,
    ctlTotalScore,
    ctlSortedArray
  ) {
    setIsPageReopened(false);
    let controlListCopy = [...controlsList];
    const presentIndex = controlListCopy.findIndex(
      (item) => item.CtlId === ctlID
    );
    if (presentIndex >= 0) {
      controlListCopy[presentIndex] = {
        CtlId: ctlID,
        CtlValue: {
          Answer: ctlValue,
          Value: ctlScore,
        },
        CtlScore: ctlScore,
        CtlTotalScore: ctlTotalScore,
        CtlSortedArray: ctlSortedArray,
        elapsedTime: minutes + ":" + seconds,
      };
    } else {
      controlListCopy.push({
        CtlId: ctlID,
        CtlValue: {
          Answer: ctlValue,
          Value: ctlScore,
        },
        CtlScore: ctlScore,
        CtlTotalScore: ctlTotalScore,
        CtlSortedArray: ctlSortedArray,
        elapsedTime: minutes + ":" + seconds,
      });
    }
    setControlsList(controlListCopy);
  }

  function setCurrentSequenceMessage() {
    let indexOfCurrentControl = smartPaperData.InputRows.findIndex(
      (obj) => obj.Priority === priorityActive
    );
    //Set current active component sequence message
    if (
      indexOfCurrentControl >= 0 &&
      smartPaperData &&
      smartPaperData.InputRows &&
      smartPaperData.InputRows[indexOfCurrentControl] &&
      smartPaperData.InputRows[indexOfCurrentControl].SpeechData
    ) {
      setTtsMessageData(
        smartPaperData.InputRows[indexOfCurrentControl].SpeechData
      );
      setTtsPlayType("sequence");
    }
  }

  //Generate user label
  function userLabelCreation(event, rect) {
    // if (rect.left === 0) {
    const localX = event.clientX - rect.left;
    const localY = event.clientY - rect.top;
    // let xPercentage =
    //   ((canvasDimension.width - localX) / canvasDimension.width) * 100;
    // let yPercentage =
    //   ((canvasDimension.width - localY) / canvasDimension.width) * 100;
    // console.log("xPercentage", xPercentage + "=====" + yPercentage);
    let labelArrayListCopy = [...labelArrayList];
    let labelObject = {
      labelId: labelArrayListCopy.length,
      width: 100,
      height: 50,
      top: localY,
      left: localX,
      labelText: "",
      textColor: "#000000",
      fillColor: "#ffffff",
      bold: false,
      italic: false,
      underline: false,
      textAlign: "left",
    };
    labelArrayListCopy.push(labelObject);
    setLabelArrayList(labelArrayListCopy);
    setTimeout(() => {
      setSelectedLabel(labelObject);
    }, 500);
    // }
  }

  useEffect(() => {
    if (labelArrayList.length > 0) {
      console.log("selectedLabel", labelArrayList);
    } else {
      setSelectedLabel(undefined);
    }
  }, [labelArrayList]);

  function handleLabeltextChange(saveType, saveValue) {
    let labelArrayListCopy = [...labelArrayList];
    if (selectedLabel) {
      if (saveType === "text") {
        labelArrayListCopy[selectedLabel.labelId].labelText = saveValue;
      } else if (saveType === "underline") {
        if (labelArrayListCopy[selectedLabel.labelId].underline) {
          labelArrayListCopy[selectedLabel.labelId].underline = false;
        } else {
          labelArrayListCopy[selectedLabel.labelId].underline = true;
        }
      } else if (saveType === "italic") {
        if (labelArrayListCopy[selectedLabel.labelId].italic) {
          labelArrayListCopy[selectedLabel.labelId].italic = false;
        } else {
          labelArrayListCopy[selectedLabel.labelId].italic = true;
        }
      } else if (saveType === "bold") {
        if (labelArrayListCopy[selectedLabel.labelId].bold) {
          labelArrayListCopy[selectedLabel.labelId].bold = false;
        } else {
          labelArrayListCopy[selectedLabel.labelId].bold = true;
        }
      } else if (saveType === "textColor") {
        labelArrayListCopy[selectedLabel.labelId].textColor = saveValue;
      } else if (saveType === "fillColor") {
        labelArrayListCopy[selectedLabel.labelId].fillColor = saveValue;
      } else if (saveType === "align") {
        labelArrayListCopy[selectedLabel.labelId].textAlign = saveValue;
      } else if (saveType === "delete") {
        let filteredData = labelArrayListCopy.filter(
          (e) => e.labelId !== selectedLabel.labelId
        );
        labelArrayListCopy = filteredData;
      } else if (saveType === "clear") {
        labelArrayListCopy[selectedLabel.labelId].labelText = "";
      }
      setLabelArrayList(labelArrayListCopy);
    }
  }

  function renderLabelBox() {
    return (
      <span>
        {labelArrayList.length > 0 &&
          labelArrayList.map((labelItem, index) => {
            return (
              <div
                id={"label" + labelItem.labelId}
                key={"label" + labelItem.labelId}
                style={{
                  width: labelItem.width,
                  height: labelItem.height,
                  top: labelItem.top,
                  left: labelItem.left,
                  position: "absolute",
                  zIndex: 10,
                }}
                onClick={() => {
                  setTimeout(() => {
                    setSelectedLabel(labelItem);
                    setIsFloatingChild(true);
                  }, 200);
                }}
              >
                <textarea
                  style={{
                    width: "100%",
                    height: "100%",
                    backgroundColor: labelItem.fillColor,
                    color: labelItem.textColor,
                    fontWeight: labelItem.bold ? "bold" : "normal",
                    fontStyle: labelItem.italic ? "italic" : "normal",
                    fontFamily: "Manrope",
                    textDecoration: labelItem.underline ? "underline" : "none",
                    border:
                      selectedLabel &&
                      selectedLabel.labelId === labelItem.labelId
                        ? "3px #ffc42d solid"
                        : "1px #bdbdbd solid",
                    borderRadius: "4px",
                    textAlign: labelItem.textAlign,
                    resize: "none",
                  }}
                  readOnly={
                    currentMode === CANVAS_MODE.SELECT ||
                    Completed === 1 ||
                    !isActive
                      ? true
                      : false
                  }
                  value={labelItem.labelText}
                  onChange={(labelText) => {
                    handleLabeltextChange("text", labelText.target.value);
                  }}
                />
              </div>
            );
          })}
      </span>
    );
  }

  //For expanded strokes
  // drag related variables
  var dragLabel = useRef();
  let startXLabel = useRef();
  let startYLabel = useRef();
  // handle mousedown events
  function labelDown(e) {
    // tell the browser we're handling this mouse event
    e.preventDefault();
    e.stopPropagation();
    var BB = canvasRef.current.getBoundingClientRect();
    var offsetX = BB.left;
    var offsetY = BB.top;
    // get the current mouse position
    var mx = parseInt(e.clientX - offsetX);
    var my = parseInt(e.clientY - offsetY);
    dragLabel.current = true;
    // test each rect to see if mouse is inside
    // dragokExpand.current = false;
    // for (var i = 0; i < selectedStroke.points.length; i++) {
    //   var r = selectedStroke.points[i];
    //   dragokExpand.current = true;
    //   r.isDragging = true;
    // }
    // save the current mouse position
    startXLabel.current = mx;
    startYLabel.current = my;
  }
  // handle mouseup events
  function labelUp(e) {
    // tell the browser we're handling this mouse event
    e.preventDefault();
    e.stopPropagation();
    // clear all the dragging flags
    dragLabel.current = false;
  }

  // handle mouse moves
  function labelMove(e) {
    // if we're dragging anything...
    // tell the browser we're handling this mouse event
    if (dragLabel.current) {
      e.preventDefault();
      e.stopPropagation();
      var BB = canvasRef.current.getBoundingClientRect();
      var offsetX = BB.left;
      var offsetY = BB.top;
      // get the current mouse position
      var mx = parseInt(e.clientX - offsetX);
      var my = parseInt(e.clientY - offsetY);
      // calculate the distance the mouse has moved
      // since the last mousemove
      var dx = mx - startXLabel.current;
      var dy = my - startYLabel.current;
      // console.log("offsetX", offsetX + "======" + offsetY);
      let labelArrayListCopy = [...labelArrayList];
      if (selectedLabel) {
        labelArrayListCopy[selectedLabel.labelId].left = mx;
        labelArrayListCopy[selectedLabel.labelId].top = my;
      }
      setLabelArrayList(labelArrayListCopy);
      startXLabel.current = mx;
      startYLabel.current = my;
    }
  }

  function handleChangeComplete(color) {
    setActiveColor(color.hex);
  }

  useEffect(() => {
    if (colorPickerType) {
      handleLabeltextChange(colorPickerType, activeColor);
    }
  }, [activeColor]);

  function renderColorPicker() {
    return (
      <div
        id="tool-color-picker"
        style={{
          position: "absolute",
          bottom: "20%",
          left:
            colorPickerType && colorPickerType === "textColor" ? "35%" : "45%",
          zIndex: 10,
        }}
      >
        <SketchPicker
          width="250px"
          disableAlpha={true}
          presetColors={presetColors}
          color={activeColor}
          onChangeComplete={(color) => handleChangeComplete(color)}
        />
      </div>
    );
  }

  useEffect(() => {
    if (colorPickerType) {
      var colorElement = document.getElementById("tool-color-picker");
      var xc = 0;
      var yc = 0;

      interact(colorElement)
        .draggable({
          modifiers: [
            interact.modifiers.snap({
              targets: [interact.snappers.grid({ x: 30, y: 30 })],
              range: Infinity,
              relativePoints: [{ x: 0, y: 0 }],
            }),
            interact.modifiers.restrict({
              restriction: colorElement.parentNode,
              elementRect: { top: 0, left: 0, bottom: 1, right: 1 },
              endOnly: true,
            }),
          ],
          inertia: true,
        })
        .on("dragmove", function (event) {
          xc += event.dx;
          yc += event.dy;

          event.target.style.transform =
            "translate(" + xc + "px, " + yc + "px)";
        });
    }
  }, [colorPickerType]);

  //Chat functions
  function handleChatClarification(clarificationType, clarificationData) {
    // setShowHideLoader(true);
    setIsKnovoApiCall(true);
    chatChallengeMe(
      clarificationType,
      clarificationData.topic,
      clarificationData.keyword,
      clarificationData.question_type,
      clarificationData.num_of_options,
      clarificationData.content,
      (response) => {
        setAiChatResponseData(response);
        setIsKnovoApiCall(false);
        // setShowHideLoader(false);
      }
    );
  }

  function renderNextButton() {
    return (
      <div className="page-nav-arrw-icon-container page-nav-arrw-down">
        <Button
          className="next-page-icon"
          hasIconOnly
          iconDescription="Next"
          renderIcon={ArrowDown}
          tooltipAlignment="center"
          tooltipPosition="top"
          onClick={() => {
            if (isRecording) {
              showOrHideToaster(true, RECORD_ONGOING, "warning");
            } else {
              if (
                activityDataFromParent.OtherActivities &&
                activityDataFromParent.OtherActivities !== null
              ) {
                if (
                  currentPageNumber <
                  activityDataFromParent.OtherActivities.length - 1
                ) {
                  if (FollowTheFlow) {
                    if (
                      priorityActive > highestPriorityValue ||
                      highestPriorityValue === 1
                    ) {
                      setAudioStop(true);
                      setIsPageScrolled(true);
                      setTimeout(() => {
                        setIsPageScrolled(false);
                        setIsPageNavigated(true);
                        setIsPageReopened(true);
                        setDisplayControls(false);
                        setIsMultipageActive(true);
                        clearCanvas();
                        getStudentWork(false, true);
                        setCurrentPageNumber(
                          (currentPageNumber) => currentPageNumber + 1
                        );
                      }, 2000);
                    } else {
                      showOrHideToaster(
                        true,
                        "Complete all steps to move",
                        "warning"
                      );
                    }
                  } else {
                    setAudioStop(true);
                    setIsPageScrolled(true);
                    setTimeout(() => {
                      setIsPageScrolled(false);
                      setIsPageNavigated(true);
                      setIsPageReopened(true);
                      setDisplayControls(false);
                      setIsMultipageActive(true);
                      clearCanvas();
                      getStudentWork(false, true);
                      setCurrentPageNumber(
                        (currentPageNumber) => currentPageNumber + 1
                      );
                    }, 1000);
                  }
                } else {
                  showOrHideToaster(true, "You're on the last page", "warning");
                }
              }
            }
          }}
        />
      </div>
    );
  }

  function renderPrevButton() {
    return (
      <div className="page-nav-arrw-icon-container page-nav-arrw-up">
        <Button
          className="next-page-icon"
          hasIconOnly
          iconDescription="Previous"
          renderIcon={ArrowUp}
          tooltipAlignment="center"
          tooltipPosition="bottom"
          onClick={() => {
            if (isRecording) {
              showOrHideToaster(true, RECORD_ONGOING, "warning");
            } else {
              if (
                activityDataFromParent.OtherActivities &&
                activityDataFromParent.OtherActivities !== null
              ) {
                if (currentPageNumber > 0) {
                  setAudioStop(true);
                  setIsPageScrolled(true);
                  setTimeout(() => {
                    setIsPageScrolled(false);
                    setIsPageNavigated(true);
                    setIsPageReopened(true);
                    setDisplayControls(false);
                    setIsMultipageActive(true);
                    clearCanvas();
                    getStudentWork(false, true);
                    setCurrentPageNumber(
                      (currentPageNumber) => currentPageNumber - 1
                    );
                  }, 1000);
                } else {
                  showOrHideToaster(
                    true,
                    "You're on the first page",
                    "warning"
                  );
                }
              }
            }
          }}
        />
      </div>
    );
  }

  function containedActivityApiCall(contentIDParent, accessToken) {
    getContainedActivityForStudent(
      user.LoginID,
      contentIDParent,
      accessToken,
      (activityDataResponse) => {
        if (activityDataResponse.StatusCode === 200) {
          setSaveUserErrorCount(0);
          currentAppName.current = activityDataResponse.AppName;
          setisPopupSlideVisible(true);
        } else if (activityDataResponse.StatusCode === 401) {
          if (saveUserErrorCount < 1) {
            refreshTokenCall(GET_ACTIVITY);
          } else {
            showOrHideToaster(
              true,
              "Server failed! Please try again.",
              "error"
            );
            setSaveUserErrorCount(0);
          }
        } else {
          showOrHideToaster(true, activityDataResponse.StatusMessage, "error");
        }
      }
    );
  }

  function refreshTokenCall(apiCall) {
    refreshToken(token, (tokenResponse) => {
      if (tokenResponse.Success) {
        if (apiCall === GET_ACTIVITY) {
          containedActivityApiCall(selectedContentID, tokenResponse.Token);
        }
        userToken(tokenResponse.Token);
        setSaveUserErrorCount(1);
      } else {
        showOrHideToaster(true, "Server failed! Please try again.", "error");
        setSaveUserErrorCount(0);
        setShowHideLoader(false);
      }
    });
  }

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
      }}
    >
      <TeacherFeedback
        feedbackVisible={feedbackVisible}
        Feedback={Feedback}
        onPopupCancel={() => {
          setFeedbackVisible(false);
        }}
        teacherRecording={
          currentRecordedTeacherURL.current
            ? currentRecordedTeacherURL.current
            : undefined
        }
        isTeacherRecordPlaying={isTeacherRecordPlaying}
        setIsTeacherRecordPlaying={(teacherRecordStatus) => {
          setIsTeacherRecordPlaying(teacherRecordStatus);
        }}
      />
      {smartPaperData && (
        <div style={{ height: "100%" }}>
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                margin: "auto",
                width: "fit-content",
                height: "100%",
                background: "white",
                display: "flex",
                alignSelf: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignSelf: "center",
                  width: canvasDimension && canvasDimension.width,
                  height: canvasDimension && canvasDimension.height,
                  position:
                    isVideoPlaying || isPopupSlideVisible || isExpandableView
                      ? undefined
                      : "relative",
                  backgroundImage: displayComponents
                    ? `url(${smartPaperData.BackgroundImage})`
                    : "none",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  zIndex:
                    currentMode === CANVAS_MODE.SELECT
                      ? 6
                      : currentMode === CANVAS_MODE.LABEL
                      ? 7
                      : 3,
                  pointerEvents:
                    showNavToast || isRecordPlaying || isRecording
                      ? "none"
                      : "auto",
                  // overflowY: "scroll",
                  // overflowX: "hidden",
                }}
                onMouseDown={(event) => {
                  if (currentMode === CANVAS_MODE.SELECT) {
                    if (selectedStroke && !selectedLabel) {
                      myDown(event);
                    } else if (!selectedStroke && selectedLabel) {
                      labelDown(event);
                    }
                  }
                }}
                onMouseUp={(event) => {
                  if (currentMode === CANVAS_MODE.SELECT) {
                    if (selectedStroke && !selectedLabel) {
                      myUp(event);
                    } else if (!selectedStroke && selectedLabel) {
                      labelUp(event);
                    }
                  }
                }}
                onMouseMove={(event) => {
                  if (currentMode === CANVAS_MODE.SELECT) {
                    if (selectedStroke && !selectedLabel) {
                      myMove(event);
                    } else if (!selectedStroke && selectedLabel) {
                      labelMove(event);
                    }
                  }
                }}
                onMouseOut={(event) => {
                  if (currentMode === CANVAS_MODE.SELECT && selectedStroke) {
                    myUp(event);
                  }
                }}
                onClick={(event) => {
                  if (currentMode === CANVAS_MODE.SELECT) {
                    selectStroke(event);
                  }
                }}
              >
                {currentMode === CANVAS_MODE.LABEL && (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      position: "absolute",
                      top: 0,
                      zIndex: 8,
                    }}
                    onClick={(event) => {
                      if (currentMode === CANVAS_MODE.LABEL) {
                        let rect = event.target.getBoundingClientRect();
                        if (selectedLabel) {
                          setSelectedLabel(undefined);
                          setColorPickerType(undefined);
                        } else {
                          userLabelCreation(event, rect);
                        }
                      }
                    }}
                  />
                )}
                {displayComponents && (
                  <img
                    alt="sd"
                    id={"sky" + ContentID}
                    ref={imgRef}
                    src={smartPaperData.BackgroundImage}
                    style={{
                      margin: "auto",
                      zIndex: 0,
                      objectFit: "contain",
                      width: canvasDimension && canvasDimension.width,
                      height: canvasDimension && canvasDimension.height,
                      MozUserSelect: "none",
                      WebkitUserSelect: "none",
                      msUserSelect: "none",
                      userSelect: "none",
                      display: "none",
                    }}
                    onLoad={() => setIsImageLoaded(true)}
                  />
                )}

                {displayComponents && renderLabelBox()}
                {selectedLabel && colorPickerType && renderColorPicker()}
                <span
                  style={{
                    backgroundColor: smartPaperData.Opacity,
                    height:
                      isVideoPlaying || isPopupSlideVisible || isExpandableView
                        ? undefined
                        : canvasDimension && canvasDimension.height,
                    width: canvasDimension && canvasDimension.width,
                    position: "absolute",
                    alignSelf: "center",
                  }}
                />
                {isImageLoaded && canvasDimension && displayComponents && (
                  <canvas
                    ref={canvasRef}
                    onMouseDown={(event) => {
                      if (currentMode === CANVAS_MODE.PEN) {
                        startDrawing(event);
                      }
                    }}
                    onMouseUp={(event) => {
                      if (currentMode === CANVAS_MODE.PEN) {
                        finishDrawing(event);
                      }
                    }}
                    onMouseMove={(event) => {
                      if (currentMode === CANVAS_MODE.PEN) {
                        draw(event);
                      }
                    }}
                    onMouseOut={(event) => {
                      if (currentMode === CANVAS_MODE.PEN) {
                        finishDrawing(event);
                      }
                    }}
                    style={{
                      position: "absolute",
                      zIndex: 4,
                      cursor:
                        currentMode === CANVAS_MODE.PEN &&
                        Completed === 0 &&
                        isActive
                          ? "crosshair"
                          : "default",
                      alignSelf: "center",
                    }}
                    onClick={() => {
                      setOutsideClick(true);
                      setTimeout(() => {
                        setOutsideClick(false);
                      }, 100);
                    }}
                  />
                )}
                {!isExpandableView && renderStrokeBorder()}
                {isImageLoaded &&
                  displayComponents &&
                  !isReplayHappening &&
                  renderReplayRectangleProperties()}
                {isImageLoaded && displayComponents && renderReplayRectangles()}
                {/* {FollowTheFlow && renderReplayRectanglesMask()} */}
                {/* {FollowTheFlow && isImageLoaded && renderReplayRectanglesDone()} */}

                {isImageLoaded && displayComponents && displayControls && (
                  <SmartPaperBaseScreen
                    // Values to client
                    initial={initial}
                    smartPaperData={smartPaperData}
                    canvasDimension={canvasDimension}
                    currentMode={currentMode}
                    isVerifyMode={isVerifyMode}
                    isPractice={isPractice}
                    Completed={Completed}
                    explanationClick={explanationClick}
                    isActive={isActive}
                    IsReadonly={IsReadonly}
                    FollowTheFlow={FollowTheFlow}
                    priorityActive={FollowTheFlow ? priorityActive : -1}
                    outsideClick={outsideClick}
                    controlsList={controlsList}
                    isVideoPlaying={isVideoPlaying}
                    minutes={minutes}
                    seconds={seconds}
                    screenMode={"desktop"}
                    projectName={"backpackweb"}
                    allMarkerStatus={allMarkerStatus}
                    isResetClick={isResetClick}
                    audioStop={audioStop}
                    isRecording={isRecording}
                    isRecordPlaying={isRecordPlaying}
                    handleValueChangeEmbeded={handleValueChangeEmbeded}
                    handleValueChange={handleValueChange}
                    handleAttemptChange={handleAttemptChange}
                    //Values from client
                    setPriorityChange={(priorityChangeValue) => {
                      onPriorityChange(priorityChangeValue);
                    }}
                    setSequenceMessageChange={(sequenceChangeValue) => {
                      sequenceMessage(sequenceChangeValue);
                    }}
                    setOutsideClickChange={(outsideClickChangeValue) => {
                      onOutsideClickChange(outsideClickChangeValue);
                    }}
                    setExplanationText={(parentExplanationText) => {
                      setExplanationText(parentExplanationText);
                    }}
                    setExplanationStatus={(parentExplanationStatus) => {
                      setExplanationStatus(parentExplanationStatus);
                    }}
                    setExplanationVisible={(parentExplanationVisible) => {
                      setExplanationVisible(parentExplanationVisible);
                    }}
                    handleSuccessModal={(successModalValue) => {
                      handleSuccessChange(successModalValue);
                    }}
                    //Smart video data
                    setIsVideoPlaying={(videoPlayingParent) => {
                      setIsVideoPlaying(videoPlayingParent);
                    }}
                    setVideoResume={(videoResumeParent) => {
                      setVideoResume(videoResumeParent);
                    }}
                    setAllMarkerStatus={(allMarkerStatusParent) => {
                      setAllMarkerStatus(allMarkerStatusParent);
                    }}
                    setTextPopupVisible={(textPopupVisibleParent) => {
                      setTextPopupVisible(textPopupVisibleParent);
                    }}
                    setExternalPopupVisible={(externalPopupVisibleParent) => {
                      setExternalPopupVisible(externalPopupVisibleParent);
                    }}
                    ContainedView={props.currentActivity.ContainedView}
                    videoResume={videoResume}
                    currentVideoPlayer={currentVideoPlayer}
                    smartVideoStatus={smartVideoStatus}
                    sendDataForApi={(contentIDParent) => {
                      setSelectedContentID(contentIDParent);
                      containedActivityApiCall(contentIDParent, token);
                    }}
                    setSmartVideoStatus={(smartVideoStatusFromParent) => {
                      setSmartVideoStatus(smartVideoStatusFromParent);
                    }}
                    //use ref data from parent
                    setCurrentPopupValue={(currentPopupValueParent) => {
                      currentPopupValue.current = currentPopupValueParent;
                    }}
                    setCurrentVideoPlayer={(currentVideoPlayerParent) => {
                      currentVideoPlayer.current = currentVideoPlayerParent;
                    }}
                    setCurrentContainedID={(currentContainedIDParent) => {
                      currentContainedID.current = currentContainedIDParent;
                    }}
                    setCurrentAudioPlayer={(currentAudioPlayerParent) => {
                      setAudioStop(false);
                      currentAudioPlayer.current = currentAudioPlayerParent;
                    }}
                    setCurrentAudioPlaying={(currentAudioPlayingParent) => {
                      currentAudioPlaying.current = currentAudioPlayingParent;
                    }}
                    isContainedView={false}
                    //handle video close
                    handleVideoClose={(videoCloseStatus) => {
                      if (FollowTheFlow && videoCloseStatus) {
                        let indexOfCurrentControl =
                          smartPaperData.InputRows.findIndex(
                            (obj) =>
                              obj.ControlID === currentVideoPlayer.current
                          );
                        if (
                          indexOfCurrentControl >= 0 &&
                          smartPaperData &&
                          smartPaperData.InputRows &&
                          smartPaperData.InputRows[indexOfCurrentControl]
                        ) {
                          if (
                            smartPaperData.InputRows[indexOfCurrentControl]
                              .Priority >= priorityActive
                          ) {
                            setPriorityActive(
                              (priorityActive) => priorityActive + 1
                            );
                          }
                        }
                      }
                    }}
                    //handle audio close
                    handleAudioClose={(audioCloseStatus) => {
                      if (FollowTheFlow && audioCloseStatus) {
                        setAudioStop(false);
                        let indexOfCurrentControl =
                          smartPaperData.InputRows.findIndex(
                            (obj) =>
                              obj.ControlID === currentAudioPlayer.current
                          );
                        if (
                          indexOfCurrentControl >= 0 &&
                          smartPaperData &&
                          smartPaperData.InputRows &&
                          smartPaperData.InputRows[indexOfCurrentControl]
                        ) {
                          if (
                            smartPaperData.InputRows[indexOfCurrentControl]
                              .Priority >= priorityActive
                          ) {
                            setPriorityActive(
                              (priorityActive) => priorityActive + 1
                            );
                          }
                        }
                      }
                    }}
                    //Sequence values
                    isSeqPlay={botTalking}
                    feedPlay={false}
                    handleSucAndFailFeedbackChange={(
                      feedbackValue,
                      feedbackStatus
                    ) => {
                      handleSucAndFailFeedbackChange(
                        feedbackValue,
                        feedbackStatus
                      );
                    }}
                    handleAiFeedbackChange={(feedbackValue, feedbackStatus) => {
                      handleAiFeedbackChange(feedbackValue, feedbackStatus);
                    }}
                    onRecordAlert={(status) => {
                      if (status) {
                        showOrHideToaster(true, RECORD_ONGOING, "warning");
                      }
                    }}
                    isReplayHappening={isReplayHappening}
                    canvasAreaDimensions={canvasAreaDimensions}
                    hintMessage={hintMessage}
                    onHintIconChange={() => {
                      if (
                        FollowTheFlow &&
                        !isRecording &&
                        !isRecordPlaying &&
                        !isReplayHappening &&
                        !botTalking
                      ) {
                        // knovoHelpClose();
                        setShowHint(false);
                        window.speechSynthesis.cancel();
                        if (Completed === 0) {
                          if (isPractice && hintMessage && hintMessage !== "") {
                            setAudioStop(true);
                            setTtsPlayType("hint");
                            setTtsMessageData(hintMessage);
                            setTtsPlayStart(true);
                          }
                        }
                      }
                    }}
                    // pass page data
                    isPageRefresh={isPageRefresh}
                  />
                )}
                {isImageLoaded &&
                  displayComponents &&
                  smartPaperData.InputRows &&
                  smartPaperData.InputRows.length > 0 &&
                  smartPaperData.InputRows.map((box, index) => {
                    if (FollowTheFlow) {
                      return (
                        <div
                          className={
                            box.Priority > priorityActive
                              ? "blur-component bounceInLeft"
                              : box.Priority === priorityActive
                              ? "active-component bounceInLeft"
                              : "visible-component bounceInLeft"
                          }
                          style={{
                            height: box.Height + "%",
                            width: box.Width + "%",
                            top: box.Y,
                            left: box.X,
                            position: "absolute",
                          }}
                        />
                      );
                    }
                  })}
                {isImageLoaded &&
                  smartPaperData.InputRows &&
                  smartPaperData.InputRows.length > 0 &&
                  smartPaperData.InputRows.map((box, index) => {
                    if (
                      FollowTheFlow
                        ? box.PluginId === "H5P" &&
                          box.Priority <= priorityActive
                        : box.PluginId === "H5P"
                    ) {
                      return (
                        <span>
                          {isPractice ? (
                            <NewComponent
                              mcData={box}
                              userId={user.LoginID}
                              activityID={ContentID}
                              lessonID={currentLessonUnitDistId}
                              initial={initial}
                              isResetClick={isResetClick}
                              isEmbeded={true}
                              isPractice={isPractice}
                              onAttemptChange={(attemptValue) => {
                                setAttempts(
                                  (attempts) => attempts + attemptValue
                                );
                                setAttemptsPractice(
                                  (attempts) => attempts + attemptValue
                                );
                              }}
                              onValueChange={(ctlID, ctlScore) => {
                                let controlListCopy = [...controlsList];
                                const presentIndex = controlListCopy.findIndex(
                                  (item) => item.CtlId === ctlID
                                );
                                if (presentIndex >= 0) {
                                  controlListCopy[presentIndex] = {
                                    CtlId: ctlID,
                                    CtlValue: {
                                      Answer: "",
                                      Value: ctlScore,
                                    },
                                    CtlScore: ctlScore,
                                    CtlTotalScore: "",
                                    CtlSortedArray: 0,
                                    elapsedTime: minutes + ":" + seconds,
                                  };
                                } else {
                                  controlListCopy.push({
                                    CtlId: ctlID,
                                    CtlValue: {
                                      Answer: "",
                                      Value: ctlScore,
                                    },
                                    CtlScore: ctlScore,
                                    CtlTotalScore: 0,
                                    CtlSortedArray: "",
                                    elapsedTime: minutes + ":" + seconds,
                                  });
                                }
                                setControlsList(controlListCopy);
                              }}
                            />
                          ) : (
                            <H5PComponentTest
                              mcData={box}
                              userId={user.LoginID}
                              activityID={ContentID}
                              initial={initial}
                              isResetClick={isResetClick}
                              isEmbeded={true}
                              isPractice={isPractice}
                              onAttemptChange={(attemptValue) => {
                                setAttempts(
                                  (attempts) => attempts + attemptValue
                                );
                                setAttemptsPractice(
                                  (attempts) => attempts + attemptValue
                                );
                              }}
                              onValueChange={(ctlID, ctlScore) => {
                                let controlListCopy = [...controlsList];
                                const presentIndex = controlListCopy.findIndex(
                                  (item) => item.CtlId === ctlID
                                );
                                if (presentIndex >= 0) {
                                  controlListCopy[presentIndex] = {
                                    CtlId: ctlID,
                                    CtlValue: {
                                      Answer: "",
                                      Value: ctlScore,
                                    },
                                    CtlScore: ctlScore,
                                    CtlTotalScore: "",
                                    CtlSortedArray: 0,
                                    elapsedTime: minutes + ":" + seconds,
                                  };
                                } else {
                                  controlListCopy.push({
                                    CtlId: ctlID,
                                    CtlValue: {
                                      Answer: "",
                                      Value: ctlScore,
                                    },
                                    CtlScore: ctlScore,
                                    CtlTotalScore: 0,
                                    CtlSortedArray: "",
                                    elapsedTime: minutes + ":" + seconds,
                                  });
                                }
                                setControlsList(controlListCopy);
                              }}
                            />
                          )}
                        </span>
                      );
                    }
                  })}
                {/* Editor shapes */}
                {isImageLoaded &&
                  displayComponents &&
                  !isReplayHappening &&
                  shapesDataArray.length > 0 &&
                  shapesDataArray.map((shapesData, index) => {
                    if (shapesData.IsDeleted !== true) {
                      if (shapesData.ShapeType === "line") {
                        return (
                          <div
                            style={{
                              position: "absolute",
                              left: shapesData.ShapeLeft,
                              top: shapesData.ShapeTop,
                              transform: [
                                {
                                  rotate:
                                    shapesData.ShapeRotation.toString().concat(
                                      "deg"
                                    ),
                                },
                                { scaleX: shapesData.ScaleX },
                                { scaleY: shapesData.ScaleY },
                              ],
                            }}
                          >
                            <svg
                              key={index.toString()}
                              height={shapesData.ShapeHeight + shapesData.Width}
                              width={shapesData.ShapeWidth + shapesData.Width}
                            >
                              <line
                                x1="0"
                                y1="0"
                                x2={shapesData.ShapeWidth}
                                y2={shapesData.ShapeHeight}
                                stroke={shapesData.Color}
                                strokeWidth={shapesData.Width}
                              />
                            </svg>
                          </div>
                        );
                      } else {
                        return (
                          <div
                            key={index.toString()}
                            style={{
                              width:
                                shapesData.ShapeType === "rect" ||
                                shapesData.ShapeType === "circle"
                                  ? shapesData.ShapeWidth > 0
                                    ? shapesData.ShapeWidth +
                                      shapesData.Width * 2
                                    : 0
                                  : shapesData.ShapeWidth,
                              height:
                                shapesData.ShapeType === "rect" ||
                                shapesData.ShapeType === "circle"
                                  ? shapesData.ShapeHeight > 0
                                    ? shapesData.ShapeHeight +
                                      shapesData.Width * 2
                                    : 0
                                  : shapesData.ShapeHeight,
                              top: shapesData.ShapeTop,
                              left: shapesData.ShapeLeft,
                              position: "absolute",
                              justifyContent: "center",
                              display: "flex",
                              transform: `rotate(${
                                shapesData.ShapeRotation + "deg"
                              })`,
                              transform: `scale( ${shapesData.ScaleX}, ${shapesData.ScaleY} )`,
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius:
                                  shapesData.ShapeType === "circle" ? "50%" : 0,
                                justifyContent: "center",
                                display: "flex",
                                borderWidth: shapesData.Width,
                                borderColor: shapesData.Color,
                                borderStyle:
                                  shapesData.ShapeWidth === 0 ||
                                  shapesData.ShapeHeight === 0
                                    ? "none"
                                    : "solid",
                              }}
                            />
                          </div>
                        );
                      }
                    }
                  })}
                {/* StudentShapes Replay */}
                {isReplayHappening &&
                  !isExpandableView &&
                  editorShapesReplayDataArray.length > 0 &&
                  editorShapesReplayDataArray.map((shapesData, index) => {
                    if (shapesData.ShapeType === "line") {
                      return (
                        <div
                          style={{
                            position: "absolute",
                            left: shapesData.ShapeLeft,
                            top: shapesData.ShapeTop,
                            transform: [
                              {
                                rotate:
                                  shapesData.ShapeRotation.toString().concat(
                                    "deg"
                                  ),
                              },
                              { scaleX: shapesData.ScaleX },
                              { scaleY: shapesData.ScaleY },
                            ],
                          }}
                        >
                          <svg
                            key={index.toString()}
                            height={shapesData.ShapeHeight + shapesData.Width}
                            width={shapesData.ShapeWidth + shapesData.Width}
                          >
                            <line
                              x1="0"
                              y1="0"
                              x2={shapesData.ShapeWidth}
                              y2={shapesData.ShapeHeight}
                              stroke={shapesData.Color}
                              strokeWidth={shapesData.Width}
                            />
                          </svg>
                        </div>
                      );
                    } else {
                      return (
                        <div
                          key={index.toString()}
                          style={{
                            width:
                              shapesData.ShapeType === "rect" ||
                              shapesData.ShapeType === "circle"
                                ? shapesData.ShapeWidth > 0
                                  ? shapesData.ShapeWidth + shapesData.Width * 2
                                  : 0
                                : shapesData.ShapeWidth,
                            height:
                              shapesData.ShapeType === "rect" ||
                              shapesData.ShapeType === "circle"
                                ? shapesData.ShapeHeight > 0
                                  ? shapesData.ShapeHeight +
                                    shapesData.Width * 2
                                  : 0
                                : shapesData.ShapeHeight,
                            top: shapesData.ShapeTop,
                            left: shapesData.ShapeLeft,
                            position: "absolute",
                            justifyContent: "center",
                            display: "flex",
                            transform: `rotate(${
                              shapesData.ShapeRotation + "deg"
                            })`,
                            transform: `scale( ${shapesData.ScaleX}, ${shapesData.ScaleY} )`,
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius:
                                shapesData.ShapeType === "circle" ? "50%" : 0,
                              justifyContent: "center",
                              display: "flex",
                              borderWidth: shapesData.Width,
                              borderColor: shapesData.Color,
                              borderStyle:
                                shapesData.ShapeWidth === 0 ||
                                shapesData.ShapeHeight === 0
                                  ? "none"
                                  : "solid",
                            }}
                          />
                        </div>
                      );
                    }
                  })}
              </div>
            </div>
          </div>
        </div>
      )}

      <input
        type="color"
        id="stroke-color"
        style={{
          opacity: "0",
          visibility: "hidden",
          position: "absolute",
          zIndex: 999,
          top: "9%",
          left: "75%",
        }}
        disabled={Completed === 1 || !isActive || IsReadonly ? true : false}
        defaultValue={
          contextRef.current ? contextRef.current.strokeStyle : "#000000"
        }
        onChange={(event) => {
          setStrokeColor(event.target.value);
        }}
      />
      {!loading &&
        FollowTheFlow &&
        Completed === 0 &&
        isActive &&
        !isVideoPlaying &&
        !isPopupSlideVisible &&
        !isRecordPlaying &&
        !isRecording &&
        !tutorialStart &&
        isBgAudioPlayed &&
        !displayActivityCompletePopup && (
          <SequenceAneme
            ttsMessageData={ttsMessageData}
            ttsPlayStart={ttsPlayStart}
            ttsPlayType={ttsPlayType}
            showCC={isSubtitle}
            skipUnskipComponent={skipUnskipComponent}
            priorityActive={priorityActive}
            isReplayHappening={isReplayHappening}
            smartPaperData={smartPaperData}
            onTtsPlaying={() => {
              setBotTalking(true);
            }}
            onTtsPlayStop={() => {
              setBotTalking(false);
              setTtsPlayStart(false);
              if (ttsPlayType === "hint") {
                if (readmoreUrl === "") {
                  setCurrentSequenceMessage();
                }
              } else if (ttsPlayType === "sequence") {
                if (sequenceTimer.current) {
                  clearTimeout(sequenceTimer.current);
                  checkAndMoveNextComponent();
                } else {
                  checkAndMoveNextComponent();
                }
              } else if (ttsPlayType === "feedback") {
                if (feedbackType === "success") {
                  // setIsPageNavigated(false);
                  setIsPageReopened(false);
                  setPriorityActive((priorityActive) => priorityActive + 1);
                } else {
                  if (failureExternalText !== "") {
                    setFailurePopupVisible(true);
                  }
                  setCurrentSequenceMessage();
                }
              }
            }}
            onSkipError={(status) => {
              if (status) {
                showOrHideToaster(
                  true,
                  "You are done with this activity. Press the button above to move to another activity.",
                  "warning"
                );
              } else {
                showOrHideToaster(
                  true,
                  "You cannot skip this section",
                  "warning"
                );
              }
            }}
            onSkipWhenNotPlaying={() => {
              if (sequenceTimer.current) {
                setIsDelayRunning(false);
                clearTimeout(sequenceTimer.current);
                setIsReplaySequence(false);
                setIsReplaySequenceTimerStart(false);
                setPriorityActive((priorityActive) => priorityActive + 1);
              }
            }}
            clearTtsPlay={() => {
              setTtsPlayStart(false);
              setBotTalking(false);
            }}
            hideAnimation={hideAnimation}
            isSmartPaper={true}
            onKnovoHelpSelected={() => {}}
            isDelayRunning={isDelayRunning}
            getTutorTalking={(tutorTalking) => {
              getTutorTalking(tutorTalking);
            }}
            currentOSName={currentOSName}
            knovoHelpClick={isKnovoHelpOpen}
            displayWlakthrough={displayWalkThrough}
            readmoreUrl={readmoreUrl}
            onReadmoreClick={(status) => {
              if (status) {
                setIsNeedClick(true);
                let popupExteValue = {
                  MarkerName: "Additional help",
                  MarkerValue: readmoreUrl,
                };
                currentPopupValue.current = popupExteValue;
                setExternalPopupVisible(true);
              }
            }}
            isHintDisplay={
              isPractice &&
              !isReplayHappening &&
              !botTalking &&
              !isRecording &&
              !isRecordPlaying &&
              !skipUnskipComponent[priorityActive] &&
              hintMessage !== ""
                ? true
                : false
            }
            onHintIconChange={() => {
              if (
                FollowTheFlow &&
                !isRecording &&
                !isRecordPlaying &&
                !isReplayHappening &&
                !botTalking
              ) {
                // knovoHelpClose();
                setShowHint(false);
                window.speechSynthesis.cancel();
                if (Completed === 0) {
                  if (isPractice && hintMessage && hintMessage !== "") {
                    setAudioStop(true);
                    setTtsPlayType("hint");
                    setTtsMessageData(hintMessage);
                    setTtsPlayStart(true);
                  }
                }
              }
            }}
            isAiChatBotVisible={isAiChatBotVisible}
            muteClicked={muteClicked}
            muteStatus={muteStatus}
          />
        )}
      {isKnovoHelpOpen && (
        <KnovoHelp
          onBotAnimeClose={() => {
            knovoHelpClose();
          }}
          onKnovoHelpSelected={(helpSelected, isShowAnswer) => {
            if (helpSelected === "tips") {
              if (
                FollowTheFlow &&
                !isRecording &&
                !isRecordPlaying &&
                !isReplayHappening &&
                !botTalking
              ) {
                knovoHelpClose();
                setShowHint(false);
                window.speechSynthesis.cancel();
                if (Completed === 0) {
                  if (isPractice && hintMessage && hintMessage !== "") {
                    setAudioStop(true);
                    setTtsPlayType("hint");
                    setTtsMessageData(hintMessage);
                    setTtsPlayStart(true);
                  }
                }
              }
            } else if (helpSelected === "instruction") {
              knovoHelpClose();
              // if (isRecording || isRecordPlaying) {
              //   showRecordingModal();
              // } else {
              //   if (!isVideoPlaying) {
              //     setAudioStop(true);
              //     setTutorialStart(true);
              //   }
              // }
            } else if (helpSelected === "walkthrough") {
              knovoHelpClose();
              knovoActivityTourClick();
            } else if (helpSelected === "alChatBot") {
              knovoHelpClose();
              setIsAiChatBotVisible(true);
            } else {
              if (isPractice || Completed === 1 || !isActive) {
                if (isShowAnswer) {
                  setcurrentDisplayMode("verify");
                } else {
                  setcurrentDisplayMode("normal");
                }
              }
            }
          }}
          onHelpNeeded={(helptype) => {
            if (helptype === "contained") {
              let selectedContained = ContainedView[0].ContentID;
              setSelectedContentID(selectedContained);
              containedActivityApiCall(selectedContained, token);
            } else {
              setIsNeedClick(true);
              let popupExteValue = {
                MarkerName: "PEMDAS TUTORIAL",
                MarkerValue: "https://youtu.be/x41BCrYh8Kc",
              };
              currentPopupValue.current = popupExteValue;
              setExternalPopupVisible(true);
            }
          }}
          isGuidedActivity={isGuidedActivity}
          guidedData={guidedData}
          onGuidedClick={(guideType) => {
            let isClickable = false;
            if (FollowTheFlow) {
              if (skipUnskipComponent[priorityActive]) {
                setIsGuidedClickEnable(true);
                isClickable = true;
                // setIsGuidedClickEnable(false);
              } else {
                let indexOfPaper = smartPaperData.ReplayRectangles.findIndex(
                  (obj) => obj.Priority === priorityActive
                );
                if (indexOfPaper < 0) {
                  setIsGuidedClickEnable(true);
                  isClickable = true;
                } else {
                  setIsGuidedClickEnable(false);
                }
              }
              if (isClickable) {
                if (guideType === "guided") {
                  setIsGuidedClicked(true);
                  if (
                    props.currentActivity.ContainedView &&
                    props.currentActivity.ContainedView.length > 0
                  ) {
                    const markerContent =
                      props.currentActivity.ContainedView.find(
                        ({ SlideID }) => {
                          return SlideID === guidedData.MarkerValue;
                        }
                      );
                    let selectedContained = markerContent.ContentID;
                    setSelectedContentID(selectedContained);
                    containedActivityApiCall(selectedContained, token);
                  }
                }
              } else {
                setIsGuidedClicked(false);
                showOrHideToaster(
                  true,
                  "Guided tutoring is not available for this component",
                  "warning"
                );
              }
            } else {
              if (guideType === "guided") {
                setIsGuidedClicked(true);
                if (
                  props.currentActivity.ContainedView &&
                  props.currentActivity.ContainedView.length > 0
                ) {
                  const markerContent =
                    props.currentActivity.ContainedView.find(({ SlideID }) => {
                      return SlideID === guidedData.MarkerValue;
                    });
                  let selectedContained = markerContent.ContentID;
                  setSelectedContentID(selectedContained);
                  containedActivityApiCall(selectedContained, token);
                }
              }
            }
          }}
          isContained={isContained}
          isPractice={isPractice}
        />
      )}
      <AnswerExplanation
        explanationVisible={explanationVisible}
        explanationStatus={explanationStatus}
        explanationText={explanationText}
        onExplanationClosed={() => {
          setExplanationVisible(false);
        }}
      />
      {isPopupSlideVisible && renderVideoPopupSlide()}
      {isExpandableView && renderPopupExpand()}
      {externalPopupVisible && renderExternalPopup()}
      {textPopupVisible && renderPopupText()}
      {failurePopupVisible && renderFailureExternalPopup()}
      <WarningPopup
        popupVisible={displayReplayDonePopup}
        onPopupCancel={() => {
          window.speechSynthesis.cancel();
          setIsDelayRunning(true);
          setIsReplaySequence(true);
          setDisplayReplayDonePopup(false);
        }}
        onPopupOk={() => {
          window.speechSynthesis.cancel();
          setPriorityActive((priorityActive) => priorityActive + 1);
          setIsReplaySequence(false);
          setIsDelayRunning(false);
          setDisplayReplayDonePopup(false);
        }}
        popupHeadingLabel="Warning"
        popupMessageLabel="Are you done with writing ?"
      />
      <SuccessPopup
        popupVisible={displayActivityCompletePopup}
        onPopupCancel={() => {
          window.speechSynthesis.cancel();
          setDisplayActivityCompletePopup(false);
        }}
        onPopupOk={() => {
          window.speechSynthesis.cancel();
          setDisplayActivityCompletePopup(false);
          if (isGuidedActivity && isGuidedClicked) {
            onGuidedCloseClick();
            setIsGuidedActivity(false);
          } else {
            onActivitySubmitClick();
          }
        }}
      />
      {displayAnimatedCommonComponents &&
        !isVideoPlaying &&
        !isPopupSlideVisible &&
        !displayWalkThrough &&
        renderPalletePop()}
      {displayWalkThrough && renderPalleteWakthroughPop()}
      {isImageLoaded && displayComponents && isAiChatBotVisible && (
        <AiAssistanceBot
          chatBotSettings={smartPaperData.ChatBotSettings}
          aiChatResponse={aiChatResponseData}
          isKnovoApiCall={isKnovoApiCall}
          onAiDialogClose={(aiDialogClose) => {
            if (aiDialogClose) {
              setIsAiChatBotVisible(false);
              setAiChatResponseData({});
            }
          }}
          onClarificationClick={(clarificationType, clarificationData) => {
            handleChatClarification(clarificationType, clarificationData);
          }}
        />
      )}
      {activityDataFromParent.OtherActivities &&
        activityDataFromParent.OtherActivities !== null &&
        activityDataFromParent.OtherActivities.length > 0 &&
        isBgAudioPlayed &&
        !isExpandableView &&
        !isVideoPlaying &&
        !loading &&
        displayComponents &&
        !isPageScrolled &&
        renderNextButton()}
      {activityDataFromParent.OtherActivities &&
        activityDataFromParent.OtherActivities !== null &&
        activityDataFromParent.OtherActivities.length > 0 &&
        isBgAudioPlayed &&
        !isExpandableView &&
        !isVideoPlaying &&
        !loading &&
        displayComponents &&
        !isPageScrolled &&
        renderPrevButton()}
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user.user,
  lessonUnitDetails: state.user.lessonUnitDetails,
  loading: state.user.loading,
  currentActivity: state.user.currentActivity,
  currentLessonUnitDistId: state.user.currentLessonUnitDistId,
  exerciseList: state.user.exerciseList,
  unitName: state.user.unitName,
  previousExerciseList: state.user.previousExerciseList,
  currentCourseId: state.user.currentCourseId,
  fromAnalytics: state.user.fromAnalytics,
  fromCourse: state.user.fromCourse,
  containedActivity: state.user.containedActivity,
  containedWorkJson: state.user.containedWorkJson,
  showToastModal: state.user.showToastModal,
  hardResetRandom: state.user.hardResetRandom,
  currentOSName: state.user.currentOSName,
  muteStatus: state.user.muteStatus,
  muteClicked: state.user.muteClicked,
  token: state.user.token,
});

const mapDispatchToProps = (dispatch) => ({
  setHeaderTitle: (headerTitle) =>
    dispatch(UserActions.setHeaderTitle(headerTitle)),
  setShowHideLoader: (status) =>
    dispatch(UserActions.setShowHideLoader(status)),
  saveActivityForStudent: (activity, successFn) =>
    dispatch(UserActions.saveActivityForStudent(activity, successFn)),
  setWorkJson: (WorkJson) => dispatch(UserActions.setWorkJson(WorkJson)),
  setContainedWorkJson: (containedWorkJson) =>
    dispatch(UserActions.setContainedWorkJson(containedWorkJson)),
  setExerciseList: (exerciseList, successFn) =>
    dispatch(UserActions.setExerciseList(exerciseList, successFn)),
  getContainedActivityForStudent: (studentID, contentID, token, successFn) =>
    dispatch(
      UserActions.getContainedActivityForStudent(
        studentID,
        contentID,
        token,
        successFn
      )
    ),
  showOrHideToaster: (showToastModal, toastMessageText, toastType) =>
    dispatch(
      UserActions.showOrHideToaster(showToastModal, toastMessageText, toastType)
    ),
  hardResetRandomActivity: (hardResetRandom) =>
    dispatch(UserActions.hardResetRandomActivity(hardResetRandom)),
  chatChallengeMe: (
    serviceTypeName,
    topic,
    keyword,
    question_type,
    num_of_options,
    content,
    successFn,
    failureFn
  ) =>
    dispatch(
      UserActions.chatChallengeMe(
        serviceTypeName,
        topic,
        keyword,
        question_type,
        num_of_options,
        content,
        successFn,
        failureFn
      )
    ),
  saveMuteStatus: (muteStatus, muteClicked) =>
    dispatch(UserActions.saveMuteStatus(muteStatus, muteClicked)),
  refreshToken: (tokenData, successFn) =>
    dispatch(UserActions.refreshToken(tokenData, successFn)),
  userToken: (token) => dispatch(UserActions.userToken(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SmartPaperScreen);
